var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _path0, _g5, _path1, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _g8, _path15, _path16, _path17, _g9, _path18, _path19, _path20, _path21, _path22, _path23, _g0, _path24, _path25, _path26, _path27, _g1, _path28, _path29, _path30, _path31, _g10, _path32, _path33, _path34, _path35, _g11, _path36, _path37, _path38, _path39, _g12, _path40, _path41, _path42, _path43, _g13, _path44, _path45, _path46, _path47, _g14, _path48, _path49, _path50, _path51, _g15, _path52, _path53, _path54, _path55, _g16, _path56, _path57, _path58, _path59, _g17, _path60, _path61, _g18, _path62, _path63, _path64, _g19, _path65, _path66, _path67, _path68, _g20, _path69, _path70, _path71, _path72, _g21, _path73, _path74, _path75, _path76, _g22, _path77, _path78, _path79, _path80, _g23, _path81, _path82, _path83, _path84, _g24, _path85, _path86, _path87, _path88, _g25, _path89, _path90, _path91, _path92, _g26, _path93, _path94, _path95, _path96, _g27, _path97, _path98, _path99, _path100, _g28, _path101, _path102, _path103, _path104, _g29, _path105, _path106, _path107, _path108, _g30, _path109, _path110, _path111, _path112, _g31, _path113, _path114, _g32, _path115, _path116, _path117, _g33, _path118, _path119, _path120, _path121, _g34, _path122, _path123, _path124, _path125, _g35, _path126, _path127, _path128, _path129, _g36, _path130, _path131, _path132, _path133, _g37, _path134, _path135, _path136, _path137, _g38, _path138, _path139, _path140, _path141, _g39, _path142, _path143, _path144, _path145, _g40, _path146, _path147, _path148, _path149, _g41, _path150, _path151, _path152, _path153, _g42, _path154, _path155, _path156, _path157, _g43, _path158, _path159, _path160, _path161, _g44, _path162, _path163, _path164, _path165, _g45, _path166, _path167, _g46, _path168, _path169, _path170, _g47, _path171, _path172, _path173, _path174, _g48, _path175, _path176, _path177, _path178, _g49, _path179, _path180, _path181, _path182, _g50, _path183, _path184, _g51, _path185, _path186, _path187, _g52, _path188, _path189, _path190, _path191, _g53, _path192, _path193, _path194, _path195, _g54, _path196, _path197, _path198, _path199, _g55, _path200, _path201, _g56, _path202, _path203, _path204, _g57, _path205, _path206, _path207, _path208, _g58, _path209, _path210, _g59, _path211, _path212, _path213, _g60, _path214, _path215, _path216, _path217, _g61, _path218, _path219, _path220, _path221, _g62, _path222, _path223, _path224, _path225, _g63, _path226, _path227, _path228, _path229, _g64, _path230, _path231, _path232, _path233, _g65, _path234, _path235, _path236, _path237, _g66, _path238, _path239, _path240, _path241, _g67, _path242, _path243, _path244, _path245, _g68, _path246, _path247, _path248, _path249, _g69, _path250, _path251, _path252, _path253, _g70, _path254, _path255, _path256, _path257, _g71, _path258, _path259, _path260, _path261, _g72, _path262, _path263, _path264, _path265, _g73, _path266, _path267, _path268, _path269, _g74, _path270, _path271, _path272, _path273, _g75, _path274, _path275, _path276, _path277, _g76, _path278, _path279, _g77, _path280, _path281, _path282, _g78, _path283, _path284, _path285, _path286, _g79, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _g80, _path301, _path302, _path303, _g81, _path304, _path305, _path306, _path307, _g82, _path308, _path309, _path310, _path311, _g83, _path312, _path313, _path314, _path315, _g84, _path316, _path317, _path318, _path319, _g85, _path320, _path321, _path322, _path323, _g86, _path324, _path325, _path326, _path327, _g87, _path328, _path329, _path330, _path331, _g88, _path332, _path333, _path334, _path335, _g89, _path336, _path337, _g90, _path338, _path339, _g91, _path340, _path341, _path342, _g92, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _g93, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _g94, _path1023, _g95, _path1024, _g96, _path1025, _path1026, _path1027, _g97, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _g98, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _g99, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquityleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 374,
    viewBox: "0 0 322 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.236 346.135C134.799 348.771 134.822 353.048 130.287 355.684L103.415 371.307C98.8772 373.944 91.504 373.944 86.9402 371.307L59.8903 355.684C55.3265 353.048 55.3006 348.775 59.8385 346.138L86.7107 330.512C91.2486 327.875 98.6218 327.872 103.189 330.512L130.239 346.135H130.236Z",
    fill: "#838383"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 338,
    width: 4,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.483 338.479L136.472 342.441C136.465 344.159 135.34 345.873 133.085 347.18L133.097 343.218C135.351 341.907 136.476 340.193 136.483 338.479Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.483 338.479L136.472 342.441C136.465 344.159 135.34 345.873 133.085 347.18L133.097 343.218C135.351 341.907 136.476 340.193 136.483 338.479Z",
    fill: "#9D6E25"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 338,
    width: 4,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2427 342.372L59.2538 338.41C59.2464 340.151 60.3975 341.891 62.6924 343.217L62.6813 347.179C60.3827 345.853 59.2353 344.109 59.2427 342.372Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6924 343.219L62.6813 347.181C60.3827 345.855 59.2353 344.111 59.2427 342.374L59.2538 338.412C59.2464 340.152 60.3975 341.893 62.6924 343.219Z",
    fill: "#9D6E25"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.096 343.221L133.085 347.179L106.209 362.805L106.221 358.843L133.096 343.221Z",
    fill: "#7E591E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7423 358.843L89.7349 362.805L62.6851 347.179L62.6925 343.221L89.7423 358.843Z",
    fill: "#966923"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 358,
    width: 18,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.22 358.842L106.209 362.804C101.675 365.44 94.2977 365.44 89.7339 362.804L89.7413 358.842C94.3088 361.478 101.686 361.478 106.22 358.842Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.22 358.842L106.209 362.804C101.675 365.44 94.2977 365.44 89.7339 362.804L89.7413 358.842C94.3088 361.478 101.686 361.478 106.22 358.842Z",
    fill: "#9D6E25"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.04 333.67C137.604 336.307 137.63 340.584 133.096 343.22L106.224 358.843C101.689 361.479 94.3088 361.479 89.7449 358.843L62.6951 343.22C58.1312 340.584 58.109 336.307 62.6432 333.674L89.5154 318.048C94.0497 315.411 101.43 315.411 105.994 318.048L133.044 333.67H133.04Z",
    fill: "#F0A838"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315.452 237.145L157.032 329.251L36.5735 259.692L194.99 167.541L315.452 237.145Z",
    fill: "#838383"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 320,
    y: 204,
    width: 2,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.619 204.791L321.575 208.827C321.575 209.56 321.075 210.327 320.079 210.919V206.879C321.075 206.291 321.619 205.565 321.619 204.791Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.619 204.791L321.574 208.827V208.875L321.619 204.839V204.791Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.619 204.84L321.575 208.876C321.575 208.965 321.575 209.061 321.527 209.15V205.11C321.575 205.021 321.575 204.932 321.615 204.844L321.619 204.84Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.53 205.111V209.151C321.53 209.24 321.53 209.377 321.442 209.466L321.482 205.43C321.53 205.341 321.53 205.245 321.53 205.111Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.478 205.43L321.438 209.466C321.438 209.562 321.349 209.647 321.349 209.736V205.704C321.39 205.607 321.438 205.519 321.478 205.43Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35 205.705V209.738C321.254 209.826 321.165 209.963 321.12 210.06V206.02C321.213 205.931 321.257 205.835 321.35 205.705Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.12 206.02V210.059C321.031 210.196 320.894 210.285 320.805 210.422V206.379C320.942 206.242 321.031 206.153 321.12 206.02Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.805 206.381V210.424C320.62 210.561 320.394 210.739 320.172 210.876V206.836C320.398 206.707 320.624 206.57 320.805 206.385V206.381Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.168 206.832V210.872C320.12 210.92 320.079 210.92 320.079 210.92V206.88C320.106 206.88 320.136 206.864 320.168 206.832Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 235,
    width: 3,
    height: 7
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.512 239.099V235.062C42.512 235.829 43.0524 236.603 44.048 237.188V241.232C43.0524 240.643 42.512 239.873 42.512 239.099Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.051 237.188V241.232C43.0553 240.643 42.5149 239.873 42.5149 239.099V235.062C42.5149 235.829 43.0553 236.603 44.051 237.188Z",
    fill: "#858585"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M320.079 206.881V210.921L160.027 303.975V299.939L320.079 206.881Z",
    fill: "#B3B3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.722 299.939V303.975L44.052 241.229V237.186L152.722 299.939Z",
    fill: "#898989"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 299,
    width: 9,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.027 299.939V303.976C157.983 305.157 154.715 305.157 152.72 303.976V299.939C154.715 301.117 158.028 301.117 160.027 299.939Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.027 299.939V303.976C159.704 304.157 159.301 304.339 158.886 304.476V300.439C159.301 300.302 159.704 300.165 160.027 299.939Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.887 300.443V304.48C158.572 304.568 158.258 304.665 157.887 304.702V300.669C158.258 300.621 158.62 300.532 158.887 300.443Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.888 300.666V304.698C157.71 304.747 157.436 304.795 157.259 304.795V300.803C157.484 300.755 157.71 300.714 157.888 300.666Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.258 300.803V304.794C157.077 304.839 156.899 304.839 156.666 304.839L156.714 300.803H157.258Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.714 300.803L156.665 304.839H156.166V300.803H156.714Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.167 300.803V304.839H155.627V300.803H156.167Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.625 300.802V304.838C155.44 304.794 155.311 304.794 155.126 304.75L155.166 300.758C155.311 300.758 155.488 300.806 155.625 300.806V300.802Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.166 300.759L155.125 304.751C154.988 304.751 154.811 304.702 154.626 304.662V300.67C154.811 300.67 154.985 300.714 155.166 300.759Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.626 300.666V304.658C154.441 304.658 154.263 304.61 154.086 304.562V300.525C154.263 300.574 154.441 300.614 154.626 300.662V300.666Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.086 300.533V304.569C153.901 304.48 153.627 304.439 153.446 304.343V300.311C153.672 300.399 153.905 300.448 154.086 300.536V300.533Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.446 300.304V304.337C153.176 304.248 152.946 304.111 152.72 303.974V299.938C152.946 300.075 153.172 300.212 153.446 300.3V300.304Z",
    fill: "#858585"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M320.081 202.659C322.076 203.841 322.076 205.703 320.081 206.881L160.028 299.939C158.03 301.116 154.717 301.116 152.722 299.939L44.0522 237.185C42.0571 236.012 42.0571 234.101 44.0522 232.968L204.112 139.913C206.152 138.732 209.416 138.732 211.411 139.913L320.081 202.663V202.659Z",
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 0,
    width: 6,
    height: 2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.282 0.52839L170.458 1.11716C169.773 0.980147 169.092 1.11715 168.415 1.48004L165.242 0.935711C165.92 0.528389 166.597 0.395085 167.282 0.52839Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.415 1.48144L165.243 0.937105C165.468 0.759365 165.742 0.670495 165.968 0.574219L169.188 1.20742C168.914 1.25556 168.689 1.39257 168.415 1.48144Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.188 1.2084L165.968 0.575199C166.242 0.530764 166.468 0.486328 166.694 0.486328L169.866 1.07509C169.64 1.07509 169.414 1.12323 169.188 1.2121V1.2084Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.866 1.06923L166.694 0.480469C166.871 0.480469 167.053 0.480469 167.241 0.528607L170.414 1.11737C170.236 1.06923 170.051 1.06923 169.866 1.06923Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41 1.11806L167.238 0.529297C167.278 0.529297 170.458 1.11806 170.458 1.11806H170.41Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 230,
    width: 7,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6045 233.926L38.4324 233.333C37.1628 233.107 36.1635 232.067 35.76 230.475L38.9321 231.023C39.3356 232.656 40.3794 233.696 41.6045 233.926Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6045 233.926L38.4324 233.333C37.1628 233.107 36.1635 232.067 35.76 230.475L38.9321 231.023C39.3356 232.656 40.3794 233.696 41.6045 233.926Z",
    fill: "#858585"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95144 94.1806L4.77563 93.5845L165.243 0.933594L168.415 1.48163L7.95144 94.1806Z",
    fill: "#B0B0B0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9311 231.022L35.759 230.474L2.37231 100.213L5.59254 100.761L38.9311 231.022Z",
    fill: "#888888"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 93,
    width: 6,
    height: 8
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59355 100.76L2.37333 100.212C1.73669 97.6683 2.77679 94.7652 4.77184 93.584L7.94765 94.1765C6.00071 95.3095 4.9125 98.2608 5.58985 100.757L5.59355 100.76Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59472 100.763L2.3745 100.215C2.27826 99.8036 2.23755 99.4 2.23755 99.0371L5.41706 99.5777C5.41706 99.9888 5.45777 100.396 5.59472 100.763Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41634 99.5748L2.23684 99.0342C2.19612 98.712 2.19612 98.401 2.23684 98.127L5.41634 98.7157C5.36823 99.0379 5.36823 99.3045 5.41634 99.5785V99.5748Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41706 98.713L2.23755 98.1242C2.23755 97.8502 2.28197 97.6243 2.32638 97.3984L5.50589 97.9391C5.45777 98.2094 5.41706 98.4871 5.41706 98.7093V98.713Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50495 97.9439L2.32544 97.4033C2.37356 97.1293 2.42168 96.9034 2.51051 96.6738L5.68261 97.2219C5.59378 97.4959 5.54566 97.7218 5.50495 97.9476V97.9439Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68309 97.2172L2.51099 96.6691C2.59982 96.4025 2.69606 96.1692 2.77749 95.9434L5.95699 96.5358C5.86816 96.7617 5.77192 97.0357 5.68309 97.2135V97.2172Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95612 96.5399L2.77661 95.9475C2.87285 95.6734 3.05052 95.4068 3.23559 95.1328L6.41139 95.7697C6.22632 95.9956 6.08937 96.2215 5.95612 96.5436V96.5399Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41628 95.765L3.24048 95.1281C3.60322 94.4912 4.15102 93.9469 4.78026 93.584L7.95607 94.1765C7.32313 94.5393 6.77532 95.08 6.41628 95.765Z",
    fill: "#A3A3A3"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.414 1.48005C170.361 0.395097 172.497 1.48005 173.13 3.97953L206.513 134.241C207.142 136.785 206.054 139.692 204.059 140.866L43.6435 233.516C41.6929 234.65 39.5609 233.516 38.9279 231.021L5.59306 100.759C4.9157 98.2634 6.00021 95.3159 7.95085 94.1791L168.414 1.48005Z",
    fill: "#E7E7E7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0563 232.018C41.5159 232.018 41.0162 231.47 40.7904 230.567L7.41114 100.301C7.00029 98.624 7.67764 96.58 8.95093 95.8542L169.366 3.20704C169.592 3.07003 169.773 3.0293 169.958 3.0293C170.499 3.0293 171.043 3.56992 171.232 4.47714L204.611 134.739C205.062 136.42 204.337 138.456 203.153 139.141L42.6966 231.84C42.4709 231.974 42.2377 232.018 42.0526 232.018H42.0563Z",
    fill: "#171C2B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3079 99.261C11.3079 99.1647 11.356 99.0759 11.4448 99.0351L167.826 8.69488C167.962 8.60601 168.236 8.69488 168.236 8.88003L200.705 135.694V135.783C200.753 135.872 200.705 135.961 200.616 136.009L44.2356 226.349C44.0505 226.438 43.8728 226.349 43.784 226.164L11.3079 99.3017V99.261Z",
    fill: "#515E7A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222.477 148.215V149.304L213.905 154.299V153.21L222.477 148.215Z",
    fill: "#808080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.043 153.208V154.297L209.593 152.256V151.164L213.043 153.208Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 153,
    width: 1,
    height: 2
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M213.905 153.209V154.298H213.042V153.209H213.905Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.905 153.209V154.298H213.042V153.209H213.905Z",
    fill: "#CCCCCC"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.478 147.718V148.218L213.905 153.209H213.043L209.593 151.165V150.665L218.125 145.674C218.487 145.674 218.669 145.718 218.946 145.674L222.481 147.718H222.478Z",
    fill: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211.048 154.84V155.929L202.613 160.824V159.739L211.048 154.84Z",
    fill: "#808080"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.798 159.74V160.825L198.259 158.833V157.74L201.798 159.74Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 159,
    width: 2,
    height: 2
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M202.611 159.74V160.829H201.797V159.74H202.611Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.611 159.74V160.829H201.797V159.74H202.611Z",
    fill: "#CCCCCC"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.047 154.386V154.842L202.612 159.741H201.798L198.259 157.745V157.245L206.691 152.391H207.513L211.047 154.39V154.386Z",
    fill: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.755 161.42L199.707 162.505L191.367 167.363V166.274L199.755 161.42Z",
    fill: "#808080"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 166.277V167.366L187.006 165.366V164.277L190.5 166.277Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 190,
    y: 166,
    width: 2,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.367 166.275V167.36H190.501V166.275H191.367Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.367 166.275V167.36H190.501V166.275H191.367Z",
    fill: "#CCCCCC"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M199.706 160.921C199.706 161.099 199.706 161.236 199.754 161.421L191.367 166.276H190.5L187.01 164.276V163.817L195.442 158.922H196.264L199.71 160.918L199.706 160.921Z",
    fill: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M188.461 167.998V169.087L180.022 173.941L180.066 172.853L188.461 167.998Z",
    fill: "#808080"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M179.208 172.851V173.94L175.762 171.944V170.855L179.208 172.851Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 172,
    width: 2,
    height: 2
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.067 172.852L180.023 173.94H179.208V172.852H180.071H180.067Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.067 172.852L180.023 173.94H179.208V172.852H180.071H180.067Z",
    fill: "#CCCCCC"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M188.461 167.497V167.997L180.066 172.852H179.204L175.758 170.852V170.356L184.105 165.453H184.967L188.461 167.497Z",
    fill: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M177.213 174.531V175.624L168.778 180.519V179.434L177.213 174.531Z",
    fill: "#808080"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M167.963 179.435V180.52L164.424 178.483V177.391L167.963 179.435Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 179,
    width: 2,
    height: 2
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M168.777 179.432V180.517H167.966V179.432H168.777Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.777 179.432V180.517H167.966V179.432H168.777Z",
    fill: "#CCCCCC"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M177.213 174.031V174.531L168.777 179.434H167.967L164.428 177.39V176.89L172.86 172.035H173.681L177.216 174.031H177.213Z",
    fill: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M165.92 181.064L165.872 182.153L157.532 187.056V185.963L165.92 181.064Z",
    fill: "#808080"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.662 185.966V187.059L153.171 185.063V183.967L156.662 185.966Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 185,
    width: 2,
    height: 3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M157.532 185.965V187.057H156.666V185.965H157.532Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.532 185.965V187.057H156.666V185.965H157.532Z",
    fill: "#CCCCCC"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M165.871 180.615C165.871 180.793 165.871 180.882 165.919 181.067L157.532 185.966H156.665L153.175 183.966V183.466L161.614 178.619H162.429L165.875 180.615H165.871Z",
    fill: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M154.626 187.646V188.731L146.19 193.634L146.231 192.549L154.626 187.646Z",
    fill: "#808080"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M145.381 192.548V193.633L141.928 191.593V190.504L145.381 192.548Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 192,
    width: 2,
    height: 2
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M146.232 192.547L146.191 193.632H145.377V192.547H146.232Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.232 192.547L146.191 193.632H145.377V192.547H146.232Z",
    fill: "#CCCCCC"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.627 187.144V187.644L146.232 192.547H145.377L141.924 190.503V190.051L150.27 185.148H151.133L154.627 187.144Z",
    fill: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M143.382 194.223V195.271L134.95 200.166V199.077L143.382 194.223Z",
    fill: "#808080"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M134.128 199.076V200.165L130.586 198.169V197.084L134.128 199.076Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 199,
    width: 1,
    height: 2
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.95 199.074V200.163H134.128V199.074H134.95Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.95 199.074V200.163H134.128V199.074H134.95Z",
    fill: "#CCCCCC"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.381 193.722V194.222L134.949 199.076H134.128L130.589 197.08V196.58L139.025 191.678H139.846L143.385 193.722H143.381Z",
    fill: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M132.085 200.754L132.037 201.85L123.698 206.745V205.657L132.085 200.754Z",
    fill: "#808080"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M122.835 205.657V206.746L119.341 204.706V203.613L122.835 205.657Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 205,
    width: 2,
    height: 2
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M123.698 205.658V206.747H122.835V205.658H123.698Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.698 205.658V206.747H122.835V205.658H123.698Z",
    fill: "#CCCCCC"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M132.037 200.262C132.037 200.439 132.037 200.576 132.085 200.754L123.698 205.657H122.835L119.341 203.613V203.161L127.777 198.266H128.591L132.037 200.262Z",
    fill: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M120.793 207.334V208.378L112.358 213.281L112.398 212.196L120.793 207.334Z",
    fill: "#808080"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M111.543 212.197V213.282L108.097 211.286V210.197L111.543 212.197Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 212,
    width: 2,
    height: 2
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M112.397 212.195L112.357 213.284H111.542V212.195H112.397Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.397 212.195L112.357 213.284H111.542V212.195H112.397Z",
    fill: "#CCCCCC"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M120.793 206.835V207.335L112.398 212.197H111.543L108.097 210.197V209.698L116.436 204.795H117.299L120.793 206.835Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 216,
    width: 1,
    height: 2
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7512 216.729V217.773V216.273C96.7512 216.451 96.7956 216.54 96.7512 216.725V216.729Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.7512 216.729V217.773V216.273C96.7512 216.451 96.7956 216.54 96.7512 216.725V216.729Z",
    fill: "#808080"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M109.548 213.869V214.958L101.113 219.86V218.764L109.548 213.869Z",
    fill: "#808080"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M100.293 218.767V219.863L96.7512 217.815V216.73L100.293 218.767Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 218,
    width: 2,
    height: 2
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M101.111 218.766V219.862H100.29V218.766H101.111Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.111 218.766V219.862H100.29V218.766H101.111Z",
    fill: "#CCCCCC"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M109.547 213.371V213.871L101.115 218.766H100.294L96.7551 216.729C96.7995 216.544 96.7551 216.455 96.7551 216.278L105.194 211.375H106.009L109.547 213.371Z",
    fill: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2507 220.445V221.493L89.8596 226.392V225.304L98.2507 220.445Z",
    fill: "#808080"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0012 225.304V226.393L85.5071 224.393V223.305L89.0012 225.304Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 225,
    width: 2,
    height: 2
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8607 225.303V226.391H88.9983V225.303H89.8607Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8607 225.303V226.391H88.9983V225.303H89.8607Z",
    fill: "#CCCCCC"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2066 219.951C98.251 220.136 98.251 220.225 98.251 220.451L89.8636 225.305H89.0012L85.5071 223.309V222.813L93.9426 217.918H94.7569L98.2066 219.955V219.951Z",
    fill: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9619 226.979V228.071L78.5227 232.97V231.885L86.9619 226.979Z",
    fill: "#808080"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7082 231.884V232.969L74.2141 230.973V229.885L77.7082 231.884Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 231,
    width: 2,
    height: 2
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5226 231.887V232.972H77.7083V231.887H78.5226Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5226 231.887V232.972H77.7083V231.887H78.5226Z",
    fill: "#CCCCCC"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9625 226.482V226.982L78.5196 231.885H77.7053L74.2112 229.885V229.386L82.5986 224.49H83.4647L86.9588 226.482H86.9625Z",
    fill: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4389 233.693V234.786L62.0139 242.543V241.503L75.4389 233.693Z",
    fill: "#808080"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M61.196 241.455V242.543L57.7092 240.544V239.455L61.196 241.455Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 241,
    width: 2,
    height: 2
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0138 241.505V242.546H61.1958V241.457C61.5141 241.457 61.6955 241.457 62.0138 241.505Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0138 241.505V242.546H61.1958V241.457C61.5141 241.457 61.6955 241.457 62.0138 241.505Z",
    fill: "#CCCCCC"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M75.439 233.194V233.693L62.014 241.503C61.6956 241.455 61.5143 241.455 61.196 241.455L57.7092 239.459V238.959L71.0861 231.205H71.9004L75.4427 233.197L75.439 233.194Z",
    fill: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M232.997 154.568V155.657L219.757 163.37V162.285L232.997 154.568Z",
    fill: "#808080"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M218.894 162.285V163.37L210.596 158.56V157.516L218.894 162.285Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 162,
    width: 2,
    height: 2
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M219.756 162.287V163.376H218.894V162.287H219.756Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.756 162.287V163.376H218.894V162.287H219.756Z",
    fill: "#CCCCCC"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M232.997 154.107V154.566L219.757 162.28H218.894L210.596 157.514V157.014L223.84 149.301H224.661L233.001 154.107H232.997Z",
    fill: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M216.126 164.371V165.46L207.868 170.274V169.177L216.126 164.371Z",
    fill: "#808080"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M207.054 169.177V170.274L198.707 165.46V164.371L207.054 169.177Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 207,
    y: 169,
    width: 1,
    height: 2
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M207.868 169.176V170.272H207.054V169.176H207.868Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.868 169.176V170.272H207.054V169.176H207.868Z",
    fill: "#CCCCCC"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M216.126 163.917V164.369L207.868 169.175H207.054L198.707 164.369V163.917L206.965 159.104H207.828L216.126 163.917Z",
    fill: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M204.878 170.945V172.034L196.627 176.848V175.755L204.878 170.945Z",
    fill: "#808080"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.764 175.755V176.848L187.465 172.034V170.945L195.764 175.755Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 175,
    width: 2,
    height: 2
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M196.626 175.756V176.852H195.764V175.756H196.626Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.626 175.756V176.852H195.764V175.756H196.626Z",
    fill: "#CCCCCC"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M204.877 170.447V170.947L196.626 175.757H195.764L187.465 170.947V170.447L195.716 165.641H196.537L204.877 170.447Z",
    fill: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M193.591 177.523L193.54 178.616L185.285 183.422V182.337L193.591 177.523Z",
    fill: "#808080"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M184.472 182.337V183.422L176.173 178.616V177.523L184.472 182.337Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 182,
    width: 2,
    height: 2
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M185.285 182.34V183.425H184.475V182.34H185.285Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.285 182.34V183.425H184.475V182.34H185.285Z",
    fill: "#CCCCCC"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M193.54 177.027C193.54 177.208 193.54 177.345 193.588 177.527L185.282 182.341H184.472L176.173 177.527V177.027L184.424 172.217H185.286L193.544 177.027H193.54Z",
    fill: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.292 184.061V185.149L174.041 189.956V188.867L182.292 184.061Z",
    fill: "#808080"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M173.226 188.867V189.956L164.872 185.149V184.061L173.226 188.867Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 188,
    width: 2,
    height: 2
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M174.041 188.867V189.956H173.227V188.867H174.041Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.041 188.867V189.956H173.227V188.867H174.041Z",
    fill: "#CCCCCC"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M182.291 183.605V184.064L174.041 188.871H173.226L164.872 184.064V183.605L173.13 178.795H173.948L182.287 183.605H182.291Z",
    fill: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M171.046 190.643V191.728L162.788 196.538V195.449L171.046 190.643Z",
    fill: "#808080"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M161.929 195.449V196.538L153.627 191.728V190.643L161.929 195.449Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 195,
    width: 2,
    height: 2
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M162.788 195.447V196.536H161.926V195.447H162.788Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.788 195.447V196.536H161.926V195.447H162.788Z",
    fill: "#CCCCCC"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M171.046 190.142V190.642L162.792 195.449H161.93L153.631 190.642V190.142L161.882 185.336H162.703L171.046 190.142Z",
    fill: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M159.752 197.174L159.704 198.266L151.447 203.073V201.984L159.752 197.174Z",
    fill: "#808080"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M150.637 201.984V203.073L142.338 198.266V197.174L150.637 201.984Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 201,
    width: 2,
    height: 3
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M151.446 201.984V203.073H150.632V201.984H151.446Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.446 201.984V203.073H150.632V201.984H151.446Z",
    fill: "#CCCCCC"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M159.705 196.718C159.705 196.896 159.753 196.993 159.753 197.17L151.447 201.984H150.633L142.334 197.17V196.718L150.589 191.912H151.444L159.701 196.718H159.705Z",
    fill: "#CCCCCC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M148.457 203.75V204.842L140.206 209.649V208.564L148.457 203.75Z",
    fill: "#808080"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M139.388 208.564V209.649L131.045 204.842V203.75L139.388 208.564Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 208,
    width: 2,
    height: 2
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M140.206 208.562V209.647H139.392V208.562H140.206Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.206 208.562V209.647H139.392V208.562H140.206Z",
    fill: "#CCCCCC"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M148.457 203.252V203.752L140.206 208.565H139.392L131.049 203.752V203.252L139.3 198.445H140.166L148.46 203.252H148.457Z",
    fill: "#CCCCCC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M137.212 210.285V211.374L128.961 216.18V215.095L137.212 210.285Z",
    fill: "#808080"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M128.094 215.095V216.18L119.792 211.374V210.285L128.094 215.095Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 215,
    width: 1,
    height: 2
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M128.961 215.096V216.181H128.095V215.096H128.961Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.961 215.096V216.181H128.095V215.096H128.961Z",
    fill: "#CCCCCC"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M137.211 209.826V210.285L128.961 215.095H128.095L119.796 210.285V209.826L128.054 205.02H128.868L137.215 209.826H137.211Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 216,
    width: 1,
    height: 2
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M125.871 217.498L125.919 216.413V216.365L125.871 217.454V217.498Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.919 216.365L125.871 217.454V217.498L125.919 216.413V216.365Z",
    fill: "#595959"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M125.918 216.865V217.954L117.619 222.76V221.672L125.918 216.865Z",
    fill: "#808080"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M116.802 221.672V222.76L108.503 217.954V216.865L116.802 221.672Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 221,
    width: 2,
    height: 2
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M117.619 221.67V222.759H116.801V221.67H117.619Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.619 221.67V222.759H116.801V221.67H117.619Z",
    fill: "#CCCCCC"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M125.918 216.365V216.865L117.62 221.675H116.802L108.503 216.865V216.365L116.757 211.559H117.62L125.918 216.365Z",
    fill: "#CCCCCC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M114.626 223.395V224.491L106.368 229.297V228.212L114.626 223.395Z",
    fill: "#808080"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M105.554 228.212V229.297L97.2112 224.491V223.395L105.554 228.212Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 228,
    width: 2,
    height: 2
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M106.368 228.211V229.296H105.554V228.211H106.368Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.368 228.211V229.296H105.554V228.211H106.368Z",
    fill: "#CCCCCC"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M114.626 222.945V223.397L106.368 228.21H105.554L97.2112 223.397V222.945L105.462 218.135H106.328L114.626 222.945Z",
    fill: "#CCCCCC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M103.374 229.973V231.069L95.1272 235.875V234.786L103.374 229.973Z",
    fill: "#808080"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2572 234.786V235.875L85.9661 231.069V229.973L94.2572 234.786Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 234,
    width: 2,
    height: 2
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1271 234.789V235.878H94.261V234.789H95.1271Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.1271 234.789V235.878H94.261V234.789H95.1271Z",
    fill: "#CCCCCC"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M103.374 229.474V229.974L95.1231 234.788H94.257L85.9622 229.974V229.474L94.2126 224.668H95.0269L103.37 229.474H103.374Z",
    fill: "#CCCCCC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M92.084 236.508V237.6L83.7854 242.407L83.8261 241.318L92.084 236.508Z",
    fill: "#808080"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9714 241.318V242.407L74.6692 237.6V236.508L82.9714 241.318Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 241,
    width: 2,
    height: 2
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8267 241.318L83.7823 242.407H82.968V241.318H83.823H83.8267Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8267 241.318L83.7823 242.407H82.968V241.318H83.823H83.8267Z",
    fill: "#CCCCCC"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0843 236.058V236.51L83.8265 241.316H82.9714L74.6692 236.51V236.058L82.9233 231.244H83.7858L92.0843 236.058Z",
    fill: "#CCCCCC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7907 243.088V244.177L72.5403 248.987V247.898L80.7907 243.088Z",
    fill: "#808080"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7192 247.898V248.987L63.3762 244.177V243.088L71.7192 247.898Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 247,
    width: 2,
    height: 2
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5407 247.898V248.991H71.719V247.898H72.5407Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5407 247.898V248.991H71.719V247.898H72.5407Z",
    fill: "#CCCCCC"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7913 242.589V243.086L72.5409 247.896H71.7192L63.3762 243.086V242.589L71.6304 237.779H72.4928L80.7913 242.589Z",
    fill: "#CCCCCC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M244.339 160.822V161.915L236.036 166.725L236.088 165.636L244.339 160.822Z",
    fill: "#808080"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M235.218 165.636V166.725L226.919 161.915V160.822L235.218 165.636Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: 165,
    width: 2,
    height: 2
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M236.088 165.639L236.04 166.724H235.222V165.639H236.088Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.088 165.639L236.04 166.724H235.222V165.639H236.088Z",
    fill: "#CCCCCC"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M244.337 160.326V160.826L236.087 165.639H235.221L226.922 160.826V160.326L235.18 155.516H235.994L244.341 160.326H244.337Z",
    fill: "#CCCCCC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M233.046 167.365V168.45L224.747 173.26V172.172L233.046 167.365Z",
    fill: "#808080"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M223.925 172.172V173.26L215.626 168.45V167.365L223.925 172.172Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 172,
    width: 2,
    height: 2
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M224.747 172.172V173.257H223.925V172.172H224.747Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.747 172.172V173.257H223.925V172.172H224.747Z",
    fill: "#CCCCCC"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M233.045 166.911V167.363L224.746 172.173H223.925L215.626 167.363V166.911L223.884 162.098H224.746L233.045 166.911Z",
    fill: "#CCCCCC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M254.905 167.453V168.538L238.622 177.981V176.888L254.905 167.453Z",
    fill: "#808080"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M237.809 176.89V177.983L229.462 173.173V172.084L237.809 176.89Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 176,
    width: 2,
    height: 2
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M238.622 176.889V177.981H237.808V176.889H238.622Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.622 176.889V177.981H237.808V176.889H238.622Z",
    fill: "#CCCCCC"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M254.906 166.953V167.453L238.623 176.888H237.809L229.462 172.081V171.63L245.745 162.146H246.607L254.906 166.953Z",
    fill: "#CCCCCC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M221.752 173.9V174.989L213.494 179.795V178.707L221.752 173.9Z",
    fill: "#808080"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M212.684 178.707V179.795L204.337 174.989V173.9L212.684 178.707Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 178,
    width: 2,
    height: 2
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M213.494 178.707V179.796H212.68V178.707H213.494Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.494 178.707V179.796H212.68V178.707H213.494Z",
    fill: "#CCCCCC"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M221.752 173.443V173.899L213.494 178.705H212.68L204.333 173.899V173.443L212.591 168.637H213.454L221.752 173.443Z",
    fill: "#CCCCCC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M235.218 178.885V179.973L226.968 184.787V183.699L235.218 178.885Z",
    fill: "#808080"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M226.105 183.699V184.787L217.807 179.973V178.885L226.105 183.699Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 183,
    width: 1,
    height: 2
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M226.968 183.697V184.786H226.11V183.697H226.968Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.968 183.697V184.786H226.11V183.697H226.968Z",
    fill: "#CCCCCC"
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M235.218 178.389V178.889L226.967 183.703H226.108L217.81 178.889V178.389L226.06 173.627H226.923L235.221 178.389H235.218Z",
    fill: "#CCCCCC"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M265.928 174.076L265.88 175.165L244.656 187.555V186.462L265.928 174.076Z",
    fill: "#808080"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M243.797 186.466V187.559L235.539 182.745V181.656L243.797 186.466Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 243,
    y: 186,
    width: 2,
    height: 2
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M244.657 186.465V187.557H243.794V186.465H244.657Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.657 186.465V187.557H243.794V186.465H244.657Z",
    fill: "#CCCCCC"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M265.88 173.626C265.928 173.804 265.88 173.9 265.928 174.078L244.656 186.464H243.793L235.535 181.654V181.154L256.759 168.812H257.581L265.88 173.626Z",
    fill: "#CCCCCC"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M276.989 180.701V181.79L253.319 195.535V194.45L276.989 180.701Z",
    fill: "#808080"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M252.503 194.451V195.536L244.16 190.729V189.641L252.503 194.451Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 194,
    width: 2,
    height: 2
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M253.317 194.451V195.536H252.503V194.451H253.317Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.317 194.451V195.536H252.503V194.451H253.317Z",
    fill: "#CCCCCC"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M276.988 180.206V180.706L253.318 194.452H252.503L244.16 189.641V189.186L267.831 175.393H268.693L276.992 180.206H276.988Z",
    fill: "#CCCCCC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M210.503 180.475V181.567L202.249 186.373V185.288L210.503 180.475Z",
    fill: "#808080"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M201.391 185.288V186.373L193.092 181.567V180.475L201.391 185.288Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 185,
    width: 2,
    height: 2
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M202.249 185.287V186.376H201.387V185.287H202.249Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.249 185.287V186.376H201.387V185.287H202.249Z",
    fill: "#CCCCCC"
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M210.503 179.972V180.472L202.253 185.286H201.39L193.092 180.472V179.972L201.342 175.166H202.157L210.503 179.972Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 184,
    width: 1,
    height: 3
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M206.558 185.376V186.465V184.965C206.558 185.102 206.606 185.239 206.558 185.376Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.558 185.376V186.465V184.965C206.558 185.102 206.606 185.239 206.558 185.376Z",
    fill: "#808080"
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M223.973 185.424V186.509L215.715 191.319V190.23L223.973 185.424Z",
    fill: "#808080"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M214.853 190.23V191.319L206.558 186.509V185.424L214.853 190.23Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 190,
    width: 2,
    height: 2
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M215.715 190.23V191.319H214.853V190.23H215.715Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.715 190.23V191.319H214.853V190.23H215.715Z",
    fill: "#CCCCCC"
  }))), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M223.973 184.924V185.424L215.715 190.23H214.853L206.554 185.424C206.602 185.239 206.554 185.15 206.554 184.965L214.853 180.158H215.674L223.973 184.924Z",
    fill: "#CCCCCC"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M241.069 188.559V189.644L232.819 194.454V193.365L241.069 188.559Z",
    fill: "#808080"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M231.956 193.365V194.454L223.657 189.644V188.559L231.956 193.365Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 193,
    width: 2,
    height: 2
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M232.819 193.363V194.452H231.956V193.363H232.819Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.819 193.363V194.452H231.956V193.363H232.819Z",
    fill: "#CCCCCC"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M241.069 188.056V188.556L232.818 193.362H231.956L223.657 188.556V188.056L231.908 183.242H232.73L241.069 188.056Z",
    fill: "#CCCCCC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M249.416 196.717V197.805L241.165 202.612V201.527L249.416 196.717Z",
    fill: "#808080"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M240.345 201.527V202.612L231.998 197.805V196.717L240.345 201.527Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 240,
    y: 201,
    width: 2,
    height: 2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M241.166 201.527V202.616H240.348V201.527H241.166Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.166 201.527V202.616H240.348V201.527H241.166Z",
    fill: "#CCCCCC"
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M249.416 196.22V196.716L241.166 201.527H240.348L232.001 196.716V196.22L240.259 191.41H241.121L249.42 196.22H249.416Z",
    fill: "#CCCCCC"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 187.057V188.145L190.912 192.904L190.952 191.815L199.21 187.057Z",
    fill: "#808080"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M190.098 191.815V192.904L181.792 188.145V187.057L190.098 191.815Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 190,
    y: 191,
    width: 1,
    height: 2
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M190.953 191.814L190.912 192.899H190.098V191.814H190.953Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.953 191.814L190.912 192.899H190.098V191.814H190.953Z",
    fill: "#CCCCCC"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21 186.558V187.054L190.952 191.816H190.097L181.792 187.054V186.558L190.049 181.744H190.912L199.21 186.558Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 191,
    width: 1,
    height: 2
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M195.353 191.864L195.312 192.953V191.453C195.353 191.638 195.353 191.727 195.353 191.864Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.353 191.864L195.312 192.953V191.453C195.353 191.638 195.353 191.727 195.353 191.864Z",
    fill: "#808080"
  }))), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M212.728 191.953V193.049L204.47 197.856V196.767L212.728 191.953Z",
    fill: "#808080"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M203.611 196.767V197.856L195.312 193.049L195.353 191.953L203.611 196.767Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 196,
    width: 2,
    height: 2
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M204.47 196.766V197.854H203.607V196.766H204.47Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.47 196.766V197.854H203.607V196.766H204.47Z",
    fill: "#CCCCCC"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M212.727 191.453V191.953L204.469 196.767H203.607L195.349 191.953C195.349 191.775 195.349 191.683 195.308 191.453L203.607 186.688H204.421L212.723 191.453H212.727Z",
    fill: "#CCCCCC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 195.086V196.175L221.568 200.988V199.892L229.825 195.086Z",
    fill: "#808080"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M220.756 199.892V200.988L212.409 196.175V195.086L220.756 199.892Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 199,
    width: 2,
    height: 2
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M221.567 199.891V200.987H220.756V199.891H221.567Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.567 199.891V200.987H220.756V199.891H221.567Z",
    fill: "#CCCCCC"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M229.825 194.584V195.084L221.567 199.89H220.756L212.409 195.084V194.584L220.667 189.777H221.482L229.828 194.584H229.825Z",
    fill: "#CCCCCC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.172 203.25V204.342L229.914 209.152V208.064L238.172 203.25Z",
    fill: "#808080"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M229.051 208.064V209.152L220.756 204.342V203.25L229.051 208.064Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 208,
    width: 1,
    height: 2
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M229.914 208.062V209.151H229.052V208.062H229.914Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.914 208.062V209.151H229.052V208.062H229.914Z",
    fill: "#CCCCCC"
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M238.172 202.798V203.25L229.914 208.064H229.052L220.753 203.25V202.798L229.004 197.988H229.825L238.172 202.798Z",
    fill: "#CCCCCC"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 193.586V194.671L179.662 199.485V198.392L187.916 193.586Z",
    fill: "#808080"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M178.845 198.392V199.485L170.498 194.671V193.586L178.845 198.392Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 198,
    width: 2,
    height: 2
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M179.664 198.395V199.487H178.846V198.395H179.664Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.664 198.395V199.487H178.846V198.395H179.664Z",
    fill: "#CCCCCC"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 193.09V193.59L179.666 198.396H178.848L170.501 193.59V193.09L178.759 188.32H179.621L187.92 193.09H187.916Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 197,
    width: 1,
    height: 3
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M184.108 198.488V199.577C184.108 199.392 184.108 199.303 184.06 199.077L184.108 197.988V198.488Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.108 198.488V199.577C184.108 199.392 184.108 199.303 184.06 199.077L184.108 197.988V198.488Z",
    fill: "#808080"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M201.479 198.488V199.577L193.221 204.387V203.298L201.479 198.488Z",
    fill: "#808080"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M192.366 203.298V204.387L184.109 199.577V198.488L192.366 203.298Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 203,
    width: 2,
    height: 2
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M193.221 203.297V204.382H192.366V203.297H193.221Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.221 203.297V204.382H192.366V203.297H193.221Z",
    fill: "#CCCCCC"
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M201.479 197.99V198.49L193.222 203.3H192.366L184.109 198.49V197.99L192.366 193.225H193.181L201.479 197.99Z",
    fill: "#CCCCCC"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M218.575 201.615V202.708L210.321 207.514V206.429L218.575 201.615Z",
    fill: "#808080"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M209.508 206.429V207.514L201.157 202.708V201.615L209.508 206.429Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 206,
    width: 2,
    height: 2
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M210.322 206.432V207.52H209.508V206.432H210.322Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.322 206.432V207.52H209.508V206.432H210.322Z",
    fill: "#CCCCCC"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M218.577 201.118V201.618L210.326 206.431H209.512L201.161 201.618V201.118L209.419 196.359H210.241L218.58 201.118H218.577Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 209,
    width: 1,
    height: 2
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M209.508 209.826L209.46 210.922V209.33C209.508 209.515 209.508 209.649 209.508 209.826Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.508 209.826L209.46 210.922V209.33C209.508 209.515 209.508 209.649 209.508 209.826Z",
    fill: "#808080"
  }))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M226.879 209.826V210.922L218.621 215.729V214.644L226.879 209.826Z",
    fill: "#808080"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M217.759 214.644V215.729L209.464 210.922L209.509 209.826L217.759 214.644Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 214,
    width: 2,
    height: 2
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M218.621 214.643V215.731H217.759V214.643H218.621Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.621 214.643V215.731H217.759V214.643H218.621Z",
    fill: "#CCCCCC"
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M226.879 209.33V209.826L218.621 214.64H217.759L209.508 209.826C209.508 209.648 209.508 209.511 209.46 209.33L217.759 204.523H218.573L226.875 209.33H226.879Z",
    fill: "#CCCCCC"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M176.672 200.164V201.253L168.414 206.018V204.93L176.672 200.164Z",
    fill: "#808080"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M167.552 204.93V206.018L159.257 201.253V200.164L167.552 204.93Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 204,
    width: 2,
    height: 3
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M168.414 204.932V206.02H167.552V204.932H168.414Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.414 204.932V206.02H167.552V204.932H168.414Z",
    fill: "#CCCCCC"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M176.672 199.669V200.169L168.414 204.935H167.552L159.253 200.169V199.669L167.504 194.859H168.326L176.672 199.669Z",
    fill: "#CCCCCC"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M165.373 206.705V207.79L157.078 212.6L157.123 211.511L165.373 206.705Z",
    fill: "#808080"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M156.263 211.511V212.6L147.957 207.79V206.705L156.263 211.511Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 211,
    width: 2,
    height: 2
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M157.122 211.51L157.074 212.598H156.26V211.51H157.122Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.122 211.51L157.074 212.598H156.26V211.51H157.122Z",
    fill: "#CCCCCC"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M165.372 206.205V206.705L157.122 211.511H156.259L147.953 206.705V206.205L156.211 201.439H157.074L165.372 206.205Z",
    fill: "#CCCCCC"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M154.087 213.283V214.372L145.829 219.138V218.045L154.087 213.283Z",
    fill: "#808080"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M145.01 218.045V219.138L136.671 214.372V213.283L145.01 218.045Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 218,
    width: 1,
    height: 2
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M145.829 218.043V219.135H145.011V218.043H145.829Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.829 218.043V219.135H145.011V218.043H145.829Z",
    fill: "#CCCCCC"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 212.781V213.28L145.828 218.039H145.01L136.671 213.28V212.781L144.922 207.967H145.784L154.086 212.781Z",
    fill: "#CCCCCC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M142.838 219.812V220.897L134.58 225.711V224.626L142.838 219.812Z",
    fill: "#808080"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M133.718 224.626V225.711L125.419 220.897V219.812L133.718 224.626Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 224,
    width: 2,
    height: 2
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M134.58 224.625V225.71H133.718V224.625H134.58Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.58 224.625V225.71H133.718V224.625H134.58Z",
    fill: "#CCCCCC"
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M142.838 219.314V219.814L134.58 224.628H133.718L125.419 219.814V219.314L133.673 214.549H134.488L142.834 219.314H142.838Z",
    fill: "#CCCCCC"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M131.538 226.391V227.476L123.287 232.241V231.156L131.538 226.391Z",
    fill: "#808080"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M122.425 231.156V232.241L114.13 227.476V226.391L122.425 231.156Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 231,
    width: 2,
    height: 2
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M123.287 231.158V232.243H122.425V231.158H123.287Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.287 231.158V232.243H122.425V231.158H123.287Z",
    fill: "#CCCCCC"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M131.538 225.89V226.39L123.287 231.156H122.425L114.126 226.39V225.89L122.377 221.084H123.243L131.538 225.89Z",
    fill: "#CCCCCC"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M190.227 205.02V206.108L181.977 210.922V209.826L190.227 205.02Z",
    fill: "#808080"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M181.114 209.826V210.922L172.856 206.108V205.02L181.114 209.826Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 209,
    width: 1,
    height: 2
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M181.977 209.826V210.922H181.115V209.826H181.977Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.977 209.826V210.922H181.115V209.826H181.977Z",
    fill: "#CCCCCC"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M190.226 204.566V205.018L181.976 209.824H181.114L172.856 205.018V204.566L181.114 199.76H181.928L190.226 204.566Z",
    fill: "#CCCCCC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M179.027 211.559L178.982 212.644L170.732 217.454V216.365L179.027 211.559Z",
    fill: "#808080"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M169.865 216.365V217.454L161.611 212.644V211.559L169.865 216.365Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 216,
    width: 2,
    height: 2
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M170.732 216.365V217.454H169.865V216.365H170.732Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.732 216.365V217.454H169.865V216.365H170.732Z",
    fill: "#CCCCCC"
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M178.982 211.099C178.982 211.285 178.982 211.373 179.026 211.559L170.731 216.365H169.865L161.615 211.559V211.099L169.865 206.293H170.687L178.985 211.099H178.982Z",
    fill: "#CCCCCC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M167.778 218.09L167.738 219.175L159.484 223.989L159.528 222.896L167.778 218.09Z",
    fill: "#808080"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M158.662 222.896L158.621 223.989L150.364 219.175V218.09L158.662 222.896Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 222,
    width: 2,
    height: 2
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 222.898L159.483 223.991H158.62L158.661 222.898H159.527Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.527 222.898L159.483 223.991H158.62L158.661 222.898H159.527Z",
    fill: "#CCCCCC"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M167.779 217.634V218.086L159.528 222.892H158.662L150.364 218.086V217.634L158.621 212.82H159.436L167.782 217.634H167.779Z",
    fill: "#CCCCCC"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M156.533 224.666V225.755L148.23 230.52L148.279 229.432L156.533 224.666Z",
    fill: "#808080"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M147.417 229.432L147.372 230.52L139.118 225.755V224.666L147.417 229.432Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 229,
    width: 2,
    height: 2
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M148.279 229.434L148.231 230.519H147.372L147.417 229.434H148.279Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.279 229.434L148.231 230.519H147.372L147.417 229.434H148.279Z",
    fill: "#CCCCCC"
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M156.533 224.168V224.668L148.275 229.433H147.413L139.115 224.668V224.168L147.369 219.361H148.183L156.53 224.168H156.533Z",
    fill: "#CCCCCC"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M145.284 231.203V232.292L137.027 237.057V235.965L145.284 231.203Z",
    fill: "#808080"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M136.171 235.965V237.057L127.865 232.292V231.203L136.171 235.965Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 235,
    width: 2,
    height: 3
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M137.027 235.963V237.055H136.172V235.963H137.027Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.027 235.963V237.055H136.172V235.963H137.027Z",
    fill: "#CCCCCC"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M145.284 230.702V231.202L137.03 235.964H136.175L127.873 231.202V230.702L136.131 225.889H136.945L145.288 230.702H145.284Z",
    fill: "#CCCCCC"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M120.252 232.928V234.016L111.994 238.823V237.734L120.252 232.928Z",
    fill: "#808080"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M111.176 237.734V238.823L102.837 234.016V232.928L111.176 237.734Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 237,
    width: 1,
    height: 2
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M111.992 237.736V238.821H111.174V237.736H111.992Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.992 237.736V238.821H111.174V237.736H111.992Z",
    fill: "#CCCCCC"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M120.252 232.43V232.93L111.994 237.74H111.176L102.837 232.93V232.43L111.088 227.664H111.946L120.249 232.43H120.252Z",
    fill: "#CCCCCC"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M134.032 237.734V238.823L125.781 243.637V242.544L134.032 237.734Z",
    fill: "#808080"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M124.919 242.544V243.637L116.62 238.823V237.734L124.919 242.544Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 242,
    width: 2,
    height: 2
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M125.782 242.545V243.637H124.919V242.545H125.782Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.782 242.545V243.637H124.919V242.545H125.782Z",
    fill: "#CCCCCC"
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M134.032 237.234V237.734L125.781 242.544H124.919L116.62 237.734V237.234L124.871 232.424H125.689L134.028 237.234H134.032Z",
    fill: "#CCCCCC"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M207.328 208.15V209.239L199.077 214.045V212.957L207.328 208.15Z",
    fill: "#808080"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M198.259 212.957V214.045L189.912 209.239V208.15L198.259 212.957Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 212,
    width: 2,
    height: 3
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M199.077 212.959V214.048H198.259V212.959H199.077Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.077 212.959V214.048H198.259V212.959H199.077Z",
    fill: "#CCCCCC"
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M207.327 207.656V208.156L199.077 212.963H198.259L189.912 208.156V207.656L198.163 202.891H199.029L207.327 207.656Z",
    fill: "#CCCCCC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M196.082 214.684V215.776L187.828 220.586V219.497L196.082 214.684Z",
    fill: "#808080"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M187.007 219.497V220.586L178.667 215.776V214.684L187.007 219.497Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 219,
    width: 1,
    height: 2
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M187.829 219.496V220.585H187.011V219.496H187.829Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.829 219.496V220.585H187.011V219.496H187.829Z",
    fill: "#CCCCCC"
  }))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M196.082 214.184V214.684L187.825 219.498H187.007L178.667 214.684V214.184L186.918 209.426H187.78L196.082 214.184Z",
    fill: "#CCCCCC"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M184.834 221.219V222.307L176.576 227.114V226.029L184.834 221.219Z",
    fill: "#808080"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M175.761 226.029V227.114L167.414 222.307V221.219L175.761 226.029Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 226,
    width: 2,
    height: 2
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M176.577 226.029V227.118H175.763V226.029H176.577Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.577 226.029V227.118H175.763V226.029H176.577Z",
    fill: "#CCCCCC"
  }))), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M184.833 220.719V221.219L176.579 226.025H175.765L167.418 221.219V220.719L175.676 215.953H176.538L184.837 220.719H184.833Z",
    fill: "#CCCCCC"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M173.582 227.752V228.844L165.331 233.654V232.566L173.582 227.752Z",
    fill: "#808080"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M164.517 232.566V233.654L156.166 228.844V227.752L164.517 232.566Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 232,
    width: 2,
    height: 2
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M165.331 232.564V233.653H164.521V232.564H165.331Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.331 232.564V233.653H164.521V232.564H165.331Z",
    fill: "#CCCCCC"
  }))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M173.581 227.301V227.752L165.331 232.566H164.52L156.166 227.752V227.301L164.424 222.494H165.287L173.585 227.301H173.581Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 233,
    width: 1,
    height: 3
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M144.921 234.922L144.962 233.826V235.37C144.962 235.185 144.921 235.096 144.921 234.919V234.922Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.962 234.287V235.372C144.962 235.187 144.921 235.098 144.921 234.92L144.962 233.824V234.283V234.287Z",
    fill: "#808080"
  }))), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M162.337 234.287V235.376L154.086 240.182V239.097L162.337 234.287Z",
    fill: "#808080"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M153.264 239.097V240.182L144.962 235.376V234.287L153.264 239.097Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 239,
    width: 2,
    height: 2
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M154.088 239.098V240.186H153.266V239.098H154.088Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.088 239.098V240.186H153.266V239.098H154.088Z",
    fill: "#CCCCCC"
  }))), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M162.338 233.83V234.289L154.087 239.095H153.265L144.963 234.289V233.83L153.221 229.023H154.087L162.338 233.83Z",
    fill: "#CCCCCC"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M151.133 240.818L151.096 241.907L142.838 246.717V245.625L151.133 240.818Z",
    fill: "#808080"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M142.017 245.625V246.717L133.718 241.907V240.818L142.017 245.625Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 245,
    width: 1,
    height: 2
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M142.838 245.625V246.717H142.016V245.625H142.838Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.838 245.625V246.717H142.016V245.625H142.838Z",
    fill: "#CCCCCC"
  }))), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M151.096 240.367C151.137 240.544 151.137 240.641 151.137 240.818L142.838 245.625H142.017L133.718 240.818V240.367L141.972 235.557H142.835L151.092 240.367H151.096Z",
    fill: "#CCCCCC"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M212.773 218.002V219.087L204.108 224.167V223.082L212.773 218.002Z",
    fill: "#808080"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M204.107 223.084V224.169L203.063 224.758V223.669L204.107 223.084Z",
    fill: "#808080"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M203.063 223.67V224.759L193.943 230.072V228.98L203.063 223.67Z",
    fill: "#808080"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M193.944 228.979V230.071L192.907 230.656V229.571L193.944 228.979Z",
    fill: "#808080"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M192.906 229.572V230.657L183.834 235.967V234.879L192.906 229.572Z",
    fill: "#808080"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M183.835 234.877V235.966L182.75 236.562V235.466L183.835 234.877Z",
    fill: "#808080"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M182.75 235.467V236.563L173.678 241.865V240.78L182.75 235.467Z",
    fill: "#808080"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M173.678 240.779V241.864L172.586 242.453V241.368L173.678 240.779Z",
    fill: "#808080"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M172.586 241.369V242.454L163.518 247.76V246.675L172.586 241.369Z",
    fill: "#808080"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M163.519 246.674V247.759L153.769 253.387L153.813 252.299L163.519 246.674Z",
    fill: "#808080"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M152.946 252.299L152.906 253.388L144.648 248.622V247.533L152.946 252.299Z",
    fill: "#808080"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M212.772 217.543V218.002L204.111 223.082L203.067 223.671L193.947 228.977L192.907 229.57L183.839 234.876L182.754 235.465L173.682 240.778L172.59 241.367L163.525 246.673L153.82 252.302H152.954L144.656 247.536V247.036L154.361 241.367L163.429 236.102L164.525 235.465L173.589 230.207L174.685 229.57L183.75 224.304L184.842 223.667L193.914 218.409L194.954 217.772L203.619 212.732H204.481L212.78 217.539L212.772 217.543Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 252,
    width: 2,
    height: 2
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M153.813 252.301L153.765 253.386H152.903L152.943 252.301H153.809H153.813Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.813 252.301L153.765 253.386H152.903L152.943 252.301H153.809H153.813Z",
    fill: "#CCCCCC"
  }))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M109.003 239.504V240.593L100.745 245.358V244.273L109.003 239.504Z",
    fill: "#808080"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8902 244.273V245.358L91.5842 240.593V239.504L99.8902 244.273Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 244,
    width: 2,
    height: 2
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M100.746 244.273V245.358H99.8909V244.273H100.746Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.746 244.273V245.358H99.8909V244.273H100.746Z",
    fill: "#CCCCCC"
  }))), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M109.003 239.009V239.505L100.745 244.275H99.8904L91.5881 239.505V239.009L99.8423 234.195H100.657L109.003 239.009Z",
    fill: "#CCCCCC"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M122.787 244.273V245.358L114.536 250.168V249.08L122.787 244.273Z",
    fill: "#808080"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M113.671 249.08V250.168L105.372 245.358V244.273L113.671 249.08Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 249,
    width: 2,
    height: 2
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M114.536 249.08V250.169H113.67V249.08H114.536Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.536 249.08V250.169H113.67V249.08H114.536Z",
    fill: "#CCCCCC"
  }))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M122.787 243.773V244.273L114.537 249.079H113.671L105.372 244.273V243.773L113.626 238.959H114.441L122.787 243.773Z",
    fill: "#CCCCCC"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M139.891 247.354V248.442L131.585 253.249L131.633 252.164L139.891 247.354Z",
    fill: "#808080"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M130.771 252.164V253.249L122.473 248.442V247.354L130.771 252.164Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 252,
    width: 2,
    height: 2
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M131.634 252.164L131.586 253.253H130.771V252.164H131.634Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.634 252.164L131.586 253.253H130.771V252.164H131.634Z",
    fill: "#CCCCCC"
  }))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M139.891 246.896V247.355L131.633 252.162H130.771L122.472 247.355V246.896L130.723 242.09H131.585L139.891 246.896Z",
    fill: "#CCCCCC"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M147.916 255.705V256.794L139.661 261.6V260.511L147.916 255.705Z",
    fill: "#808080"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M138.843 260.511V261.6L130.496 256.794V255.705L138.843 260.511Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 260,
    width: 2,
    height: 2
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M139.663 260.51V261.598H138.845V260.51H139.663Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.663 260.51V261.598H138.845V260.51H139.663Z",
    fill: "#CCCCCC"
  }))), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M147.915 255.246V255.705L139.665 260.511H138.847L130.5 255.705V255.246L138.751 250.439H139.617L147.915 255.246Z",
    fill: "#CCCCCC"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3918 246.223V247.311L83.8743 255.158V254.073L97.3918 246.223Z",
    fill: "#808080"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0598 254.072V255.157L74.7131 250.35V249.258L83.0598 254.072Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 254,
    width: 1,
    height: 2
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8741 254.072V255.157H83.0598V254.072H83.8741Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8741 254.072V255.157H83.0598V254.072H83.8741Z",
    fill: "#CCCCCC"
  }))), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3914 245.72V246.22L83.8702 254.07H83.0559L74.7092 249.256V248.805L88.2231 240.906H89.0855L97.3877 245.72H97.3914Z",
    fill: "#CCCCCC"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M110.951 251.117V252.21L95.0312 261.463V260.378L110.951 251.117Z",
    fill: "#808080"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2168 260.377V261.461L85.8701 256.655V255.566L94.2168 260.377Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 260,
    width: 2,
    height: 2
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0311 260.377V261.462H94.2168V260.377H95.0311Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.0311 260.377V261.462H94.2168V260.377H95.0311Z",
    fill: "#CCCCCC"
  }))), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M110.951 250.622V251.121L95.0308 260.379H94.2165L85.8699 255.572V255.117L101.838 245.863H102.652L110.951 250.625V250.622Z",
    fill: "#CCCCCC"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M127.866 254.34V255.432L106.602 267.818V266.73L127.866 254.34Z",
    fill: "#808080"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M105.735 266.73V267.819L97.4807 263.012V261.924L105.735 266.73Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 266,
    width: 2,
    height: 2
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M106.601 266.732V267.817H105.731V266.732H106.601Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.601 266.732V267.817H105.731V266.732H106.601Z",
    fill: "#CCCCCC"
  }))), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M127.866 253.84V254.336L106.601 266.726H105.731L97.4807 261.916V261.416L118.705 249.074H119.567L127.866 253.836V253.84Z",
    fill: "#CCCCCC"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M136.672 262.285V263.374L128.414 268.176V267.092L136.672 262.285Z",
    fill: "#808080"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M127.592 267.092V268.176L119.253 263.374V262.285L127.592 267.092Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 267,
    width: 2,
    height: 2
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M128.414 267.09V268.175H127.592V267.09H128.414Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.414 267.09V268.175H127.592V267.09H128.414Z",
    fill: "#CCCCCC"
  }))), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M136.672 261.785V262.284L128.414 267.094H127.592L119.253 262.284V261.785L127.504 256.971H128.318L136.668 261.785H136.672Z",
    fill: "#CCCCCC"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M125.371 268.814V269.903L117.12 274.717V273.625L125.371 268.814Z",
    fill: "#808080"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M116.258 273.625V274.717L108.004 269.903V268.814L116.258 273.625Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 273,
    width: 2,
    height: 2
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M117.12 273.623V274.715H116.258V273.623H117.12Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.12 273.623V274.715H116.258V273.623H117.12Z",
    fill: "#CCCCCC"
  }))), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M125.371 268.363V268.814L117.121 273.621H116.258L108 268.814V268.363L116.258 263.549H117.072L125.371 268.363Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 245,
    y: 203,
    width: 12,
    height: 4
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M245.519 205.112C248.465 203.39 253.273 203.39 256.264 205.112V206.704C253.27 204.982 248.465 204.982 245.519 206.704V205.112Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.519 205.112V206.705C246.018 206.383 246.559 206.157 247.147 205.979V204.387C246.607 204.572 246.018 204.846 245.519 205.112Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.149 204.388V205.98C247.608 205.795 248.104 205.706 248.603 205.61V204.021C248.148 204.11 247.648 204.247 247.149 204.384V204.388Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.602 204.018V205.607C248.916 205.566 249.238 205.518 249.601 205.477V203.885C249.238 203.933 248.965 203.981 248.602 204.022V204.018Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.597 203.886V205.478C249.871 205.43 250.137 205.43 250.411 205.43V203.842C250.141 203.842 249.871 203.886 249.597 203.886Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.413 203.842V205.43C250.687 205.382 250.961 205.382 251.235 205.43V203.842H250.413Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.235 203.842V205.43H251.96V203.886C251.686 203.842 251.46 203.842 251.235 203.842Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.96 203.887V205.431C252.234 205.479 252.46 205.52 252.682 205.52V203.979C252.456 203.931 252.23 203.883 251.96 203.883V203.887Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.681 203.982V205.523C252.955 205.571 253.229 205.612 253.455 205.66V204.116C253.229 204.027 252.955 203.986 252.681 203.986V203.982Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.455 204.113V205.657C253.729 205.705 253.955 205.794 254.229 205.835V204.295C253.996 204.206 253.729 204.158 253.455 204.109V204.113Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.228 204.295V205.835C254.591 205.932 254.857 206.069 255.179 206.157V204.613C254.857 204.484 254.591 204.387 254.228 204.299V204.295Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.18 204.611V206.155C255.543 206.333 255.954 206.518 256.264 206.703V205.111C255.95 204.933 255.587 204.748 255.18 204.611Z",
    fill: "#858585"
  }))), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M256.264 205.113L277.262 217.277V218.814L256.264 206.706V205.113Z",
    fill: "#898989"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 277,
    y: 217,
    width: 3,
    height: 5
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M279.531 221.948C279.531 220.815 278.757 219.679 277.262 218.816V217.275C278.761 218.138 279.531 219.268 279.531 220.401V221.945V221.948Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.262 217.277V218.818C278.761 219.681 279.531 220.814 279.531 221.95V220.406C279.531 219.27 278.757 218.14 277.262 217.281V217.277Z",
    fill: "#858585"
  }))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M277.262 218.812C280.256 220.534 280.256 223.352 277.262 225.077L238.893 247.399C235.899 249.12 231.094 249.12 228.1 247.399L207.102 235.286C204.152 233.565 204.107 230.747 207.054 229.025L245.515 206.704C248.461 204.982 253.269 204.982 256.26 206.704L277.258 218.816L277.262 218.812Z",
    fill: "#F2F2F2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M207.053 227.479L245.518 205.113V206.706L207.053 229.023V227.479Z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 227,
    width: 4,
    height: 6
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M204.877 230.567C204.877 229.434 205.606 228.345 207.057 227.479V229.023C205.606 229.885 204.877 231.022 204.877 232.107V230.567Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.877 230.474V232.066C204.877 231.929 204.877 231.792 204.925 231.607V230.07C204.877 230.207 204.877 230.341 204.877 230.474Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.922 230.07V231.607C204.97 231.47 204.97 231.341 205.059 231.204V229.611C204.97 229.748 204.97 229.93 204.922 230.07Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.058 229.612V231.205C205.106 231.068 205.147 230.934 205.243 230.746V229.205C205.147 229.342 205.106 229.472 205.058 229.612Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.243 229.209V230.75C205.332 230.613 205.421 230.479 205.558 230.298V228.754C205.421 228.891 205.332 229.024 205.243 229.209Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.558 228.752V230.296C205.695 230.159 205.828 229.974 206.017 229.796V228.252C205.872 228.389 205.695 228.574 205.558 228.752Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.018 228.253V229.797C206.288 229.571 206.603 229.297 206.969 229.112V227.523C206.603 227.749 206.332 227.979 206.018 228.249V228.253Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.968 227.527V229.115C207.016 229.075 207.057 229.075 207.057 229.027V227.482C207.057 227.482 207.016 227.482 206.968 227.527Z",
    fill: "#B8B8B8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M168.236 8.88003C168.236 8.69488 167.962 8.60601 167.826 8.69488L166.145 9.64653L127.277 178.348L133.947 174.53L170.272 16.8191L168.236 8.88003Z",
    fill: "#1A1A1A"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6915 55.5618L47.8157 224.256L61.2407 216.502L100.113 47.7598L86.6915 55.5618Z",
    fill: "#1A1A1A"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M104.01 45.5392L65.1448 214.233L94.756 197.174L133.628 28.4316L104.01 45.5392Z",
    fill: "#1A1A1A"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M40.605 82.1531L24.6445 151.39L26.9061 160.285L45.5982 79.25L40.605 82.1531Z",
    fill: "#1A1A1A"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M182.291 63.7344L160.253 159.288L166.871 155.478L185.286 75.5319L182.291 63.7344Z",
    fill: "#1A1A1A"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M186.418 79.8418L169.322 154.108L173.493 151.664L188.376 87.3698L186.418 79.8418Z",
    fill: "#1A1A1A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M191.952 124.166L162.2 7.97169C161.204 4.06881 157.888 2.34325 154.853 4.11325L4.00924 91.2245C0.966685 92.9945 -0.710051 97.5788 0.289328 101.482L30.0449 217.724C31.0369 221.627 34.346 223.352 37.4366 221.582L188.232 134.423C191.274 132.701 192.951 128.069 191.952 124.166Z",
    fill: "#838383"
  }))), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M202.796 132.7L201.567 132.429L201.068 130.43L202.248 130.619L202.796 132.7Z",
    fill: "#151720"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M201.252 125.803L200.027 125.625L199.528 123.533L200.753 123.807L201.252 125.803Z",
    fill: "#151720"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M197.307 128.117L196.082 127.891L200.028 125.621L201.253 125.799L197.307 128.117Z",
    fill: "#181B25"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M200.754 123.807L201.253 125.803L197.308 128.121L196.808 126.077L200.754 123.807Z",
    fill: "#F3F3F3"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M197.308 128.119L196.082 127.894L195.538 125.85L196.808 126.075L197.308 128.119Z",
    fill: "#828282"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M196.808 126.077L195.538 125.851L199.528 123.533L200.754 123.807L196.808 126.077Z",
    fill: "#969696"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M169.914 151.664L168.689 151.435L201.568 132.428L202.797 132.698L169.914 151.664Z",
    fill: "#181B25"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M169.409 149.626L168.14 149.392L201.068 130.43L202.248 130.619L169.409 149.626Z",
    fill: "#969696"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M169.913 151.666L168.688 151.437L168.14 149.393L169.409 149.626L169.913 151.666Z",
    fill: "#828282"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 157.653L158.306 157.475L157.806 155.383L158.979 155.657L159.527 157.653Z",
    fill: "#151720"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M151.274 162.42L150.097 162.198L158.307 157.477L159.528 157.654L151.274 162.42Z",
    fill: "#181B25"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M153.539 153.387L152.269 153.161L151.77 151.121L152.995 151.347L153.539 153.387Z",
    fill: "#151720"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M149.596 168.181L148.367 168L148.641 167.814L149.911 168L149.596 168.181Z",
    fill: "#181B25"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M150.771 160.374L149.549 160.148L157.807 155.383L158.98 155.657L150.771 160.374Z",
    fill: "#969696"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M151.274 162.42L150.097 162.198L149.549 160.15L150.771 160.376L151.274 162.42Z",
    fill: "#828282"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M158.98 155.656L159.527 157.652L151.273 162.418L150.77 160.374L158.98 155.656Z",
    fill: "#F3F3F3"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M149.549 155.656L148.323 155.478L152.269 153.16L153.539 153.386L149.549 155.656Z",
    fill: "#181B25"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M152.995 151.348L153.539 153.388L149.549 155.658L149.049 153.662L152.995 151.348Z",
    fill: "#F3F3F3"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M149.549 155.657L148.323 155.479L147.827 153.387L149.049 153.661L149.549 155.657Z",
    fill: "#828282"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M149.049 153.661L147.827 153.387L151.769 151.121L152.995 151.347L149.049 153.661Z",
    fill: "#969696"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M146.554 165.19L145.284 164.96L144.784 162.92L146.01 163.098L146.554 165.19Z",
    fill: "#151720"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M149.911 167.999L148.641 167.814L144.196 150.488L145.461 150.714L149.911 167.999Z",
    fill: "#151720"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M149.596 168.179L148.368 167.997L143.922 150.664L145.192 150.846L149.596 168.179Z",
    fill: "#29303E"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M145.192 150.847L143.922 150.666L144.196 150.488L145.462 150.714L145.192 150.847Z",
    fill: "#303748"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M145.462 150.713L149.911 167.998L149.596 168.18L145.192 150.846L145.462 150.713Z",
    fill: "#4D5974"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M143.923 155.108L142.742 154.842L142.201 152.846L143.427 153.023L143.923 155.108Z",
    fill: "#151720"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M141.972 156.201L140.746 156.019L142.741 154.842L143.922 155.108L141.972 156.201Z",
    fill: "#181B25"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M141.476 154.208L140.206 153.931L142.201 152.846L143.427 153.023L141.476 154.208Z",
    fill: "#969696"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M141.972 156.202L140.747 156.02L140.206 153.932L141.476 154.209L141.972 156.202Z",
    fill: "#828282"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M143.426 153.025L143.922 155.11L141.972 156.203L141.476 154.21L143.426 153.025Z",
    fill: "#F3F3F3"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M138.296 169.908L137.027 169.727L145.284 164.961L146.554 165.191L138.296 169.908Z",
    fill: "#181B25"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M141.292 156.61L140.07 156.384L139.571 154.344L140.792 154.57L141.292 156.61Z",
    fill: "#151720"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M138.297 169.907L137.027 169.725L136.528 167.637L137.756 167.911L138.297 169.907Z",
    fill: "#828282"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M137.756 167.911L136.528 167.637L144.785 162.92L146.011 163.098L137.756 167.911Z",
    fill: "#969696"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M139.345 157.74L138.119 157.514L140.07 156.381L141.291 156.607L139.345 157.74Z",
    fill: "#181B25"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M140.792 154.568L141.292 156.609L139.345 157.742L138.845 155.746L140.792 154.568Z",
    fill: "#F3F3F3"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M138.844 155.747L137.571 155.481L139.569 154.344L140.791 154.57L138.844 155.747Z",
    fill: "#969696"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M139.343 157.743L138.118 157.517L137.57 155.48L138.844 155.747L139.343 157.743Z",
    fill: "#828282"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M138.666 158.107L137.437 157.929L136.938 155.885L138.118 156.111L138.666 158.107Z",
    fill: "#151720"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M136.671 159.29L135.487 159.065L137.437 157.928L138.666 158.105L136.671 159.29Z",
    fill: "#181B25"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M136.672 159.291L135.487 159.065L134.95 157.018L136.172 157.243L136.672 159.291Z",
    fill: "#828282"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M138.119 156.107L138.667 158.103L136.672 159.288L136.172 157.241L138.119 156.107Z",
    fill: "#F3F3F3"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M136.172 157.244L134.95 157.018L136.938 155.885L138.119 156.111L136.172 157.244Z",
    fill: "#969696"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M136.027 159.649L134.765 159.471L134.265 157.379L135.486 157.653L136.027 159.649Z",
    fill: "#151720"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M134.032 160.828L132.807 160.561L134.765 159.473L136.027 159.65L134.032 160.828Z",
    fill: "#181B25"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M135.487 157.652L136.027 159.648L134.032 160.826L133.491 158.741L135.487 157.652Z",
    fill: "#F3F3F3"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M134.032 160.827L132.807 160.56L132.311 158.561L133.492 158.742L134.032 160.827Z",
    fill: "#828282"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M133.492 158.742L132.311 158.56L134.265 157.379L135.487 157.653L133.492 158.742Z",
    fill: "#969696"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M144.922 148.851L143.738 148.577L121.699 62.5508L122.877 62.7396L144.922 148.851Z",
    fill: "#151720"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M144.647 148.671L143.381 148.445L121.521 62.9668L122.746 63.189L144.647 148.671Z",
    fill: "#29303E"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M139.069 129.707L137.844 129.522L137.3 127.438L138.57 127.66L139.069 129.707Z",
    fill: "#151720"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6485 207.927L41.427 207.701L143.738 148.576L144.922 148.85L42.6485 207.927Z",
    fill: "#181B25"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7845 207.472L41.6038 207.242L143.381 148.443L144.647 148.669L42.7845 207.472Z",
    fill: "#303748"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M132.178 155.382L130.956 155.204L133.036 153.979L134.265 154.208L132.178 155.382Z",
    fill: "#181B25"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M134.766 132.153L133.581 131.978L137.845 129.523L139.07 129.709L134.766 132.153Z",
    fill: "#181B25"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M137.348 122.991L136.123 122.805L135.575 120.721L136.849 120.995L137.348 122.991Z",
    fill: "#151720"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M134.265 154.208L133.036 153.979L130.723 144.947L131.952 145.221L134.265 154.208Z",
    fill: "#151720"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M134.765 132.151L133.58 131.977L133.036 129.93L134.265 130.159L134.765 132.151Z",
    fill: "#828282"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M134.265 130.159L133.036 129.93L137.3 127.438L138.57 127.66L134.265 130.159Z",
    fill: "#969696"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M128.317 157.653L127.144 157.379L129.228 156.201L130.408 156.383L128.317 157.653Z",
    fill: "#181B25"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M130.409 156.382L129.228 156.201L128.051 151.709L129.317 151.935L130.409 156.382Z",
    fill: "#151720"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M132.177 155.383L130.956 155.205L128.639 146.174L129.86 146.403L132.177 155.383Z",
    fill: "#4E4E4E"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M129.86 146.403L128.639 146.173L130.723 144.947L131.952 145.221L129.86 146.403Z",
    fill: "#5A5A5A"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M133.081 125.488L131.86 125.262L136.124 122.807L137.349 122.992L133.081 125.488Z",
    fill: "#181B25"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M135.672 116.319L134.403 116.093L133.855 114.053L135.128 114.279L135.672 116.319Z",
    fill: "#151720"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 153.12L125.967 152.935L128.051 151.709L129.317 151.935L127.237 153.12Z",
    fill: "#5A5A5A"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M128.317 157.655L127.144 157.381L125.967 152.938L127.237 153.123L128.317 157.655Z",
    fill: "#4E4E4E"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M129.317 151.936L130.409 156.383L128.317 157.653L127.237 153.12L129.317 151.936Z",
    fill: "#929292"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M133.081 125.487L131.86 125.261L131.312 123.217L132.585 123.443L133.081 125.487Z",
    fill: "#828282"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M132.585 123.442L131.312 123.216L135.576 120.721L136.849 120.995L132.585 123.442Z",
    fill: "#969696"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M136.849 120.994L137.349 122.99L133.081 125.486L132.585 123.442L136.849 120.994Z",
    fill: "#F3F3F3"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M124.513 159.832L123.287 159.599L125.419 158.377L126.596 158.651L124.513 159.832Z",
    fill: "#181B25"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M126.596 158.652L125.419 158.378L123.968 152.846L125.193 153.023L126.596 158.652Z",
    fill: "#151720"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M131.359 118.813L130.134 118.547L134.402 116.092L135.671 116.318L131.359 118.813Z",
    fill: "#181B25"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M133.951 109.649L132.678 109.375L132.178 107.379L133.403 107.564L133.951 109.649Z",
    fill: "#151720"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M131.359 118.811L130.134 118.545L129.59 116.545L130.86 116.723L131.359 118.811Z",
    fill: "#828282"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86 116.726L129.59 116.549L133.854 114.053L135.127 114.279L130.86 116.726Z",
    fill: "#969696"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M122.788 160.828L121.566 160.602L121.067 158.654L122.292 158.836L122.788 160.828Z",
    fill: "#151720"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M123.102 154.297L121.88 154.02L123.968 152.846L125.193 153.023L123.102 154.297Z",
    fill: "#5A5A5A"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M124.512 159.833L123.287 159.6L121.88 154.02L123.102 154.297L124.512 159.833Z",
    fill: "#4E4E4E"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M126.737 130.518L125.508 130.292L125.967 130.07L127.188 130.248L126.737 130.518Z",
    fill: "#181B25"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M120.704 162.009L119.479 161.827L121.566 160.602L122.788 160.827L120.704 162.009Z",
    fill: "#181B25"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M129.639 112.097L128.414 111.871L132.678 109.375L133.951 109.649L129.639 112.097Z",
    fill: "#181B25"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M132.222 102.936L130.956 102.662L130.456 100.666L131.678 100.847L132.222 102.936Z",
    fill: "#151720"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M120.203 160.061L118.982 159.836L121.066 158.654L122.291 158.836L120.203 160.061Z",
    fill: "#5A5A5A"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M120.703 162.01L119.478 161.828L118.982 159.836L120.203 160.062L120.703 162.01Z",
    fill: "#4E4E4E"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M129.135 110.06L127.865 109.834L132.178 107.379L133.403 107.564L129.135 110.06Z",
    fill: "#969696"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M133.403 107.562L133.951 109.647L129.638 112.095L129.135 110.058L133.403 107.562Z",
    fill: "#F3F3F3"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M129.638 112.096L128.413 111.871L127.865 109.834L129.135 110.06L129.638 112.096Z",
    fill: "#828282"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M127.189 130.247L125.967 130.069L124.15 123.078L125.419 123.263L127.189 130.247Z",
    fill: "#151720"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M125.419 123.264L124.15 123.079L124.968 122.631L126.241 122.805L125.419 123.264Z",
    fill: "#181B25"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M126.736 130.517L125.507 130.291L123.698 123.352L124.967 123.529L126.736 130.517Z",
    fill: "#151720"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M124.967 123.53L123.698 123.352L124.149 123.078L125.419 123.263L124.967 123.53Z",
    fill: "#181B25"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M118.983 163.008L117.709 162.823L116.936 159.697L118.161 159.923L118.983 163.008Z",
    fill: "#151720"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M127.961 105.384L126.692 105.158L130.956 102.662L132.222 102.936L127.961 105.384Z",
    fill: "#181B25"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M130.497 96.2209L129.228 95.9913L128.728 93.9473L129.957 94.1806L130.497 96.2209Z",
    fill: "#151720"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M116.891 164.279L115.625 164.009L117.709 162.824L118.982 163.009L116.891 164.279Z",
    fill: "#181B25"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M124.149 124.029L122.875 123.803L123.697 123.352L124.967 123.529L124.149 124.029Z",
    fill: "#181B25"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M131.677 100.846L132.221 102.934L127.961 105.382L127.413 103.345L131.677 100.846Z",
    fill: "#F3F3F3"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M127.414 103.347L126.145 103.117L130.457 100.666L131.678 100.847L127.414 103.347Z",
    fill: "#969696"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M127.962 105.381L126.693 105.156L126.145 103.115L127.414 103.345L127.962 105.381Z",
    fill: "#828282"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M118.16 159.922L118.982 163.006L116.891 164.277L116.076 161.099L118.16 159.922Z",
    fill: "#929292"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M116.891 164.279L115.625 164.008L114.852 160.924L116.077 161.102L116.891 164.279Z",
    fill: "#4E4E4E"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M116.077 161.101L114.852 160.923L116.936 159.697L118.161 159.923L116.077 161.101Z",
    fill: "#5A5A5A"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M128.776 89.5043L127.551 89.3265L127.055 87.2344L128.236 87.5084L128.776 89.5043Z",
    fill: "#151720"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M113.038 166.455L111.817 166.23L113.897 165.004L115.166 165.278L113.038 166.455Z",
    fill: "#181B25"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M115.166 165.277L113.897 165.003L111.994 157.652L113.268 157.837L115.166 165.277Z",
    fill: "#151720"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M123.246 100.397L121.973 100.215L129.228 95.9941L130.497 96.2237L123.246 100.397Z",
    fill: "#181B25"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M124.512 92.0016L123.246 91.7758L127.551 89.3281L128.776 89.5059L124.512 92.0016Z",
    fill: "#181B25"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M127.055 82.7882L125.822 82.6104L125.323 80.5664L126.551 80.7923L127.055 82.7882Z",
    fill: "#151720"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M117.531 128.795L116.258 128.525L116.713 128.295L117.983 128.525L117.531 128.795Z",
    fill: "#181B25"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M123.246 100.397L121.973 100.216L121.477 98.1309L122.698 98.4012L123.246 100.397Z",
    fill: "#7A2E12"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M122.698 98.3982L121.477 98.1279L128.728 93.9473L129.957 94.1806L122.698 98.3982Z",
    fill: "#8E3515"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M124.512 91.9984L123.246 91.7725L122.746 89.7285L123.968 89.9544L124.512 91.9984Z",
    fill: "#828282"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M123.968 89.956L122.746 89.7301L127.055 87.2344L128.236 87.5084L123.968 89.956Z",
    fill: "#969696"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M113.038 166.455L111.817 166.229L109.91 158.834L111.176 159.064L113.038 166.455Z",
    fill: "#4E4E4E"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M111.176 159.063L109.91 158.834L111.994 157.652L113.268 157.837L111.176 159.063Z",
    fill: "#5A5A5A"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M109.226 168.678L108.004 168.452L110.088 167.23L111.317 167.456L109.226 168.678Z",
    fill: "#181B25"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M118.708 116.367L117.483 116.141L117.934 115.867L119.159 116.093L118.708 116.367Z",
    fill: "#181B25"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M126.24 122.805L124.967 122.631L119.341 100.572L120.607 100.761L126.24 122.805Z",
    fill: "#151720"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M117.983 128.526L116.713 128.296L115.125 121.99L116.35 122.175L117.983 128.526Z",
    fill: "#151720"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M116.35 122.175L115.125 121.99L115.94 121.494L117.161 121.72L116.35 122.175Z",
    fill: "#181B25"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M111.317 167.456L110.088 167.23L108.004 159.291L109.274 159.472L111.317 167.456Z",
    fill: "#151720"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M122.787 85.2829L121.521 85.057L125.822 82.6094L127.054 82.7871L122.787 85.2829Z",
    fill: "#181B25"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M125.322 76.1232L124.101 75.8973L123.601 73.8496L124.83 74.0792L125.322 76.1232Z",
    fill: "#151720"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M117.531 128.796L116.258 128.525L114.666 122.264L115.891 122.441L117.531 128.796Z",
    fill: "#151720"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M115.891 122.442L114.666 122.264L115.125 121.99L116.35 122.175L115.891 122.442Z",
    fill: "#181B25"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M115.077 122.941L113.811 122.715L114.666 122.264L115.891 122.441L115.077 122.941Z",
    fill: "#181B25"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M117.161 121.719L115.94 121.493L114.263 114.961L115.488 115.187L117.161 121.719Z",
    fill: "#151720"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M115.488 115.188L117.161 121.719L116.35 122.175L115.891 122.442L115.077 122.941L113.397 116.365L114.218 115.913L114.666 115.639L115.488 115.188Z",
    fill: "#EFA838"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M117.531 128.795L115.891 122.44L116.35 122.174L117.982 128.524L117.531 128.795Z",
    fill: "#272C3C"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M119.793 101.257L118.528 101.031L119.342 100.572L120.608 100.761L119.793 101.257Z",
    fill: "#8E3515"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M119.341 101.483L118.072 101.298L118.527 101.031L119.793 101.257L119.341 101.483Z",
    fill: "#8E3515"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M113.719 130.979L112.446 130.794L112.897 130.52L114.17 130.705L113.719 130.979Z",
    fill: "#181B25"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M122.787 85.2823L121.521 85.0564L121.022 83.0605L122.247 83.2383L122.787 85.2823Z",
    fill: "#828282"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M122.247 83.2399L121.022 83.0622L125.323 80.5664L126.552 80.7923L122.247 83.2399Z",
    fill: "#969696"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M124.15 124.031L122.877 123.805L117.258 101.758L118.528 101.984L124.15 124.031Z",
    fill: "#7A2E12"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M118.528 101.984L117.258 101.758L118.072 101.299L119.342 101.484L118.528 101.984Z",
    fill: "#8E3515"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M105.373 170.904L104.148 170.63L106.28 169.449L107.457 169.675L105.373 170.904Z",
    fill: "#181B25"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M109.225 168.676L108.004 168.451L105.916 160.471L107.186 160.697L109.225 168.676Z",
    fill: "#4E4E4E"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M107.186 160.698L105.916 160.472L108.004 159.291L109.273 159.472L107.186 160.698Z",
    fill: "#5A5A5A"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M109.273 159.473L111.317 167.456L109.225 168.678L107.186 160.698L109.273 159.473Z",
    fill: "#929292"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M119.793 101.256L118.527 101.03L117.439 96.668L118.612 96.8531L119.793 101.256Z",
    fill: "#151720"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M118.209 97.1271L116.984 96.942L117.439 96.668L118.612 96.8531L118.209 97.1271Z",
    fill: "#181B25"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M119.341 101.481L118.072 101.296L116.984 96.9414L118.209 97.1266L119.341 101.481Z",
    fill: "#151720"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M114.667 115.639L113.446 115.461L114.264 114.961L115.489 115.187L114.667 115.639Z",
    fill: "#946823"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M121.067 78.6181L119.842 78.3441L124.102 75.8965L125.324 76.1224L121.067 78.6181Z",
    fill: "#181B25"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M123.601 69.4535L122.424 69.1795L121.88 67.1836L123.102 67.3613L123.601 69.4535Z",
    fill: "#151720"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M114.219 115.915L112.993 115.685L113.445 115.463L114.666 115.641L114.219 115.915Z",
    fill: "#946823"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M115.94 103.478L114.715 103.207L115.537 102.752L116.758 102.982L115.94 103.478Z",
    fill: "#181B25"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M119.16 116.091L117.935 115.866L114.715 103.209L115.94 103.479L119.16 116.091Z",
    fill: "#151720"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M113.396 116.365L112.171 116.187L112.993 115.684L114.218 115.913L113.396 116.365Z",
    fill: "#946823"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M115.077 122.944L113.811 122.718L112.171 116.189L113.396 116.367L115.077 122.944Z",
    fill: "#7F591E"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M121.066 78.6193L119.841 78.3453L119.341 76.3457L120.526 76.5271L121.066 78.6193Z",
    fill: "#828282"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M124.83 74.0781L125.323 76.1221L121.066 78.6179L120.526 76.5258L124.83 74.0781Z",
    fill: "#F3F3F3"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M120.526 76.5268L119.341 76.3454L123.601 73.8496L124.83 74.0792L120.526 76.5268Z",
    fill: "#969696"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M118.709 116.365L115.489 103.753L115.94 103.479L119.16 116.091L118.709 116.365Z",
    fill: "#272C3C"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M115.488 103.753L114.263 103.479L114.715 103.209L115.94 103.479L115.488 103.753Z",
    fill: "#181B25"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M118.708 116.365L117.483 116.139L114.263 103.479L115.488 103.753L118.708 116.365Z",
    fill: "#151720"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M107.455 169.678L106.278 169.452L103.647 159.291L104.872 159.561L107.455 169.678Z",
    fill: "#151720"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M114.667 104.204L113.446 103.93L114.264 103.479L115.489 103.753L114.667 104.204Z",
    fill: "#181B25"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M114.666 115.639L113.444 115.461L112.082 110.195L113.356 110.373L114.666 115.639Z",
    fill: "#151720"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M101.563 173.079L100.341 172.853L102.421 171.631L103.646 171.905L101.563 173.079Z",
    fill: "#181B25"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M112.042 118.813L110.821 118.635L110.45 117.184L111.676 117.361L112.042 118.813Z",
    fill: "#151720"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M114.219 115.916L112.994 115.686L111.632 110.473L112.898 110.65L114.219 115.916Z",
    fill: "#151720"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M112.898 110.647L111.632 110.469L112.084 110.195L113.357 110.373L112.898 110.647Z",
    fill: "#181B25"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M114.17 130.702L112.896 130.517L109.998 119.086L111.22 119.312L114.17 130.702Z",
    fill: "#151720"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 119.312L109.998 119.087L110.82 118.635L112.041 118.813L111.22 119.312Z",
    fill: "#181B25"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M116.758 102.983L115.536 102.754L113.989 96.8066L115.263 97.0399L116.758 102.983Z",
    fill: "#151720"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M110.769 119.541L109.548 119.356L109.999 119.086L111.221 119.312L110.769 119.541Z",
    fill: "#181B25"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M113.719 130.977L112.446 130.792L109.548 119.357L110.769 119.543L113.719 130.977Z",
    fill: "#151720"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M119.342 71.9013L118.121 71.6755L122.425 69.1797L123.602 69.4537L119.342 71.9013Z",
    fill: "#181B25"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M110.82 117.861L109.636 117.635L110.45 117.184L111.675 117.361L110.82 117.861Z",
    fill: "#946823"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M114.441 97.4917L113.171 97.3065L113.989 96.8066L115.262 97.0399L114.441 97.4917Z",
    fill: "#946823"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M102.789 160.739L101.564 160.513L103.648 159.291L104.873 159.561L102.789 160.739Z",
    fill: "#5A5A5A"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M105.372 170.906L104.147 170.632L101.564 160.512L102.789 160.738L105.372 170.906Z",
    fill: "#4E4E4E"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M110.407 118.135L109.178 117.909L109.637 117.635L110.821 117.861L110.407 118.135Z",
    fill: "#946823"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M109.951 120.042L108.729 119.813L109.547 119.357L110.769 119.543L109.951 120.042Z",
    fill: "#181B25"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M113.99 97.7658L112.72 97.5807L113.172 97.3066L114.441 97.4918L113.99 97.7658Z",
    fill: "#946823"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M119.343 71.9007L118.121 71.6749L117.621 69.6309L118.798 69.8567L119.343 71.9007Z",
    fill: "#828282"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M118.798 69.8571L117.621 69.6312L121.882 67.1836L123.103 67.3613L118.798 69.8571Z",
    fill: "#969696"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M108.325 127.164L107.1 126.894L107.551 126.664L108.773 126.894L108.325 127.164Z",
    fill: "#181B25"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M110.82 117.86L109.636 117.635L109.088 115.639L110.361 115.913L110.82 117.86Z",
    fill: "#151720"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M109.951 120.042L108.729 119.813L108.366 118.361L109.547 118.635L109.951 120.042Z",
    fill: "#7F591E"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M109.547 118.634L108.366 118.36L109.177 117.908L110.406 118.134L109.547 118.634Z",
    fill: "#946823"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M111.676 117.361L112.043 118.813L111.221 119.313L110.769 119.542L109.951 120.042L109.548 118.635L110.407 118.135L110.821 117.861L111.676 117.361Z",
    fill: "#EFA838"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M109.909 116.139L108.64 115.913L109.088 115.639L110.361 115.913L109.909 116.139Z",
    fill: "#181B25"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M110.405 118.134L109.177 117.908L108.64 115.912L109.909 116.138L110.405 118.134Z",
    fill: "#151720"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M115.262 97.041L116.758 102.984L115.94 103.48L115.488 103.754L114.667 104.206L113.171 98.2148L113.989 97.7668L114.441 97.4928L115.262 97.041Z",
    fill: "#EFA838"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M113.171 98.2133L111.898 98.0355L112.72 97.5801L113.989 97.7652L113.171 98.2133Z",
    fill: "#946823"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M114.667 104.206L113.445 103.932L111.898 98.0371L113.171 98.2149L114.667 104.206Z",
    fill: "#7F591E"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M114.441 97.493L113.171 97.3079L112.398 94.2715L113.627 94.4974L114.441 97.493Z",
    fill: "#151720"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M113.989 97.7658L112.719 97.5806L111.946 94.4961L113.171 94.7664L113.989 97.7658Z",
    fill: "#151720"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M113.171 94.7677L111.946 94.4974L112.397 94.2715L113.626 94.4974L113.171 94.7677Z",
    fill: "#181B25"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7515 175.306L96.4856 175.08L98.5695 173.902L99.8391 174.08L97.7515 175.306Z",
    fill: "#181B25"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M107.005 120.083L105.783 119.857L106.601 119.357L107.823 119.631L107.005 120.083Z",
    fill: "#181B25"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M108.774 126.893L107.553 126.663L105.783 119.857L107.005 120.083L108.774 126.893Z",
    fill: "#151720"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M106.553 120.357L105.331 120.083L105.783 119.857L107.004 120.083L106.553 120.357Z",
    fill: "#181B25"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M108.326 127.162L107.101 126.892L105.331 120.082L106.553 120.356L108.326 127.162Z",
    fill: "#151720"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M105.735 120.808L104.51 120.582L105.332 120.082L106.553 120.356L105.735 120.808Z",
    fill: "#181B25"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M107.822 119.632L106.6 119.358L103.736 108.064L104.92 108.29L107.822 119.632Z",
    fill: "#151720"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M104.921 108.287L107.823 119.629L107.005 120.081L106.553 120.355L105.735 120.807L102.837 109.468L103.648 109.009L104.107 108.746L104.921 108.287Z",
    fill: "#E55622"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M108.326 127.162L106.553 120.356L107.005 120.082L108.774 126.892L108.326 127.162Z",
    fill: "#272C3C"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M104.558 129.617L103.333 129.384L103.737 129.158L105.01 129.343L104.558 129.617Z",
    fill: "#181B25"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M103.648 171.905L102.423 171.631L98.3918 156.02L99.6577 156.201L103.648 171.905Z",
    fill: "#151720"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8381 174.078L98.5685 173.901L96.0256 163.732L97.2101 163.958L99.8381 174.078Z",
    fill: "#151720"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9419 177.526L92.676 177.252L94.7562 176.074L96.0258 176.3L93.9419 177.526Z",
    fill: "#181B25"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M101.564 173.081L100.343 172.855L96.301 157.203L97.5706 157.477L101.564 173.081Z",
    fill: "#4E4E4E"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5706 157.475L96.301 157.201L98.3923 156.02L99.6582 156.201L97.5706 157.475Z",
    fill: "#5A5A5A"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6572 156.201L103.647 171.905L101.563 173.079L97.5696 157.475L99.6572 156.201Z",
    fill: "#929292"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1268 165.188L93.9016 164.914L96.0262 163.732L97.2107 163.958L95.1268 165.188Z",
    fill: "#5A5A5A"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7511 175.306L96.4852 175.081L93.9016 164.916L95.1268 165.19L97.7511 175.306Z",
    fill: "#4E4E4E"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0268 176.302L94.7572 176.076L92.5364 167.318L93.7578 167.544L96.0268 176.302Z",
    fill: "#151720"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M104.107 108.749L102.878 108.561L103.737 108.064L104.921 108.29L104.107 108.749Z",
    fill: "#8E3515"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M103.648 109.01L102.467 108.788L102.878 108.559L104.107 108.747L103.648 109.01Z",
    fill: "#8E3515"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0897 179.708L88.8645 179.523L90.9484 178.297L92.1773 178.523L90.0897 179.708Z",
    fill: "#181B25"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M102.836 109.472L101.611 109.287L102.466 108.791L103.646 109.013L102.836 109.472Z",
    fill: "#8E3515"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M105.734 120.809L104.509 120.583L101.611 109.285L102.836 109.47L105.734 120.809Z",
    fill: "#7A2E12"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1759 178.522L90.947 178.296L89.6848 173.441L90.947 173.715L92.1759 178.522Z",
    fill: "#151720"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M104.107 108.75L102.878 108.561L102.112 105.48L103.333 105.754L104.107 108.75Z",
    fill: "#151720"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M105.009 129.345L103.735 129.16L100.204 115.277L101.47 115.503L105.009 129.345Z",
    fill: "#151720"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M101.47 115.503L100.204 115.278L101.019 114.818L102.288 115.004L101.47 115.503Z",
    fill: "#181B25"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9433 177.528L92.6774 177.254L90.4084 168.541L91.678 168.726L93.9433 177.528Z",
    fill: "#4E4E4E"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M91.678 168.725L90.4084 168.54L92.5368 167.318L93.7582 167.544L91.678 168.725Z",
    fill: "#5A5A5A"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7572 167.543L96.0262 176.3L93.9423 177.526L91.677 168.724L93.7572 167.543Z",
    fill: "#929292"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M99.295 126.351L98.0735 126.077L98.5214 125.803L99.7465 126.077L99.295 126.351Z",
    fill: "#181B25"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M102.925 105.977L101.652 105.754L102.111 105.48L103.332 105.754L102.925 105.977Z",
    fill: "#181B25"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M103.647 109.012L102.466 108.79L101.652 105.754L102.925 105.976L103.647 109.012Z",
    fill: "#151720"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M102.925 105.976L103.332 105.754L104.106 108.75L103.647 109.012L102.925 105.976Z",
    fill: "#272C3C"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M104.558 129.618L103.333 129.385L99.7463 115.551L101.02 115.777L104.558 129.618Z",
    fill: "#151720"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M101.02 115.777L99.7466 115.551L100.206 115.277L101.471 115.503L101.02 115.777Z",
    fill: "#181B25"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2578 154.21L92.0364 153.932L92.4917 153.662L93.7168 153.932L93.2578 154.21Z",
    fill: "#181B25"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M100.205 116.277L98.9319 116.003L99.7462 115.551L101.019 115.777L100.205 116.277Z",
    fill: "#181B25"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M102.289 115.001L101.02 114.816L99.8909 110.283L101.112 110.509L102.289 115.001Z",
    fill: "#151720"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0887 179.71L88.8636 179.524L87.594 174.67L88.8636 174.896L90.0887 179.71Z",
    fill: "#4E4E4E"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8636 174.893L87.594 174.667L89.6853 173.441L90.9475 173.715L88.8636 174.893Z",
    fill: "#5A5A5A"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M100.294 110.968L99.0686 110.735L99.8903 110.283L101.112 110.509L100.294 110.968Z",
    fill: "#8E3515"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8399 111.233L98.6184 111.01L99.07 110.736L100.295 110.97L99.8399 111.233Z",
    fill: "#8E3515"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M86.233 181.93L85.0559 181.704L87.1435 180.52L88.3169 180.705L86.233 181.93Z",
    fill: "#181B25"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M100.204 116.277L98.9307 116.003L97.7981 111.467L99.0196 111.737L100.204 116.277Z",
    fill: "#7A2E12"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0196 111.736L97.7981 111.465L98.6161 111.01L99.8376 111.232L99.0196 111.736Z",
    fill: "#8E3515"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M88.317 180.704L87.1436 180.519L85.8704 175.664L87.1436 175.89L88.317 180.704Z",
    fill: "#151720"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M100.294 110.971L99.0692 110.737L97.9329 106.379L99.2061 106.612L100.294 110.971Z",
    fill: "#151720"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7473 106.884L99.2063 106.613L100.294 110.972L99.8392 111.235L98.7473 106.884Z",
    fill: "#272C3C"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7466 106.883L97.4807 106.657L97.9323 106.379L99.2056 106.612L98.7466 106.883Z",
    fill: "#181B25"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8385 111.233L98.617 111.011L97.4807 106.656L98.7466 106.882L99.8385 111.233Z",
    fill: "#151720"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M86.232 181.93L85.055 181.704L83.7854 176.891L85.055 177.076L86.232 181.93Z",
    fill: "#4E4E4E"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1435 175.893L88.3169 180.706L86.233 181.932L85.0559 177.078L87.1435 175.893Z",
    fill: "#929292"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M85.055 177.075L83.7854 176.89L85.8693 175.664L87.1426 175.89L85.055 177.075Z",
    fill: "#5A5A5A"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7454 126.073L98.5203 125.799L95.3 113.279L96.5733 113.464L99.7454 126.073Z",
    fill: "#151720"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5733 113.466L95.3 113.281L96.1218 112.781L97.3913 113.007L96.5733 113.466Z",
    fill: "#181B25"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M92.628 134.514L91.4065 134.333L91.8581 134.062L93.0795 134.24L92.628 134.514Z",
    fill: "#181B25"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7169 153.931L92.4918 153.661L89.7268 142.859L90.9483 143.133L93.7169 153.931Z",
    fill: "#151720"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9483 143.134L89.7268 142.86L90.5374 142.412L91.77 142.638L90.9483 143.134Z",
    fill: "#181B25"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1216 113.731L94.8521 113.553L95.2999 113.279L96.5732 113.464L96.1216 113.731Z",
    fill: "#181B25"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2935 126.348L98.072 126.074L94.8518 113.555L96.1214 113.732L99.2935 126.348Z",
    fill: "#151720"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4961 143.359L89.2747 143.133L89.7262 142.859L90.9477 143.133L90.4961 143.359Z",
    fill: "#181B25"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2574 154.21L92.0359 153.932L89.2747 143.135L90.4961 143.361L93.2574 154.21Z",
    fill: "#151720"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2576 154.21L90.4963 143.361L90.9479 143.135L93.7166 153.932L93.2576 154.21Z",
    fill: "#272C3C"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0803 134.24L91.8588 134.063L91.0852 131.115L92.3104 131.341L93.0803 134.24Z",
    fill: "#151720"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3104 131.339L91.0852 131.113L91.9476 130.654L93.1284 130.88L92.3104 131.339Z",
    fill: "#181B25"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3001 114.229L94.0305 114.006L94.8522 113.555L96.1218 113.732L95.3001 114.229Z",
    fill: "#181B25"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4229 184.151L81.2014 183.925L83.2853 182.703L84.5105 182.925L82.4229 184.151Z",
    fill: "#181B25"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6852 143.861L88.4563 143.59L89.2743 143.135L90.4958 143.361L89.6852 143.861Z",
    fill: "#181B25"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6278 134.514L91.4064 134.332L90.6809 131.381L91.858 131.614L92.6278 134.514Z",
    fill: "#151720"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M91.858 131.615L90.6809 131.382L91.0844 131.115L92.3095 131.341L91.858 131.615Z",
    fill: "#181B25"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0362 132.062L89.8147 131.881L90.6808 131.381L91.8579 131.614L91.0362 132.062Z",
    fill: "#181B25"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1288 130.881L91.9481 130.655L89.0425 119.357L90.2232 119.543L93.1288 130.881Z",
    fill: "#151720"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2228 119.543L93.1284 130.881L92.3104 131.34L91.8588 131.614L91.0371 132.063L88.1389 120.769L88.9606 120.269L89.4085 120.043L90.2228 119.543Z",
    fill: "#EFA838"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6276 134.513L91.8577 131.614L92.3092 131.34L93.0791 134.239L92.6276 134.513Z",
    fill: "#272C3C"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2208 119.814L92.0364 119.544L92.4917 119.27L93.6761 119.544L93.2208 119.814Z",
    fill: "#181B25"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M84.511 182.926L83.2859 182.704L81.4241 175.354L82.6048 175.531L84.511 182.926Z",
    fill: "#151720"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4615 148.579L86.2327 148.397L86.6916 148.127L87.865 148.357L87.4615 148.579Z",
    fill: "#181B25"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8054 116.318L92.584 116.093L92.3101 115.004L93.5315 115.23L93.8054 116.318Z",
    fill: "#151720"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M93.675 119.541L92.4906 119.267L91.7688 116.545L92.9903 116.815L93.675 119.541Z",
    fill: "#151720"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9903 116.818L91.7688 116.547L92.5831 116.092L93.8046 116.318L92.9903 116.818Z",
    fill: "#181B25"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 157.838L84.1965 157.653L84.6444 157.379L85.8696 157.605L85.418 157.838Z",
    fill: "#181B25"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5841 117.045L91.3108 116.815L91.7698 116.545L92.9912 116.815L92.5841 117.045Z",
    fill: "#181B25"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2207 119.812L92.0363 119.542L91.3108 116.816L92.5841 117.046L93.2207 119.812Z",
    fill: "#151720"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7215 117.546L90.4963 117.272L91.3106 116.816L92.5839 117.046L91.7215 117.546Z",
    fill: "#181B25"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5314 115.23L93.8053 116.319L92.991 116.819L92.5838 117.049L91.7214 117.549L91.4475 116.456L92.2692 115.956L92.7171 115.73L93.5314 115.23Z",
    fill: "#EFA838"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2199 119.812L92.5833 117.046L92.9904 116.816L93.6752 119.542L93.2199 119.812Z",
    fill: "#272C3C"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7168 115.73L91.4954 115.463L92.3097 115.004L93.5311 115.23L92.7168 115.73Z",
    fill: "#946823"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1414 145.407L85.9163 145.174L86.7269 144.674L87.9594 144.948L87.1414 145.407Z",
    fill: "#181B25"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8632 148.355L86.6899 148.125L85.9163 145.174L87.1414 145.407L87.8632 148.355Z",
    fill: "#151720"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7695 142.639L90.537 142.413L88.0422 132.789L89.3155 132.974L91.7695 142.639Z",
    fill: "#151720"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2699 115.955L91.0374 115.73L91.4963 115.463L92.7178 115.73L92.2699 115.955Z",
    fill: "#946823"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4615 148.578L86.6917 145.675L87.1432 145.408L87.865 148.356L87.4615 148.578Z",
    fill: "#272C3C"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4611 148.578L86.2323 148.396L85.4661 145.408L86.6912 145.675L87.4611 148.578Z",
    fill: "#151720"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6912 145.674L85.4661 145.407L85.9176 145.174L87.1428 145.407L86.6912 145.674Z",
    fill: "#181B25"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9607 144.949L86.7282 144.675L86.0471 141.953L87.276 142.179L87.9607 144.949Z",
    fill: "#151720"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M88.502 133.474L87.2288 133.241L88.0431 132.789L89.3164 132.974L88.502 133.474Z",
    fill: "#8E3515"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6054 175.529L84.5116 182.924L82.424 184.15L80.5178 176.751L82.6054 175.529Z",
    fill: "#929292"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4236 184.152L81.2021 183.926L79.344 176.527L80.5173 176.753L82.4236 184.152Z",
    fill: "#4E4E4E"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5173 176.753L79.344 176.527L81.4242 175.354L82.6049 175.531L80.5173 176.753Z",
    fill: "#5A5A5A"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M91.721 117.548L90.4958 117.274L90.2219 116.189L91.4471 116.456L91.721 117.548Z",
    fill: "#7F591E"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4471 116.454L90.2219 116.188L91.0362 115.729L92.2688 115.954L91.4471 116.454Z",
    fill: "#946823"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6109 186.337L77.345 186.148L79.4326 184.926L80.7021 185.152L78.6109 186.337Z",
    fill: "#181B25"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8699 146.134L84.6448 145.904L85.4665 145.408L86.6917 145.675L85.8699 146.134Z",
    fill: "#181B25"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4169 142.679L85.2324 142.412L86.0467 141.953L87.2756 142.179L86.4169 142.679Z",
    fill: "#8E3515"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0427 133.697L86.7805 133.512L87.2284 133.238L88.5017 133.472L88.0427 133.697Z",
    fill: "#8E3515"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3919 113.008L96.1223 112.782L92.717 99.4883L93.9422 99.666L97.3919 113.008Z",
    fill: "#151720"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0067 142.912L84.7815 142.679L85.2331 142.412L86.4175 142.679L86.0067 142.912Z",
    fill: "#8E3515"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M89.686 143.859L88.4571 143.589L85.9661 133.973L87.2282 134.199L89.686 143.859Z",
    fill: "#7A2E12"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2282 134.201L85.9661 133.975L86.7804 133.516L88.0426 133.701L87.2282 134.201Z",
    fill: "#8E3515"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1272 100.166L91.9058 99.94L92.7164 99.4883L93.9415 99.666L93.1272 100.166Z",
    fill: "#946823"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1441 143.407L83.967 143.133L84.7813 142.678L86.0065 142.911L85.1441 143.407Z",
    fill: "#8E3515"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8696 146.134L84.6444 145.905L83.967 143.135L85.1441 143.409L85.8696 146.134Z",
    fill: "#7A2E12"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4085 120.042L88.2278 119.813L89.0421 119.357L90.2228 119.543L89.4085 120.042Z",
    fill: "#946823"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7032 185.153L79.4336 184.927L77.4348 176.939L78.66 177.165L80.7032 185.153Z",
    fill: "#151720"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6764 100.437L91.4475 100.212L91.9065 99.9375L93.128 100.163L92.6764 100.437Z",
    fill: "#946823"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9601 120.268L87.7756 120.083L88.2272 119.812L89.408 120.042L88.9601 120.268Z",
    fill: "#946823"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5012 133.473L87.2279 133.239L86.0471 128.525L87.276 128.707L88.5012 133.473Z",
    fill: "#151720"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4174 142.679L85.2329 142.412L84.1965 138.506L85.418 138.691L86.4174 142.679Z",
    fill: "#151720"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8201 128.981L85.595 128.748L86.0465 128.525L87.2754 128.707L86.8201 128.981Z",
    fill: "#181B25"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0416 133.697L86.7794 133.512L85.595 128.746L86.8201 128.979L88.0416 133.697Z",
    fill: "#151720"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9661 138.958L83.7854 138.732L84.1963 138.506L85.4177 138.691L84.9661 138.958Z",
    fill: "#181B25"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9661 138.958L85.4176 138.691L86.417 142.679L86.0062 142.913L84.9661 138.958Z",
    fill: "#272C3C"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0062 142.913L84.7811 142.68L83.7854 138.732L84.9661 138.958L86.0062 142.913Z",
    fill: "#151720"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7172 115.727L91.4958 115.461L89.4563 107.562L90.6815 107.748L92.7172 115.727Z",
    fill: "#151720"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1282 100.165L91.9067 99.9386L91.2219 97.3984L92.4915 97.628L93.1282 100.165Z",
    fill: "#151720"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8705 157.605L84.6453 157.38L82.0618 147.396L83.3276 147.582L85.8705 157.605Z",
    fill: "#151720"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3276 147.582L82.0618 147.397L82.8761 146.904L84.1494 147.13L83.3276 147.582Z",
    fill: "#181B25"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9416 99.6641L97.3913 113.006L96.5733 113.465L96.1217 113.731L95.3 114.228L91.8577 100.934L92.6757 100.438L93.1273 100.164L93.9416 99.6641Z",
    fill: "#EFA838"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8592 100.935L90.634 100.665L91.4483 100.213L92.6772 100.439L91.8592 100.935Z",
    fill: "#946823"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3015 114.23L94.0319 114.008L90.634 100.666L91.8592 100.936L95.3015 114.23Z",
    fill: "#7F591E"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1382 120.767L86.9612 120.541L87.7755 120.082L88.9599 120.267L88.1382 120.767Z",
    fill: "#946823"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0364 132.063L89.815 131.881L86.9612 120.543L88.1382 120.769L91.0364 132.063Z",
    fill: "#7F591E"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2696 115.956L91.037 115.73L89.0012 107.791L90.2227 108.017L92.2696 115.956Z",
    fill: "#151720"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2219 108.017L90.6809 107.75L92.7167 115.73L92.2688 115.956L90.2219 108.017Z",
    fill: "#272C3C"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2227 108.014L89.0012 107.788L89.4565 107.562L90.6817 107.748L90.2227 108.014Z",
    fill: "#181B25"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6763 100.438L91.4474 100.212L90.8108 97.668L92.036 97.8975L92.6763 100.438Z",
    fill: "#151720"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M92.036 97.8983L90.8108 97.6688L91.2216 97.3984L92.4912 97.628L92.036 97.8983Z",
    fill: "#181B25"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4182 157.838L84.1967 157.653L81.6057 147.629L82.8753 147.855L85.4182 157.838Z",
    fill: "#151720"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8753 147.856L81.6057 147.63L82.061 147.396L83.3269 147.582L82.8753 147.856Z",
    fill: "#181B25"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4181 157.839L82.8752 147.856L83.3268 147.582L85.8697 157.606L85.4181 157.839Z",
    fill: "#272C3C"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8025 188.557L73.5403 188.324L75.6168 187.146L76.8901 187.324L74.8025 188.557Z",
    fill: "#181B25"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6108 186.338L77.3449 186.149L75.3499 178.162L76.5713 178.351L78.6108 186.338Z",
    fill: "#4E4E4E"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5713 178.35L75.3499 178.161L77.4337 176.939L78.6589 177.165L76.5713 178.35Z",
    fill: "#5A5A5A"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0608 148.307L80.7913 148.125L81.6056 147.629L82.8751 147.855L82.0608 148.307Z",
    fill: "#181B25"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8895 187.325L75.6162 187.147L74.0764 180.934L75.2609 181.156L76.8895 187.325Z",
    fill: "#151720"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1492 147.131L82.876 146.905L81.1067 139.869L82.3282 140.139L84.1492 147.131Z",
    fill: "#151720"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6099 152.387L78.4329 152.21L78.8844 151.936L80.0652 152.121L79.6099 152.387Z",
    fill: "#181B25"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5127 140.591L80.2913 140.369L81.1056 139.869L82.327 140.139L81.5127 140.591Z",
    fill: "#8E3515"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4089 120.04L88.2281 119.811L85.7815 110.283L86.9622 110.468L89.4089 120.04Z",
    fill: "#151720"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M81.065 140.867L79.8362 140.589L80.2915 140.367L81.5129 140.589L81.065 140.867Z",
    fill: "#8E3515"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5062 110.735L85.3254 110.509L85.7807 110.283L86.9615 110.468L86.5062 110.735Z",
    fill: "#181B25"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9602 120.269L87.7758 120.084L85.3254 110.512L86.5062 110.738L88.9602 120.269Z",
    fill: "#151720"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2615 181.156L76.8901 187.325L74.8025 188.558L73.1702 182.341L75.2615 181.156Z",
    fill: "#929292"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1697 182.341L71.9446 182.156L74.0766 180.934L75.261 181.156L73.1697 182.341Z",
    fill: "#5A5A5A"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8021 188.559L73.5399 188.325L71.9446 182.156L73.1697 182.341L74.8021 188.559Z",
    fill: "#4E4E4E"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2496 141.323L79.0208 141.09L79.8351 140.59L81.0639 140.868L80.2496 141.323Z",
    fill: "#8E3515"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0596 148.307L80.79 148.125L79.0208 141.09L80.2496 141.323L82.0596 148.307Z",
    fill: "#7A2E12"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3267 140.139L84.1478 147.13L83.3261 147.582L82.8745 147.856L82.0602 148.307L80.2502 141.324L81.0646 140.868L81.5124 140.59L82.3267 140.139Z",
    fill: "#E55622"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5121 140.591L80.2906 140.369L79.5208 137.236L80.7015 137.462L81.5121 140.591Z",
    fill: "#151720"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9492 190.779L69.7278 190.554L71.808 189.324L73.0405 189.554L70.9492 190.779Z",
    fill: "#181B25"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0656 140.868L79.8368 140.591L79.0706 137.51L80.2513 137.695L81.0656 140.868Z",
    fill: "#151720"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2502 137.694L80.7018 137.461L81.5124 140.59L81.0646 140.868L80.2502 137.694Z",
    fill: "#272C3C"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2513 137.695L79.0706 137.51L79.5221 137.236L80.7029 137.462L80.2513 137.695Z",
    fill: "#181B25"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0397 189.552L71.8071 189.323L70.4487 184.102L71.7183 184.335L73.0397 189.552Z",
    fill: "#151720"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0651 152.121L78.8844 151.936L76.4377 142.59L77.7073 142.775L80.0651 152.121Z",
    fill: "#151720"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7073 142.773L76.4377 142.588L77.2558 142.088L78.5216 142.314L77.7073 142.773Z",
    fill: "#181B25"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7189 184.336L73.0403 189.553L70.949 190.779L69.635 185.558L71.7189 184.336Z",
    fill: "#929292"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6358 185.557L68.3625 185.335L70.4501 184.102L71.7197 184.335L69.6358 185.557Z",
    fill: "#5A5A5A"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9498 190.779L69.7284 190.553L68.3625 185.336L69.6358 185.558L70.9498 190.779Z",
    fill: "#4E4E4E"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M79.611 152.387L78.434 152.209L75.9836 142.859L77.2569 143.045L79.611 152.387Z",
    fill: "#151720"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2569 143.045L75.9836 142.86L76.4389 142.59L77.7085 142.775L77.2569 143.045Z",
    fill: "#181B25"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4386 143.5L75.1653 143.315L75.9833 142.859L77.2566 143.045L76.4386 143.5Z",
    fill: "#181B25"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0923 193.002L65.9153 192.776L68.0029 191.551L69.1799 191.777L67.0923 193.002Z",
    fill: "#181B25"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5225 142.316L77.2566 142.09L75.1653 133.877L76.4386 134.151L78.5225 142.316Z",
    fill: "#151720"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M73.895 147.039L72.6292 146.806L73.0807 146.58L74.3503 146.765L73.895 147.039Z",
    fill: "#181B25"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1797 191.774L68.0026 191.548L65.7336 182.791L67.0032 183.013L69.1797 191.774Z",
    fill: "#151720"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6177 134.61L74.3518 134.377L75.1661 133.877L76.4394 134.151L75.6177 134.61Z",
    fill: "#8E3515"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1653 134.875L73.8958 134.608L74.351 134.375L75.6169 134.608L75.1653 134.875Z",
    fill: "#8E3515"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6162 134.61L74.3503 134.377L74.0764 133.203L75.3016 133.425L75.6162 134.61Z",
    fill: "#151720"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1658 134.878L73.8962 134.611L73.6223 133.475L74.8512 133.7L75.1658 134.878Z",
    fill: "#151720"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8512 133.699L73.6223 133.473L74.0776 133.203L75.3028 133.425L74.8512 133.699Z",
    fill: "#181B25"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3509 135.331L73.0813 135.106L73.8956 134.609L75.1652 134.876L74.3509 135.331Z",
    fill: "#8E3515"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4385 143.502L75.1652 143.317L73.0813 135.107L74.3509 135.333L76.4385 143.502Z",
    fill: "#7A2E12"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2869 195.175L62.0618 194.949L64.1864 193.775L65.3671 193.998L63.2869 195.175Z",
    fill: "#181B25"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0034 183.014L69.1798 191.775L67.0922 193L64.8713 184.239L67.0034 183.014Z",
    fill: "#929292"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0918 193.002L65.9147 192.776L63.6458 183.967L64.8709 184.241L67.0918 193.002Z",
    fill: "#4E4E4E"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8709 184.239L63.6458 183.965L65.7333 182.791L67.0029 183.013L64.8709 184.239Z",
    fill: "#5A5A5A"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3674 193.998L64.1867 193.776L62.5618 187.559L63.8313 187.781L65.3674 193.998Z",
    fill: "#151720"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7684 136.783L70.5432 136.598L71.3612 136.098L72.5827 136.331L71.7684 136.783Z",
    fill: "#181B25"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M74.352 146.766L73.0824 146.581L70.5432 136.598L71.7684 136.783L74.352 146.766Z",
    fill: "#151720"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8959 147.041L72.63 146.808L70.0872 136.873L71.3086 137.058L73.8959 147.041Z",
    fill: "#151720"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3086 137.057L70.0872 136.872L70.5424 136.598L71.7676 136.783L71.3086 137.057Z",
    fill: "#181B25"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M63.287 195.176L62.0618 194.95L60.4702 188.781L61.7398 189.011L63.287 195.176Z",
    fill: "#4E4E4E"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8318 187.779L65.3679 193.997L63.2877 195.174L61.7405 189.009L63.8318 187.779Z",
    fill: "#929292"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7398 189.01L60.4702 188.781L62.5615 187.559L63.8311 187.781L61.7398 189.01Z",
    fill: "#5A5A5A"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6468 175.715L62.3772 175.485L62.8325 175.256L64.0983 175.437L63.6468 175.715Z",
    fill: "#181B25"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4979 137.51L69.2727 137.332L70.087 136.873L71.3085 137.058L70.4979 137.51Z",
    fill: "#181B25"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M59.471 197.397L58.2495 197.175L60.3408 195.949L61.5623 196.175L59.471 197.397Z",
    fill: "#181B25"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2896 183.742L60.1125 183.52L60.5641 183.246L61.7412 183.52L61.2896 183.742Z",
    fill: "#181B25"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M64.919 163.459L63.6458 163.233L64.0973 162.959L65.3669 163.192L64.919 163.459Z",
    fill: "#181B25"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1058 171.536L61.8362 171.31L62.6505 170.811L63.9201 171.085L63.1058 171.536Z",
    fill: "#181B25"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0977 175.439L62.8319 175.258L61.8362 171.311L63.1058 171.536L64.0977 175.439Z",
    fill: "#151720"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5625 196.174L60.341 195.948L58.4348 188.598L59.6563 188.82L61.5625 196.174Z",
    fill: "#151720"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6865 160.648L63.4651 160.422L64.2831 159.922L65.5083 160.196L64.6865 160.648Z",
    fill: "#181B25"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3679 163.194L64.0983 162.96L63.4653 160.424L64.6868 160.65L65.3679 163.194Z",
    fill: "#151720"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6515 171.81L61.3782 171.536L61.8371 171.311L63.1067 171.536L62.6515 171.81Z",
    fill: "#181B25"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6471 175.716L62.3776 175.486L61.3782 171.535L62.6515 171.809L63.6471 175.716Z",
    fill: "#151720"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7402 183.517L60.5631 183.243L59.7932 180.34L61.0147 180.614L61.7402 183.517Z",
    fill: "#151720"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0147 180.616L59.7932 180.342L60.6149 179.887L61.8364 180.116L61.0147 180.616Z",
    fill: "#181B25"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9192 163.457L63.6459 163.231L63.0129 160.646L64.2344 160.921L64.9192 163.457Z",
    fill: "#151720"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2344 160.924L63.0129 160.65L63.4645 160.424L64.686 160.65L64.2344 160.924Z",
    fill: "#181B25"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4215 161.372L62.1926 161.143L63.0143 160.646L64.2358 160.921L63.4215 161.372Z",
    fill: "#181B25"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5078 160.198L64.2827 159.924L60.5627 145.312L61.7398 145.498L65.5078 160.198Z",
    fill: "#151720"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7394 145.498L65.5074 160.199L64.6857 160.65L64.2342 160.924L63.4198 161.376L59.6555 146.768L60.4698 146.268L60.9251 145.994L61.7394 145.498Z",
    fill: "#EFA838"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9194 163.457L64.2346 160.921L64.6862 160.646L65.3673 163.19L64.9194 163.457Z",
    fill: "#272C3C"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M61.289 183.739L60.1119 183.516L59.342 180.613L60.5635 180.839L61.289 183.739Z",
    fill: "#151720"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2882 183.739L60.5627 180.839L61.0143 180.613L61.7398 183.516L61.2882 183.739Z",
    fill: "#272C3C"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5635 180.84L59.342 180.614L59.7936 180.34L61.0151 180.614L60.5635 180.84Z",
    fill: "#181B25"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M61.836 172.265L60.5627 172.035L61.3771 171.535L62.6503 171.809L61.836 172.265Z",
    fill: "#181B25"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M72.581 136.334L71.3595 136.101L68.9055 126.488L70.1344 126.714L72.581 136.334Z",
    fill: "#151720"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7442 181.339L58.5227 181.065L59.3407 180.613L60.5622 180.839L59.7442 181.339Z",
    fill: "#181B25"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7494 198.397L56.4762 198.172L55.8469 195.498L57.024 195.724L57.7494 198.397Z",
    fill: "#151720"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3675 148.216L64.1868 147.993L64.5976 147.768L65.8265 147.945L65.3675 148.216Z",
    fill: "#181B25"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6554 188.822L61.5617 196.176L59.4704 197.398L57.5715 190.007L59.6554 188.822Z",
    fill: "#929292"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4699 197.398L58.2485 197.176L56.3459 189.781L57.5711 190.007L59.4699 197.398Z",
    fill: "#4E4E4E"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5711 190.005L56.3459 189.779L58.4335 188.598L59.655 188.82L57.5711 190.005Z",
    fill: "#5A5A5A"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6626 199.623L54.3967 199.398L56.4769 198.172L57.7502 198.398L55.6626 199.623Z",
    fill: "#181B25"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4972 137.509L69.2721 137.331L66.8254 127.707L68.0025 127.892L70.4972 137.509Z",
    fill: "#7F591E"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0025 127.895L66.8254 127.71L68.9056 126.488L70.1345 126.714L68.0025 127.895Z",
    fill: "#946823"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M70.134 126.711L72.5806 136.331L71.7663 136.783L71.3073 137.057L70.4967 137.509L68.002 127.892L70.134 126.711Z",
    fill: "#EFA838"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9194 171.084L62.6498 170.81L60.3809 161.875L61.6097 162.097L63.9194 171.084Z",
    fill: "#151720"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0246 195.723L57.75 198.396L55.6625 199.622L54.9407 196.945L57.0246 195.723Z",
    fill: "#929292"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9408 196.946L53.76 196.72L55.8476 195.498L57.0246 195.724L54.9408 196.946Z",
    fill: "#5A5A5A"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6625 199.62L54.3967 199.394L53.76 196.717L54.9408 196.943L55.6625 199.62Z",
    fill: "#4E4E4E"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1814 134.241L65.0081 134.063L65.4189 133.789L66.6404 134.015L66.1814 134.241Z",
    fill: "#181B25"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8265 147.943L64.5977 147.766L63.2874 142.678L64.5569 142.911L65.8265 147.943Z",
    fill: "#151720"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5569 142.912L63.2874 142.678L64.098 142.227L65.3675 142.412L64.5569 142.912Z",
    fill: "#181B25"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7926 162.556L59.5637 162.327L60.3817 161.875L61.6106 162.097L60.7926 162.556Z",
    fill: "#8E3515"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3677 148.215L64.187 147.993L62.8323 142.953L64.0982 143.179L65.3677 148.215Z",
    fill: "#151720"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3675 148.215L64.0979 143.179L64.5569 142.912L65.8265 147.944L65.3675 148.215Z",
    fill: "#272C3C"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0982 143.178L62.8323 142.952L63.2875 142.678L64.5571 142.911L64.0982 143.178Z",
    fill: "#181B25"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3406 162.822L59.1155 162.596L59.5633 162.326L60.7922 162.556L60.3406 162.822Z",
    fill: "#8E3515"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2872 143.679L62.0139 143.409L62.8319 142.953L64.0978 143.179L63.2872 143.679Z",
    fill: "#181B25"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6098 162.096L63.9195 171.083L63.1052 171.534L62.6499 171.808L61.8356 172.264L59.5186 163.281L60.3403 162.821L60.7918 162.555L61.6098 162.096Z",
    fill: "#E55622"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8364 172.264L60.5631 172.035L58.2942 163.096L59.5194 163.281L61.8364 172.264Z",
    fill: "#7A2E12"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5194 163.283L58.2942 163.098L59.1159 162.598L60.3411 162.824L59.5194 163.283Z",
    fill: "#8E3515"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5076 129.523L64.2825 129.249L65.0968 128.797L66.3256 129.023L65.5076 129.523Z",
    fill: "#181B25"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6403 134.016L65.4188 133.79L64.2825 129.25L65.5076 129.524L66.6403 134.016Z",
    fill: "#151720"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1807 134.241L65.0074 134.063L63.8303 129.523L65.0555 129.797L66.1807 134.241Z",
    fill: "#151720"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0555 129.798L63.8303 129.524L64.2819 129.25L65.5071 129.524L65.0555 129.798Z",
    fill: "#181B25"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8575 201.803L50.5842 201.578L52.6718 200.393L53.9414 200.618L51.8575 201.803Z",
    fill: "#181B25"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9405 200.619L52.671 200.393L51.3088 195.176L52.5784 195.402L53.9405 200.619Z",
    fill: "#151720"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2344 130.249L63.0129 130.023L63.8309 129.523L65.0561 129.797L64.2344 130.249Z",
    fill: "#181B25"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8359 180.116L60.6145 179.886L56.6614 164.371L57.8421 164.641L61.8359 180.116Z",
    fill: "#151720"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9258 145.994L59.7043 145.772L60.5631 145.312L61.7401 145.498L60.9258 145.994Z",
    fill: "#946823"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1251 176.752L53.8999 176.526L54.3515 176.256L55.5729 176.485L55.1251 176.752Z",
    fill: "#181B25"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7925 162.556L59.5636 162.326L57.7092 155.109L58.9307 155.343L60.7925 162.556Z",
    fill: "#151720"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M57.024 165.093L55.8469 164.823L56.6612 164.371L57.842 164.641L57.024 165.093Z",
    fill: "#8E3515"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4693 146.268L59.2922 146.042L59.7031 145.771L60.9246 145.994L60.4693 146.268Z",
    fill: "#946823"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4717 155.609L57.2502 155.383L57.7092 155.109L58.9307 155.343L58.4717 155.609Z",
    fill: "#181B25"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3409 162.822L59.1158 162.596L57.2502 155.383L58.4717 155.609L60.3409 162.822Z",
    fill: "#151720"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5718 165.367L55.3948 165.093L55.8463 164.822L57.0234 165.093L56.5718 165.367Z",
    fill: "#8E3515"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4206 161.374L62.1917 161.145L58.4348 146.492L59.6563 146.766L63.4206 161.374Z",
    fill: "#7F591E"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6563 146.767L58.4348 146.493L59.2935 146.041L60.4706 146.267L59.6563 146.767Z",
    fill: "#946823"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3675 142.412L64.098 142.227L61.2405 130.881L62.4656 131.155L65.3675 142.412Z",
    fill: "#151720"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5793 195.402L53.9414 200.62L51.8575 201.805L50.4954 196.584L52.5793 195.402Z",
    fill: "#929292"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8566 201.805L50.5833 201.579L49.2249 196.361L50.4944 196.583L51.8566 201.805Z",
    fill: "#4E4E4E"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4947 196.583L49.2251 196.361L51.309 195.176L52.5786 195.402L50.4947 196.583Z",
    fill: "#5A5A5A"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7507 165.82L54.5774 165.594L55.3954 165.094L56.5725 165.368L55.7507 165.82Z",
    fill: "#8E3515"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7446 181.342L58.5231 181.068L54.5774 165.594L55.7507 165.82L59.7446 181.342Z",
    fill: "#7A2E12"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8425 164.639L61.8363 180.113L61.0146 180.613L60.563 180.839L59.745 181.339L55.7512 165.816L56.5729 165.364L57.0245 165.09L57.8425 164.639Z",
    fill: "#E55622"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6507 131.614L60.3811 131.381L61.2398 130.881L62.465 131.155L61.6507 131.614Z",
    fill: "#946823"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M48.001 204.022L46.7795 203.8L48.8634 202.615L50.0886 202.849L48.001 204.022Z",
    fill: "#181B25"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1968 131.881L59.9717 131.614L60.3825 131.381L61.6521 131.614L61.1968 131.881Z",
    fill: "#946823"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9261 145.993L59.7046 145.771L58.2056 139.824L59.4307 140.05L60.9261 145.993Z",
    fill: "#151720"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0885 202.847L48.8633 202.614L47.5012 197.355L48.7671 197.581L50.0885 202.847Z",
    fill: "#151720"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 140.329L59.4299 140.051L60.9253 145.994L60.47 146.268L58.9709 140.329Z",
    fill: "#272C3C"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9717 140.328L57.7502 140.095L58.2055 139.824L59.4307 140.05L58.9717 140.328Z",
    fill: "#181B25"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4708 146.265L59.2937 146.039L57.7502 140.092L58.9717 140.325L60.4708 146.265Z",
    fill: "#151720"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M63.287 143.678L62.0137 143.407L59.1155 132.113L60.3814 132.339L63.287 143.678Z",
    fill: "#7F591E"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M62.465 131.154L65.3669 142.411L64.5563 142.911L64.0973 143.178L63.2867 143.678L60.3811 132.339L61.1954 131.88L61.6507 131.613L62.465 131.154Z",
    fill: "#EFA838"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3814 132.339L59.1155 132.113L59.9705 131.613L61.1957 131.88L60.3814 132.339Z",
    fill: "#946823"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0249 165.093L55.8479 164.823L53.9417 157.477L55.1631 157.743L57.0249 165.093Z",
    fill: "#151720"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2158 167.316L51.9944 167.09L52.8087 166.635L54.0302 166.816L53.2158 167.316Z",
    fill: "#181B25"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5734 176.486L54.3519 176.257L51.9941 167.092L53.2156 167.318L55.5734 176.486Z",
    fill: "#151720"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7106 157.976L53.4817 157.743L53.9407 157.477L55.1621 157.743L54.7106 157.976Z",
    fill: "#181B25"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5724 165.367L55.3953 165.092L53.4817 157.742L54.7106 157.975L56.5724 165.367Z",
    fill: "#151720"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1267 176.752L53.9016 176.526L51.5364 167.365L52.7615 167.543L55.1267 176.752Z",
    fill: "#151720"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1252 176.753L52.76 167.544L53.2153 167.318L55.5731 176.487L55.1252 176.753Z",
    fill: "#272C3C"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7615 167.544L51.5364 167.366L51.9954 167.092L53.2168 167.318L52.7615 167.544Z",
    fill: "#181B25"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 204.022L46.7784 203.799L45.4163 198.582L46.6858 198.808L47.9998 204.022Z",
    fill: "#4E4E4E"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M48.767 197.584L50.0884 202.85L48.0008 204.023L46.6868 198.81L48.767 197.584Z",
    fill: "#929292"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6858 198.807L45.4163 198.581L47.5002 197.355L48.766 197.581L46.6858 198.807Z",
    fill: "#5A5A5A"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9461 168.043L50.7209 167.813L51.5353 167.365L52.7604 167.543L51.9461 168.043Z",
    fill: "#181B25"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6519 131.614L60.3823 131.381L58.5686 124.264L59.8419 124.53L61.6519 131.614Z",
    fill: "#151720"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2314 205.021L45.0506 204.795L44.2363 201.711L45.4578 201.941L46.2314 205.021Z",
    fill: "#151720"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1956 131.882L59.9704 131.615L58.1604 124.531L59.3819 124.761L61.1956 131.882Z",
    fill: "#151720"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3831 124.761L59.842 124.531L61.652 131.615L61.1967 131.882L59.3831 124.761Z",
    fill: "#272C3C"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3819 124.76L58.1604 124.53L58.5676 124.264L59.8408 124.53L59.3819 124.76Z",
    fill: "#181B25"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M44.147 206.246L42.97 206.021L45.0502 204.795L46.2309 205.021L44.147 206.246Z",
    fill: "#181B25"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0303 166.817L52.8088 166.636L51.2209 160.285L52.4017 160.511L54.0303 166.817Z",
    fill: "#151720"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5835 161.011L50.4065 160.737L51.2208 160.285L52.4016 160.511L51.5835 161.011Z",
    fill: "#8E3515"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1329 161.238L49.9485 161.012L50.4075 160.738L51.5845 161.012L51.1329 161.238Z",
    fill: "#8E3515"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3255 129.022L65.0966 128.796L59.6555 107.475L60.8363 107.7L66.3255 129.022Z",
    fill: "#151720"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3738 203.114L42.1487 202.888L44.2363 201.711L45.4577 201.941L43.3738 203.114Z",
    fill: "#5A5A5A"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1474 206.247L42.9704 206.021L42.1487 202.889L43.3738 203.115L44.1474 206.247Z",
    fill: "#4E4E4E"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5776 206.705L53.4006 206.476L52.8528 204.436L54.078 204.658L54.5776 206.705Z",
    fill: "#151720"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8685 209.423L44.5989 209.201L52.853 204.436L54.0782 204.658L45.8685 209.423Z",
    fill: "#969696"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M46.368 211.464L45.1428 211.239L53.4007 206.477L54.5777 206.706L46.368 211.464Z",
    fill: "#181B25"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0781 204.658L54.5778 206.706L46.3681 211.464L45.8684 209.424L54.0781 204.658Z",
    fill: "#F3F3F3"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4582 201.939L46.2318 205.02L44.1479 206.246L43.3743 203.113L45.4582 201.939Z",
    fill: "#929292"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9463 168.043L50.7212 167.813L49.137 161.463L50.3103 161.737L51.9463 168.043Z",
    fill: "#7A2E12"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3103 161.737L49.137 161.463L49.9476 161.012L51.132 161.238L50.3103 161.737Z",
    fill: "#8E3515"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0191 108.2L58.842 107.926L59.6563 107.475L60.8371 107.7L60.0191 108.2Z",
    fill: "#946823"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5628 108.426L58.3821 108.2L58.8411 107.926L60.0181 108.2L59.5628 108.426Z",
    fill: "#946823"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5834 161.013L50.4063 160.739L49.0405 155.48L50.2657 155.747L51.5834 161.013Z",
    fill: "#151720"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8367 107.701L66.3258 129.023L65.5078 129.523L65.0563 129.797L64.2345 130.248L58.7454 108.923L59.5634 108.427L60.0186 108.201L60.8367 107.701Z",
    fill: "#EFA838"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2341 130.25L63.0126 130.024L57.5715 108.65L58.7449 108.924L64.2341 130.25Z",
    fill: "#7F591E"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7449 108.921L57.5715 108.647L58.3821 108.199L59.5629 108.425L58.7449 108.921Z",
    fill: "#946823"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0185 108.201L58.8415 107.927L58.0198 104.932L59.2931 105.158L60.0185 108.201Z",
    fill: "#151720"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8133 155.98L48.5881 155.747L49.0397 155.48L50.2649 155.747L49.8133 155.98Z",
    fill: "#181B25"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M51.131 161.238L49.9465 161.012L48.5881 155.746L49.8133 155.979L51.131 161.238Z",
    fill: "#151720"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M58.842 105.382L59.2936 105.156L60.0191 108.2L59.5638 108.426L58.842 105.382Z",
    fill: "#272C3C"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5629 108.427L58.3821 108.201L57.5715 105.205L58.8411 105.383L59.5629 108.427Z",
    fill: "#151720"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8411 105.383L57.5715 105.206L58.0194 104.932L59.2927 105.158L58.8411 105.383Z",
    fill: "#181B25"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2306 163.193L46.0461 162.96L46.5051 162.693L47.6859 162.919L47.2306 163.193Z",
    fill: "#181B25"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9571 156.158L44.7356 155.932L45.598 155.48L46.7788 155.658L45.9571 156.158Z",
    fill: "#181B25"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6856 162.919L46.5049 162.693L44.7356 155.932L45.9571 156.158L47.6856 162.919Z",
    fill: "#151720"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5052 156.432L44.3245 156.202L44.7353 155.932L45.9568 156.158L45.5052 156.432Z",
    fill: "#181B25"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M47.23 163.194L45.5051 156.432L45.9567 156.158L47.6853 162.92L47.23 163.194Z",
    fill: "#272C3C"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2301 163.192L46.0456 162.959L44.3245 156.201L45.5052 156.431L47.2301 163.192Z",
    fill: "#151720"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6922 156.927L43.467 156.653L44.3258 156.201L45.5065 156.431L44.6922 156.927Z",
    fill: "#181B25"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7787 155.658L45.5979 155.48L44.01 149.393L45.2315 149.667L46.7787 155.658Z",
    fill: "#151720"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1092 182.836L37.884 182.606L38.3356 182.34L39.5645 182.606L39.1092 182.836Z",
    fill: "#181B25"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M44.417 150.126L43.1956 149.892L44.0099 149.393L45.2313 149.667L44.417 150.126Z",
    fill: "#8E3515"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9664 150.392L42.7375 150.126L43.1965 149.893L44.418 150.126L43.9664 150.392Z",
    fill: "#8E3515"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2316 149.666L46.7788 155.657L45.9571 156.157L45.5055 156.431L44.6912 156.927L43.1477 150.847L43.9657 150.392L44.4173 150.125L45.2316 149.666Z",
    fill: "#E55622"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M44.692 156.927L43.4668 156.653L41.927 150.625L43.1485 150.847L44.692 156.927Z",
    fill: "#7A2E12"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1485 150.847L41.927 150.625L42.7376 150.125L43.9665 150.392L43.1485 150.847Z",
    fill: "#8E3515"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1104 176.937L36.8853 176.711L37.707 176.256L38.9321 176.437L38.1104 176.937Z",
    fill: "#181B25"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5651 182.608L38.3362 182.341L36.8853 176.713L38.1104 176.939L39.5651 182.608Z",
    fill: "#151720"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M39.109 182.837L37.8838 182.607L36.4329 176.986L37.658 177.164L39.109 182.837Z",
    fill: "#151720"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M37.658 177.165L36.4329 176.987L36.8844 176.713L38.1096 176.939L37.658 177.165Z",
    fill: "#181B25"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1094 182.838L37.6584 177.165L38.11 176.939L39.5647 182.609L39.1094 182.838Z",
    fill: "#272C3C"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4176 150.127L43.1961 149.894L41.9709 145.225L43.2368 145.45L44.4176 150.127Z",
    fill: "#151720"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0567 156.156L39.8352 155.93L40.2905 155.656L41.5156 155.93L41.0567 156.156Z",
    fill: "#181B25"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9655 150.393L42.7367 150.127L41.5559 145.498L42.7848 145.72L43.9655 150.393Z",
    fill: "#151720"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7848 145.721L41.5559 145.499L41.9705 145.225L43.2363 145.45L42.7848 145.721Z",
    fill: "#181B25"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7854 145.718L43.237 145.447L44.4177 150.124L43.9661 150.391L42.7854 145.718Z",
    fill: "#272C3C"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8397 177.664L35.6145 177.438L36.4325 176.986L37.6577 177.164L36.8397 177.664Z",
    fill: "#181B25"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7469 164.232L37.5217 164.006L37.9807 163.732L39.2022 164.006L38.7469 164.232Z",
    fill: "#181B25"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8349 158.927L37.6135 158.701L37.2063 157.105L38.4315 157.339L38.8349 158.927Z",
    fill: "#151720"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8829 149.391L38.6096 149.213L39.4313 148.717L40.7009 148.939L39.8829 149.391Z",
    fill: "#181B25"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5152 155.93L40.2901 155.656L38.6096 149.213L39.8829 149.391L41.5152 155.93Z",
    fill: "#151720"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0215 159.379L36.8 159.197L37.6144 158.701L38.8358 158.927L38.0215 159.379Z",
    fill: "#181B25"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2023 164.005L37.9808 163.731L36.8 159.195L38.0215 159.377L39.2023 164.005Z",
    fill: "#151720"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4317 149.665L38.1584 149.442L38.61 149.213L39.8833 149.391L39.4317 149.665Z",
    fill: "#181B25"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0566 156.155L39.8352 155.929L38.1584 149.441L39.4317 149.664L41.0566 156.155Z",
    fill: "#151720"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6106 150.123L37.3411 149.938L38.1591 149.441L39.4324 149.664L38.6106 150.123Z",
    fill: "#181B25"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7018 148.942L39.4322 148.719L36.5266 137.422L37.7962 137.6L40.7018 148.942Z",
    fill: "#151720"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7951 137.6L40.7007 148.942L39.8827 149.393L39.4311 149.667L38.6094 150.127L35.7112 138.829L36.5255 138.37L36.9808 138.1L37.7951 137.6Z",
    fill: "#EFA838"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0568 156.158L39.4319 149.667L39.8835 149.393L41.5158 155.932L41.0568 156.158Z",
    fill: "#272C3C"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M38.746 164.234L37.5208 164.008L36.3401 159.424L37.569 159.65L38.746 164.234Z",
    fill: "#151720"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M37.569 159.647L36.3401 159.421L36.7991 159.195L38.0205 159.377L37.569 159.647Z",
    fill: "#181B25"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7466 164.233L37.5696 159.649L38.0212 159.379L39.2019 164.008L38.7466 164.233Z",
    fill: "#272C3C"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6141 157.839L36.3889 157.565L37.2069 157.105L38.4321 157.339L37.6141 157.839Z",
    fill: "#946823"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9318 176.44L37.7066 176.258L34.801 164.916L36.0706 165.142L38.9318 176.44Z",
    fill: "#151720"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1592 158.105L35.9377 157.838L36.3893 157.564L37.6145 157.838L37.1592 158.105Z",
    fill: "#946823"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7555 160.105L35.5266 159.924L36.3409 159.424L37.5698 159.65L36.7555 160.105Z",
    fill: "#181B25"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2119 165.642L33.9905 165.368L34.8011 164.916L36.0707 165.142L35.2119 165.642Z",
    fill: "#8E3515"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7562 160.103L35.5273 159.922L35.1165 158.289L36.3416 158.559L36.7562 160.103Z",
    fill: "#7F591E"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4314 157.338L38.8348 158.926L38.0205 159.378L37.569 159.649L36.7546 160.104L36.3401 158.56L37.1581 158.104L37.6134 157.838L38.4314 157.338Z",
    fill: "#EFA838"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3416 158.562L35.1165 158.292L35.9382 157.84L37.1596 158.106L36.3416 158.562Z",
    fill: "#946823"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8011 165.867L33.5315 165.641L33.9905 165.367L35.2119 165.641L34.8011 165.867Z",
    fill: "#8E3515"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0707 165.141L38.9319 176.438L38.1102 176.938L37.6586 177.164L36.8406 177.664L33.9387 166.366L34.8011 165.866L35.212 165.641L36.0707 165.141Z",
    fill: "#E55622"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8414 177.663L35.6162 177.438L32.718 166.092L33.9395 166.366L36.8414 177.663Z",
    fill: "#7A2E12"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9395 166.366L32.718 166.092L33.5323 165.641L34.8019 165.866L33.9395 166.366Z",
    fill: "#8E3515"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2123 165.639L33.9909 165.365L33.0803 161.736L34.2611 161.918L35.2123 165.639Z",
    fill: "#151720"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8021 162.195L32.6213 162.007L33.0803 161.736L34.2611 161.918L33.8021 162.195Z",
    fill: "#181B25"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8015 165.866L33.5319 165.64L32.6213 162.008L33.8021 162.197L34.8015 165.866Z",
    fill: "#151720"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9808 138.1L35.7112 137.874L36.5255 137.422L37.7951 137.6L36.9808 138.1Z",
    fill: "#946823"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5266 138.369L35.2607 138.147L35.7123 137.873L36.9819 138.099L36.5266 138.369Z",
    fill: "#946823"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6151 157.838L36.3899 157.564L33.4436 146.133L34.7132 146.403L37.6151 157.838Z",
    fill: "#151720"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M35.712 138.828L34.4387 138.595L35.2604 138.146L36.5263 138.369L35.712 138.828Z",
    fill: "#946823"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6102 150.125L37.3406 149.94L34.4387 138.594L35.712 138.827L38.6102 150.125Z",
    fill: "#7F591E"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M37.159 158.065L35.9375 157.839L32.9912 146.404L34.2608 146.671L37.159 158.065Z",
    fill: "#151720"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M34.261 146.67L32.9915 146.403L33.443 146.133L34.7126 146.403L34.261 146.67Z",
    fill: "#181B25"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9811 138.098L35.7115 137.872L34.7122 133.877L35.9373 134.11L36.9811 138.098Z",
    fill: "#151720"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4852 134.332L34.26 134.151L34.7116 133.877L35.9367 134.11L35.4852 134.332Z",
    fill: "#181B25"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5253 138.37L35.2594 138.148L34.26 134.152L35.4852 134.334L36.5253 138.37Z",
    fill: "#151720"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M129.957 94.1816L130.497 96.222L123.246 100.395L122.698 98.3993L129.957 94.1816Z",
    fill: "#E55622"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M126.551 80.791L127.054 82.7869L122.787 85.2827L122.246 83.2386L126.551 80.791Z",
    fill: "#F3F3F3"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M120.608 100.762L126.241 122.805L125.42 123.264L124.968 123.531L124.15 124.031L118.528 101.984L119.342 101.484L119.793 101.258L120.608 100.762Z",
    fill: "#E55622"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M118.208 97.1295L118.612 96.8555L119.792 101.258L119.341 101.484L118.208 97.1295Z",
    fill: "#272C3C"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9204 121.991L19.6545 121.766L121.521 62.9668L122.746 63.189L20.9204 121.991Z",
    fill: "#181B25"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7846 207.473L41.6039 207.244L19.6545 121.766L20.9204 121.991L42.7846 207.473Z",
    fill: "#151720"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M122.877 62.7381L20.6067 121.807L42.6486 207.926L144.922 148.85L122.877 62.7344V62.7381ZM20.9213 121.989L122.747 63.1861L144.648 148.664L42.7855 207.467L20.9213 121.989Z",
    fill: "#4D5974"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M125.193 153.025L126.596 158.654L124.512 159.835L123.102 154.299L125.193 153.025Z",
    fill: "#929292"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M126.736 130.518L124.967 123.53L125.419 123.264L127.188 130.247L126.736 130.518Z",
    fill: "#272C3C"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M128.235 87.5098L128.776 89.5056L124.512 92.0014L123.968 89.9574L128.235 87.5098Z",
    fill: "#F3F3F3"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2111 163.961L99.8391 174.081L97.7515 175.307L95.1272 165.19L97.2111 163.961Z",
    fill: "#929292"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3164 132.973L91.7704 142.637L90.9487 143.133L90.4971 143.359L89.6865 143.859L87.2288 134.198L88.0431 133.698L88.502 133.473L89.3164 132.973Z",
    fill: "#E55622"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 63.1875L20.9211 121.99L42.7853 207.468L85.8697 182.603L144.648 148.666L122.747 63.1875ZM137.349 122.99L133.085 125.486L132.585 123.441L136.849 120.994L137.349 122.99ZM135.672 116.317L131.36 118.813L130.86 116.728L135.124 114.28L135.668 116.321L135.672 116.317ZM133.951 109.648L129.639 112.096L129.139 110.059L133.407 107.563L133.951 109.648ZM132.222 102.935L127.962 105.382L127.414 103.346L131.678 100.846L132.219 102.931L132.222 102.935ZM130.498 96.2213L123.243 100.398L122.699 98.4023L129.957 94.181L130.498 96.2213ZM128.776 89.5042L124.512 92L123.972 89.9559L128.236 87.5083L128.776 89.5042ZM127.055 82.7871L122.791 85.2828L122.251 83.2388L126.556 80.7912L127.055 82.7871ZM125.323 76.1218L121.063 78.6176L120.522 76.5254L124.827 74.0778L125.319 76.1218H125.323ZM123.102 67.3607L123.602 69.4528L119.342 71.9005L118.797 69.8565L123.102 67.3607ZM109.91 116.139L110.362 115.913L110.821 117.861L111.676 117.365L112.046 118.813L111.224 119.313L114.171 130.703L113.719 130.977L110.773 119.542L109.955 120.042L109.548 118.635L110.41 118.135L109.91 116.139ZM102.926 105.975L103.337 105.749L104.107 108.745L104.921 108.285L107.826 119.627L107.008 120.079L108.73 126.889L108.326 127.156L106.553 120.353L105.731 120.805L102.833 109.467L103.648 109.007L102.926 105.971V105.975ZM99.2059 106.612L100.294 110.97L101.116 110.511L102.289 115.003L101.471 115.502L105.01 129.344L104.558 129.618L101.02 115.776L100.205 116.276L99.0245 111.737L99.8425 111.237L98.7506 106.882L99.2059 106.615V106.612ZM92.0362 97.8987L92.4952 97.6654L93.1319 100.161L93.9425 99.6613L97.3922 113.003L96.5742 113.462L99.7463 126.074L99.2947 126.345L96.1226 113.729L95.3009 114.229L91.8549 100.935L92.6766 100.435L92.0362 97.8987ZM90.6815 107.748L92.7173 115.728L93.5316 115.228L93.8055 116.317L92.9912 116.817L93.676 119.546L93.217 119.813L92.5804 117.05L91.7179 117.55L91.444 116.458L92.2657 115.958L90.2226 108.019L90.6815 107.748ZM86.821 128.981L87.2799 128.707L88.5051 133.473L89.3194 132.973L91.7697 142.637L90.9517 143.137L93.7204 153.935L93.2614 154.213L90.5002 143.367L89.6859 143.867L87.2318 134.202L88.0461 133.702L86.821 128.981ZM86.9616 110.47L89.4083 120.042L90.2226 119.542L93.1282 130.881L92.3065 131.34L93.08 134.239L92.6285 134.51L91.8586 131.61L91.0406 132.062L88.779 123.079L88.1424 120.768L88.9641 120.268L86.5101 110.737L86.969 110.47H86.9616ZM85.4181 138.69L86.4175 142.678L87.2799 142.178L87.961 144.948L87.143 145.407L87.8685 148.355L87.465 148.581L86.6914 145.678L85.8697 146.137L85.1442 143.415L86.0067 142.915L84.9666 138.964L85.4181 138.698V138.69ZM80.251 137.694L80.7025 137.464L81.5132 140.593L82.3275 140.142L84.1449 147.133L83.3231 147.585L85.866 157.608L85.4144 157.842L82.8716 147.859L82.0573 148.31L80.2473 141.327L81.0616 140.871L80.2473 137.698L80.251 137.694ZM74.8506 133.699L75.3022 133.425L75.6168 134.609L76.4348 134.15L78.5187 142.315L77.7044 142.771L80.0622 152.117L79.6069 152.384L77.2528 143.041L76.4311 143.493L74.3435 135.328L75.1578 134.869L74.8432 133.695L74.8506 133.699ZM70.135 126.711L72.5817 136.335L71.7711 136.787L74.3546 146.77L73.8957 147.044L71.3121 137.061L70.5015 137.513L68.0067 127.896L70.1387 126.711H70.135ZM58.842 105.382L59.2936 105.156L60.0154 108.2L60.8371 107.7L66.3263 129.022L65.5046 129.522L66.6409 134.013L66.1819 134.239L65.053 129.796L64.235 130.247L58.7458 108.922L59.5638 108.422L58.842 105.379V105.382ZM65.3676 163.192L64.9198 163.459L64.235 160.919L63.4207 161.371L59.6527 146.762L60.467 146.263L58.9716 140.319L59.4306 140.045L60.9296 145.989L61.7439 145.489L65.5083 160.189L64.6866 160.641L65.3676 163.185V163.192ZM65.3676 148.214L64.098 143.178L63.2874 143.678L60.3818 132.34L61.1961 131.88L59.3824 124.76L59.8414 124.53L61.6514 131.614L62.4657 131.155L65.3676 142.408L65.0086 142.634L64.557 142.908L65.8266 147.944L65.3676 148.214ZM58.9309 155.342L60.7927 162.555L61.6107 162.096L63.9204 171.083L63.1061 171.535L64.098 175.438L63.6465 175.712L62.6508 171.805L61.8365 172.261L59.5194 163.278L60.3411 162.818L58.4756 155.605L58.9346 155.338L58.9309 155.342ZM55.1628 157.742L57.0247 165.092L57.8427 164.64L61.8328 180.115L61.0148 180.615L61.7402 183.514L61.2887 183.74L60.5632 180.841L59.7415 181.34L55.7514 165.818L56.5731 165.366L54.715 157.975L55.1665 157.745L55.1628 157.742ZM34.7126 146.403L37.6108 157.838L38.4288 157.338L38.8322 158.923L38.0179 159.375L39.1987 164.003L38.7397 164.229L37.5664 159.649L36.7521 160.1L36.3375 158.56L37.1592 158.101L34.261 146.666L34.7126 146.4V146.403ZM39.1099 182.836L37.6626 177.164L36.8446 177.663L33.9427 166.369L34.8051 165.87L33.8057 162.2L34.2647 161.922L35.216 165.644L36.0784 165.144L38.9359 176.441L38.1142 176.941L39.5688 182.611L39.1099 182.84V182.836ZM41.0568 156.157L39.4282 149.666L38.6065 150.125L36.2524 141.138L35.7083 138.827L36.5226 138.368L35.4825 134.332L35.934 134.106L36.9778 138.094L37.7922 137.594L40.6978 148.936L39.8797 149.388L41.5121 155.927L41.0531 156.153L41.0568 156.157ZM43.1481 150.847L43.9661 150.391L42.7853 145.718L43.2369 145.448L44.4177 150.125L45.232 149.666L46.7755 155.657L45.9538 156.157L47.6823 162.918L47.2233 163.192L45.5022 156.431L44.6879 156.931L43.1444 150.851L43.1481 150.847ZM44.1475 206.246L43.3739 203.114L45.4578 201.936L46.2314 205.021L44.1475 206.246ZM48.0006 204.021L46.6866 198.807L48.7668 197.581L50.0845 202.847L48.0006 204.021ZM49.8143 155.979L50.2659 155.75L51.5836 161.015L52.4053 160.515L54.0339 166.818L53.2233 167.317L55.5811 176.486L55.1295 176.752L52.7643 167.543L51.95 168.043L50.3177 161.737L51.1394 161.237L49.818 155.979H49.8143ZM51.8575 201.803L50.4954 196.585L52.5793 195.404L53.9377 200.622L51.8538 201.803H51.8575ZM55.6625 199.622L54.9408 196.948L57.0247 195.723L57.7501 198.396L55.6625 199.622ZM59.4713 197.396L57.5688 190.005L59.6527 188.82L61.5626 196.174L59.4713 197.4V197.396ZM63.2874 195.175L61.7439 189.009L63.8352 187.783L65.3713 194.001L63.2874 195.178V195.175ZM67.0925 193.001L64.8679 184.243L67.0036 183.018L69.1764 191.775L67.0925 193.001ZM70.9493 190.779L69.639 185.562L71.7229 184.336L73.0443 189.553L70.953 190.779H70.9493ZM74.8025 188.557L73.1702 182.344L75.2615 181.159L76.8901 187.328L74.8062 188.557H74.8025ZM78.6113 186.336L76.5718 178.348L78.6594 177.164L80.7025 185.151L78.6113 186.336ZM82.4237 184.151L80.5175 176.749L82.6014 175.527L84.5076 182.922L82.4237 184.147V184.151ZM88.3163 180.703L86.2324 181.929L85.0554 177.075L87.1393 175.89L88.3126 180.703H88.3163ZM90.0893 179.707L88.8641 174.894L90.948 173.716L92.1769 178.522L90.0856 179.707H90.0893ZM93.9425 177.526L91.6772 168.725L93.7574 167.543L96.0264 176.301L93.9425 177.526ZM97.7512 175.305L95.1269 165.188L97.2108 163.959L99.8388 174.079L97.7475 175.305H97.7512ZM101.564 173.079L97.5735 157.475L99.6574 156.201L103.648 171.902L101.564 173.075V173.079ZM105.372 170.906L102.785 160.737L104.869 159.56L107.453 169.672L105.369 170.902L105.372 170.906ZM109.226 168.676L107.182 160.697L109.274 159.471L109.677 161.1L111.317 167.454L109.226 168.68V168.676ZM113.038 166.455L111.176 159.064L113.268 157.838L115.166 165.277L113.038 166.455ZM115.077 122.942L113.397 116.365L114.219 115.913L112.901 110.648L113.36 110.374L114.67 115.639L115.492 115.188L117.165 121.72L116.351 122.175L117.983 128.526L117.532 128.796L115.892 122.442L115.077 122.942ZM116.891 164.277L116.077 161.1L118.161 159.923L118.982 163.007L116.891 164.277ZM118.709 116.365L115.488 103.753L114.667 104.205L113.168 98.2135L113.989 97.7617L113.168 94.766L113.627 94.4957L114.441 97.4914L115.259 97.0396L116.758 102.983L115.94 103.483L119.16 116.091L118.709 116.365ZM120.704 162.007L120.204 160.06L122.292 158.834L122.788 160.826L120.704 162.007ZM124.512 159.834L123.106 154.294L125.197 153.02L126.6 158.649L124.516 159.834H124.512ZM126.737 130.518L124.968 123.53L124.146 124.03L118.527 101.983L119.342 101.483L118.209 97.1248L118.612 96.8508L119.793 101.254L120.607 100.757L126.237 122.805L125.419 123.264L127.189 130.247L126.737 130.518ZM128.317 157.653L127.237 153.117L129.317 151.935L130.412 156.379L128.321 157.653H128.317ZM132.178 155.383L129.861 146.403L131.952 145.222L134.266 154.209L132.178 155.383ZM134.266 130.159L138.57 127.663L139.07 129.707L134.765 132.154L134.266 130.159Z",
    fill: "#272C3C"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M138.57 127.66L139.069 129.708L134.765 132.152L134.265 130.16L138.57 127.66Z",
    fill: "#F3F3F3"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M131.952 145.225L134.265 154.212L132.178 155.385L129.861 146.406L131.952 145.225Z",
    fill: "#929292"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M135.127 114.275L135.671 116.316L131.359 118.811L130.86 116.723L135.127 114.275Z",
    fill: "#F3F3F3"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M122.292 158.834L122.788 160.826L120.704 162.007L120.204 160.06L122.292 158.834Z",
    fill: "#929292"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M113.267 157.84L115.166 165.279L113.038 166.457L111.176 159.066L113.267 157.84Z",
    fill: "#929292"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M122.246 60.7404L121.021 60.5108L120.429 58.2891L121.699 58.4705L122.246 60.7404Z",
    fill: "#151720"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M104.872 159.561L107.456 169.677L105.372 170.906L102.788 160.738L104.872 159.561Z",
    fill: "#929292"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M123.102 67.3613L123.602 69.4535L119.341 71.9011L118.797 69.8571L123.102 67.3613Z",
    fill: "#F3F3F3"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M109.91 116.138L110.362 115.912L110.821 117.86L110.406 118.134L109.91 116.138Z",
    fill: "#272C3C"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M114.441 65.2273L113.268 65.0014L121.022 60.5098L122.247 60.7393L114.441 65.2273Z",
    fill: "#181B25"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M114.44 65.2286L113.267 65.0027L112.671 62.7402L113.896 63.0068L114.44 65.2286Z",
    fill: "#828282"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M113.896 63.0066L112.671 62.74L120.429 58.2891L121.699 58.4705L113.896 63.0066Z",
    fill: "#969696"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9484 173.715L92.1773 178.521L90.0897 179.706L88.8645 174.892L90.9484 173.715Z",
    fill: "#929292"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M101.112 110.512L102.289 115.003L101.471 115.503L101.02 115.777L100.205 116.277L99.0208 111.737L99.8388 111.234L100.294 110.971L101.112 110.512Z",
    fill: "#E55622"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2768 142.18L87.9615 144.949L87.1435 145.409L86.692 145.675L85.8703 146.134L85.1448 143.409L86.0072 142.913L86.4181 142.68L87.2768 142.18Z",
    fill: "#E55622"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8218 128.981L87.277 128.707L88.5022 133.473L88.0432 133.699L86.8218 128.981Z",
    fill: "#272C3C"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6601 177.164L80.7033 185.151L78.612 186.336L76.5725 178.349L78.6601 177.164Z",
    fill: "#929292"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4394 134.152L78.5233 142.317L77.709 142.776L77.2574 143.047L76.4394 143.502L74.3518 135.334L75.1661 134.878L75.6177 134.612L76.4394 134.152Z",
    fill: "#E55622"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6102 152.386L77.2561 143.044L77.7077 142.773L80.0655 152.12L79.6102 152.386Z",
    fill: "#272C3C"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2097 216.774L55.9365 216.544L55.4368 214.508L56.6619 214.734L57.2097 216.774Z",
    fill: "#151720"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7083 87.0563L75.4868 86.7823L74.8909 84.5605L76.1642 84.7864L76.7083 87.0563Z",
    fill: "#151720"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9517 221.538L47.6858 221.309L55.9362 216.543L57.2095 216.773L48.9517 221.538Z",
    fill: "#181B25"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1723 212.512L49.9471 212.283L49.4104 210.242L50.6726 210.464L51.1723 212.512Z",
    fill: "#151720"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5013 227.163L46.3206 226.937L46.5945 226.752L47.8677 226.978L47.5013 227.163Z",
    fill: "#181B25"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1811 134.241L65.0559 129.797L65.5075 129.523L66.6401 134.015L66.1811 134.241Z",
    fill: "#272C3C"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M48.41 219.499L47.1848 219.266L55.4352 214.508L56.6604 214.734L48.41 219.499Z",
    fill: "#969696"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6618 214.734L57.2096 216.775L48.9518 221.54L48.4114 219.5L56.6618 214.734Z",
    fill: "#F3F3F3"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9504 221.539L47.6845 221.31L47.1848 219.266L48.41 219.499L48.9504 221.539Z",
    fill: "#828282"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4719 155.608L58.9309 155.342L60.7927 162.555L60.3411 162.822L58.4719 155.608Z",
    fill: "#272C3C"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2306 214.783L45.9573 214.549L49.9474 212.283L51.1726 212.513L47.2306 214.783Z",
    fill: "#181B25"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9502 91.5027L67.7288 91.3249L75.4869 86.7852L76.7084 87.0592L68.9502 91.5027Z",
    fill: "#181B25"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2312 214.782L45.9579 214.548L45.4583 212.512L46.6871 212.738L47.2312 214.782Z",
    fill: "#828282"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6732 210.463L51.1729 212.511L47.2309 214.781L46.6868 212.736L50.6732 210.463Z",
    fill: "#F3F3F3"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6871 212.738L45.4583 212.512L49.4114 210.242L50.6735 210.464L46.6871 212.738Z",
    fill: "#969696"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9499 91.5023L67.7284 91.3246L67.1399 89.0547L68.3614 89.2769L68.9499 91.5023Z",
    fill: "#7F591E"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1651 84.7891L76.7092 87.059L68.9511 91.5025L68.3625 89.277L76.1651 84.7891Z",
    fill: "#EFA838"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3614 89.2744L67.1399 89.0522L74.8906 84.5605L76.1639 84.7864L68.3614 89.2744Z",
    fill: "#946823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 224,
    width: 5,
    height: 5
  }, _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3199 228.252C43.9652 227.575 42.8732 226.168 42.3254 224.168L43.595 224.394C44.0947 226.39 45.1866 227.801 46.5895 228.474C46.3637 228.434 46.1379 228.434 45.9528 228.386C45.864 228.341 45.7752 228.341 45.6863 228.341C45.5938 228.297 45.4568 228.297 45.3199 228.245V228.252Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6851 228.889L46.5006 228.663C44.5944 228.3 42.9658 226.712 42.3254 224.168L43.595 224.394C44.2317 226.938 45.8196 228.523 47.6851 228.885V228.889Z",
    fill: "#1A1D27"
  }))), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3681 211.466L45.143 211.24L44.5989 209.203L45.8685 209.425L46.3681 211.466Z",
    fill: "#828282"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8262 92.1798L66.5529 91.9503L66.0051 89.7285L67.1822 89.9544L67.8262 92.1798Z",
    fill: "#151720"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8674 226.979L46.5941 226.754L42.1487 209.424L43.422 209.65L47.8674 226.979Z",
    fill: "#151720"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4219 209.65L47.8673 226.98L47.5008 227.165L43.0999 209.828L43.4219 209.65Z",
    fill: "#4D5974"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1002 209.827L41.875 209.605L42.1489 209.424L43.4222 209.65L43.1002 209.827Z",
    fill: "#303748"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5014 227.165L46.3206 226.939L41.8752 209.605L43.1004 209.828L47.5014 227.165Z",
    fill: "#29303E"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0186 96.6687L58.7454 96.4428L66.5516 91.9512L67.8249 92.1808L60.0186 96.6687Z",
    fill: "#181B25"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0193 96.6683L58.746 96.4425L58.2056 94.2207L59.4307 94.4466L60.0193 96.6683Z",
    fill: "#7F591E"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4305 94.446L58.2053 94.2202L66.0042 89.7285L67.1812 89.9544L59.4305 94.446Z",
    fill: "#946823"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M58.842 97.3514L57.6169 97.1293L57.0247 94.8594L58.2942 95.1334L58.842 97.3514Z",
    fill: "#151720"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0838 101.848L49.8586 101.623L57.6168 97.1309L58.842 97.353L51.0838 101.848Z",
    fill: "#181B25"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4957 99.5769L49.2668 99.3992L57.025 94.8594L58.2946 95.1334L50.4957 99.5769Z",
    fill: "#946823"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0842 101.848L49.8591 101.622L49.2668 99.4004L50.4957 99.5781L51.0842 101.848Z",
    fill: "#7F591E"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2942 95.1348L58.842 97.3528L51.0839 101.848L50.4954 99.5783L58.2942 95.1348Z",
    fill: "#EFA838"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9469 102.483L48.6848 102.298L48.137 100.035L49.314 100.302L49.9469 102.483Z",
    fill: "#151720"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1478 107.014L40.8782 106.748L48.6844 102.297L49.9466 102.482L42.1478 107.014Z",
    fill: "#181B25"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1487 107.014L40.8791 106.747L40.3313 104.566L41.5565 104.752L42.1487 107.014Z",
    fill: "#7F591E"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5565 104.753L40.3313 104.568L48.1376 100.035L49.3146 100.302L41.5565 104.753Z",
    fill: "#946823"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3141 100.301L49.947 102.482L42.1481 107.014L41.5559 104.752L49.3141 100.301Z",
    fill: "#EFA838"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6147 109.6L36.3895 109.374L35.801 107.152L37.0706 107.378L37.6147 109.6Z",
    fill: "#151720"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6257 109.561L29.3598 109.376L28.8157 107.113L29.9964 107.38L30.6257 109.561Z",
    fill: "#151720"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M28.501 110.786L27.2759 110.56L29.3598 109.375L30.6256 109.56L28.501 110.786Z",
    fill: "#181B25"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5017 110.786L27.2766 110.56L26.7288 108.338L27.9058 108.56L28.5017 110.786Z",
    fill: "#4E4E4E"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9961 107.379L30.6253 109.56L28.5007 110.786L27.9048 108.56L29.9961 107.379Z",
    fill: "#929292"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9058 108.561L26.7288 108.339L28.8164 107.113L29.9971 107.38L27.9058 108.561Z",
    fill: "#5A5A5A"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6323 111.283L26.4552 111.057L25.8186 108.832L27.0919 109.062L27.6323 111.283Z",
    fill: "#151720"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6063 121.809L19.3811 121.631L121.699 62.5508L122.876 62.7396L20.6063 121.809Z",
    fill: "#303748"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6481 207.926L41.4267 207.7L19.3811 121.629L20.6063 121.807L42.6481 207.926Z",
    fill: "#29303E"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1951 119.68L18.9292 119.451L36.3887 109.375L37.6139 109.601L20.1951 119.68Z",
    fill: "#181B25"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1955 119.68L18.9296 119.45L18.3818 117.229L19.607 117.451L20.1955 119.68Z",
    fill: "#7F591E"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6072 117.45L18.3821 117.228L35.8009 107.152L37.0705 107.378L19.6072 117.45Z",
    fill: "#946823"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2923 116.093L18.0227 115.915L26.4545 111.061L27.6316 111.286L19.2923 116.093Z",
    fill: "#181B25"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0913 109.064L27.6317 111.286L19.2925 116.093L18.6965 113.919L27.0913 109.064Z",
    fill: "#929292"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2913 116.09L18.0217 115.912L17.4739 113.643L18.6953 113.917L19.2913 116.09Z",
    fill: "#4E4E4E"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6953 113.916L17.4739 113.642L25.8168 108.832L27.0901 109.062L18.6953 113.916Z",
    fill: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 100,
    width: 4,
    height: 8
  }, _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3807 102.935C19.1068 101.798 18.3814 101.032 17.6559 100.898L18.881 101.124C19.6546 101.261 20.3764 102.035 20.6503 103.209C20.2395 103.12 19.836 103.024 19.3807 102.935C19.836 103.024 20.2432 103.12 20.6503 103.209C21.1019 104.842 20.5134 106.749 19.3807 107.382C19.018 107.612 18.6553 107.656 18.3406 107.612L17.1155 107.382C17.4301 107.43 17.7928 107.382 18.1556 107.205C19.2882 106.523 19.836 104.661 19.3807 102.939V102.935Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3406 107.612L17.1155 107.382C17.4301 107.431 17.7928 107.382 18.1556 107.205C19.2882 106.523 19.836 104.661 19.3807 102.939C19.1068 101.802 18.3814 101.036 17.6559 100.902L18.881 101.128C19.6546 101.265 20.3764 102.039 20.6503 103.213C21.1019 104.846 20.5134 106.753 19.3807 107.386C19.018 107.616 18.6553 107.66 18.3406 107.616V107.612Z",
    fill: "#1A1D27"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 100,
    width: 3,
    height: 2
  }, _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6558 100.895L18.881 101.12C18.5183 101.032 18.1962 101.12 17.8409 101.298L16.5676 101.072C16.9304 100.895 17.2931 100.846 17.6558 100.895Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8448 101.298L16.5715 101.072C16.9343 100.895 17.297 100.846 17.6597 100.895L18.8849 101.12C18.5222 101.032 18.2002 101.12 17.8448 101.298Z",
    fill: "#9D6E25"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 101,
    width: 4,
    height: 7
  }, _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3416 107.612L17.1165 107.382C16.2947 107.205 15.6211 106.479 15.2991 105.298C14.8919 103.665 15.4767 101.761 16.5686 101.08L17.8419 101.306C16.7019 101.943 16.1208 103.85 16.5686 105.572C16.8426 106.705 17.568 107.479 18.3416 107.616V107.612Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3416 107.612L17.1165 107.382C16.2947 107.205 15.6211 106.479 15.2991 105.298C14.8919 103.665 15.4767 101.761 16.5686 101.08L17.8419 101.306C16.7019 101.943 16.1208 103.85 16.5686 105.572C16.8426 106.705 17.568 107.479 18.3416 107.616V107.612Z",
    fill: "#9D6E25"
  }))), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M205.517 130.882L175.762 14.6394C174.766 10.7403 171.409 9.0147 168.414 10.781L17.5709 97.9441C14.4803 99.666 12.8553 104.298 13.851 108.201L43.5992 224.399C44.5986 228.302 47.8669 230.027 50.9465 228.254L201.797 141.142C204.832 139.372 206.517 134.788 205.517 130.885V130.882ZM152.994 151.348L153.538 153.388L149.548 155.658L149.049 153.662L152.994 151.348ZM121.699 58.471L122.247 60.7408L114.44 65.2288L113.893 63.0033L121.699 58.4673V58.471ZM76.1642 84.7876L76.712 87.0575L68.9539 91.5047L68.3653 89.2793L76.1642 84.7876ZM67.1809 89.9569L67.8249 92.1861L60.0187 96.674L59.4301 94.4523L67.1846 89.9606L67.1809 89.9569ZM58.2938 95.1336L58.8416 97.3554L51.0835 101.851L50.4949 99.5808L58.2938 95.1373V95.1336ZM49.3142 100.303L49.9471 102.484L42.1483 107.016L41.556 104.754L49.3142 100.303ZM29.9966 107.379L30.6258 109.56L28.5012 110.786L27.909 108.564L30.0003 107.383L29.9966 107.379ZM16.5716 105.568C16.12 103.847 16.7048 101.94 17.8448 101.303C18.9294 100.666 20.1952 101.488 20.6542 103.21C21.1058 104.843 20.5173 106.75 19.3846 107.383C18.2483 108.064 16.9787 107.205 16.5753 105.572L16.5716 105.568ZM18.6962 113.919L27.091 109.064L27.6314 111.286L19.2921 116.092L18.6962 113.919ZM19.6067 117.451L37.0699 107.379L37.6103 109.601L20.1915 119.68L19.603 117.451H19.6067ZM20.6061 121.809L122.88 62.7404L144.925 148.856L42.6517 207.932L20.6098 121.813L20.6061 121.809ZM143.922 155.11L141.971 156.202L141.472 154.206L143.422 153.021L143.918 155.106L143.922 155.11ZM141.29 156.61L139.343 157.746L138.844 155.75L140.791 154.573L141.29 156.613V156.61ZM46.3679 211.465L45.8682 209.424L54.0779 204.659L54.5776 206.703L46.3679 211.465ZM51.1723 212.513L47.2303 214.783L46.6899 212.738L50.6763 210.469L51.176 212.513H51.1723ZM47.5005 227.165L43.0995 209.828L43.4216 209.65L47.8669 226.98L47.5005 227.165ZM48.9515 221.54L48.411 219.5L56.6615 214.734L57.2093 216.778L48.9515 221.54ZM134.032 160.827L133.492 158.742L135.487 157.654L136.027 159.65L134.032 160.827ZM136.171 157.243L138.122 156.11L138.67 158.106L136.675 159.29L136.175 157.246L136.171 157.243ZM138.296 169.907L137.756 167.911L146.006 163.097L146.554 165.189L138.296 169.907ZM149.596 168.181L145.192 150.852L145.458 150.718L149.907 168.003L149.593 168.181H149.596ZM151.273 162.419L150.773 160.375L158.983 155.658L159.531 157.654L151.277 162.419H151.273ZM200.754 123.805L201.253 125.801L197.307 128.119L196.808 126.075L200.754 123.805ZM169.913 151.666L169.414 149.626L202.253 130.619L202.8 132.703L169.917 151.666H169.913Z",
    fill: "#272C3C"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M202.249 130.617L202.797 132.698L169.914 151.665L169.41 149.624L202.249 130.617Z",
    fill: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 9,
    width: 5,
    height: 2
  }, _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M170.362 9.92058L171.587 10.1946C170.592 10.0169 169.463 10.1946 168.415 10.7834L167.142 10.5575C168.234 9.92058 169.322 9.74284 170.362 9.92058Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.415 10.7814L167.142 10.5555C168.234 9.91863 169.322 9.74089 170.362 9.91863L171.587 10.1926C170.592 10.0149 169.463 10.1926 168.415 10.7814Z",
    fill: "#1A1D27"
  }))), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M146.01 163.096L146.554 165.188L138.297 169.905L137.756 167.91L146.01 163.096Z",
    fill: "#F3F3F3"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M112.897 110.649L113.356 110.375L114.666 115.641L114.218 115.915L112.897 110.649Z",
    fill: "#272C3C"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M113.718 130.977L110.768 119.542L111.219 119.312L114.169 130.703L113.718 130.977Z",
    fill: "#272C3C"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M113.171 94.7664L113.626 94.4961L114.441 97.4918L113.989 97.7658L113.171 94.7664Z",
    fill: "#272C3C"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M121.699 58.4688L122.247 60.7386L114.441 65.2266L113.897 63.0048L121.699 58.4688Z",
    fill: "#F3F3F3"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M104.558 129.619L101.02 115.778L101.471 115.504L105.01 129.345L104.558 129.619Z",
    fill: "#272C3C"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2944 126.349L96.1223 113.733L96.5739 113.467L99.746 126.075L99.2944 126.349Z",
    fill: "#272C3C"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0364 97.8973L92.4917 97.627L93.1283 100.163L92.6767 100.437L92.0364 97.8973Z",
    fill: "#272C3C"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5051 110.739L86.9604 110.473L89.407 120.045L88.9592 120.271L86.5051 110.739Z",
    fill: "#272C3C"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8508 133.698L75.3024 133.424L75.617 134.609L75.1655 134.875L74.8508 133.698Z",
    fill: "#272C3C"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7678 136.783L74.3514 146.766L73.8961 147.04L71.3088 137.057L71.7678 136.783Z",
    fill: "#272C3C"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6463 175.716L62.6506 171.809L63.1059 171.535L64.0979 175.438L63.6463 175.716Z",
    fill: "#272C3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 228,
    width: 3,
    height: 1
  }, _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5052 228.665C46.0944 228.576 45.6909 228.439 45.3245 228.254C45.7797 228.35 46.1425 228.439 46.594 228.48C46.9568 228.665 47.3195 228.802 47.686 228.891C47.3158 228.802 46.8642 228.713 46.5015 228.665H46.5052Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6851 228.889L46.5006 228.663C44.5944 228.3 42.9658 226.712 42.3254 224.168L43.595 224.394C44.2317 226.938 45.8196 228.523 47.6851 228.885V228.889Z",
    fill: "#1A1D27"
  }))), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7112 157.975L55.1628 157.742L57.0246 165.092L56.573 165.367L54.7112 157.975Z",
    fill: "#272C3C"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4021 160.512L54.0307 166.818L53.2164 167.318L52.7611 167.544L51.9468 168.043L50.3108 161.737L51.1325 161.237L51.5841 161.012L52.4021 160.512Z",
    fill: "#E55622"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8137 155.979L50.2653 155.746L51.583 161.012L51.1314 161.238L49.8137 155.979Z",
    fill: "#272C3C"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1807 89.9551L67.8247 92.1805L60.0185 96.6685L59.4299 94.4467L67.1807 89.9551Z",
    fill: "#EFA838"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M33.802 162.196L34.261 161.918L35.2122 165.639L34.8014 165.865L33.802 162.196Z",
    fill: "#272C3C"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M34.26 146.671L34.7116 146.404L37.6135 157.839L37.1582 158.065L34.26 146.671Z",
    fill: "#272C3C"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4856 134.332L35.9372 134.109L36.981 138.097L36.5257 138.368L35.4856 134.332Z",
    fill: "#272C3C"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0699 107.379L37.614 109.601L20.1952 119.68L19.6067 117.451L37.0699 107.379Z",
    fill: "#EFA838"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5714 97.9439L16.2981 97.6699L167.141 10.5586L168.415 10.7808L17.5714 97.9439Z",
    fill: "#181B25"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8447 101.299C18.9292 100.662 20.1951 101.484 20.654 103.206C21.1056 104.839 20.5171 106.746 19.3844 107.379C18.2481 108.06 16.9785 107.201 16.5751 105.568C16.1235 103.846 16.7083 101.939 17.8484 101.302L17.8447 101.299Z",
    fill: "#EFA838"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5989 224.394L42.3256 224.168L12.5774 107.926L13.8507 108.2L43.5989 224.394Z",
    fill: "#151720"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_4471_3517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 97,
    width: 6,
    height: 12
  }, _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8512 108.199L12.578 107.925C11.5823 104.022 13.2553 99.4861 16.2979 97.668L17.5712 97.942C14.4805 99.6638 12.8556 104.296 13.8512 108.199Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_4471_3517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8512 108.199L12.578 107.925C11.5823 104.022 13.2553 99.4861 16.2979 97.668L17.5712 97.942C14.4805 99.6638 12.8556 104.296 13.8512 108.199Z",
    fill: "#1A1D27"
  }))), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M153.172 91.9512H153.446L153.627 91.9993L153.539 92.3178L153.353 92.2252L153.131 92.0475L153.172 91.9512Z",
    fill: "#F8F8F8"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M152.946 91.1868L153.627 91.1387H153.768L153.716 91.5904L153.538 91.5016L152.906 91.3238L152.946 91.1868Z",
    fill: "#F8F8F8"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M152.947 89.9576L153.587 89.5984L153.768 89.5059L153.813 89.9576H153.628L152.995 90.0539L152.947 89.9576Z",
    fill: "#F8F8F8"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M159.431 84.2383C159.657 84.1494 159.883 84.2383 159.931 84.5123L160.298 85.9676C160.342 86.1934 160.253 86.5082 160.068 86.6008L155.578 89.1854C155.353 89.3224 155.167 89.1854 155.079 88.9521L154.72 87.5006C154.671 87.2265 154.816 86.9599 154.99 86.8229L159.435 84.2309L159.431 84.2383Z",
    fill: "#4F5B77"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M159.431 84.0611C159.704 83.876 159.978 84.0611 160.067 84.4203L160.474 85.8274C160.563 86.1903 160.426 86.6421 160.112 86.7791L155.618 89.4118C155.344 89.597 155.03 89.4119 154.933 89.049L154.53 87.6011C154.434 87.2308 154.619 86.7791 154.893 86.6013L159.427 84.0611H159.431ZM160.297 85.9681L159.93 84.5129C159.882 84.2389 159.66 84.15 159.431 84.2389L154.985 86.8309C154.808 86.9679 154.667 87.2345 154.715 87.5086L155.074 88.9601C155.163 89.1934 155.348 89.3267 155.574 89.1934L160.064 86.6087C160.249 86.5162 160.337 86.1977 160.293 85.9755L160.297 85.9681Z",
    fill: "#F8F8F8"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M152.631 93.2207L152.816 93.4058L152.994 93.4947L152.816 93.7687L152.72 93.5836L152.542 93.317L152.631 93.2207Z",
    fill: "#F8F8F8"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M153.626 88.7812L153.671 89.1441H153.493L153.219 89.233L153.171 89.1441L153.445 88.959L153.626 88.7812Z",
    fill: "#F8F8F8"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 94.2676L151.948 94.4935L152.044 94.6749L151.818 94.8563L151.77 94.6749L151.722 94.3157L151.77 94.2676Z",
    fill: "#F8F8F8"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M151.177 94.1328L151.447 94.8586L151.543 95.0845L151.225 95.2696L151.177 95.04L151.095 94.2217L151.177 94.1328Z",
    fill: "#F8F8F8"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M150.681 94.9075L150.726 94.8594L150.822 95.2223L150.907 95.4037L150.637 95.4926V95.2704L150.681 94.9075Z",
    fill: "#F8F8F8"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M152.043 86.6016L152.269 86.7349L152.132 86.92L151.947 87.2348L151.906 87.1422L151.995 86.783L152.043 86.6016Z",
    fill: "#F8F8F8"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M150.137 94.4961H150.274L150.322 95.3144L150.363 95.5848H150V95.4033L150.137 94.4961Z",
    fill: "#F8F8F8"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M149.638 94.9941H149.686V95.357V95.5829H149.453L149.501 95.3126L149.638 94.9941Z",
    fill: "#F8F8F8"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M150.906 86.1953L151.132 86.2361L151.095 86.4693L150.951 86.7841H150.906V86.4212V86.1953Z",
    fill: "#F8F8F8"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M149.186 94.3594L149.323 94.4075L149.186 95.2703L149.097 95.4925L148.823 95.4036L148.916 95.1333L149.186 94.3594Z",
    fill: "#F8F8F8"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M150.225 86.2361L150.547 86.1953V86.4212L150.451 87.3284H150.321L150.273 86.4212L150.225 86.2361Z",
    fill: "#F8F8F8"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M148.642 94.584L148.687 94.6321L148.553 94.995V95.2209L148.28 95.0394L148.413 94.858L148.642 94.584Z",
    fill: "#F8F8F8"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M148.457 93.7715L148.501 93.8604L148.142 94.6787L148.053 94.8601L147.828 94.5861L147.916 94.4084L148.457 93.7715Z",
    fill: "#F8F8F8"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 86.5078V86.7337L149.453 87.6002L149.364 87.6409L149.098 86.8707L149.005 86.6893L149.364 86.5078Z",
    fill: "#F8F8F8"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M147.828 93.7246L147.876 93.8172L147.691 94.1319L147.554 94.3171L147.417 94.0431L147.554 93.9468L147.828 93.7246Z",
    fill: "#F8F8F8"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M149.597 88.188C150.726 87.503 151.995 88.1399 152.406 89.684C152.817 91.1318 152.177 92.9463 151 93.5832C149.823 94.3126 148.553 93.6313 148.146 92.1353C147.735 90.6356 148.416 88.8656 149.6 88.188H149.597ZM150.907 93.4054C151.995 92.7722 152.588 91.1355 152.269 89.7766C151.906 88.3657 150.726 87.7807 149.637 88.4139C148.553 89.0026 147.957 90.6838 148.324 92.0465C148.638 93.4054 149.819 94.0423 150.907 93.4054Z",
    fill: "#F8F8F8"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M149.637 88.4143C150.725 87.7811 151.906 88.3662 152.269 89.777C152.591 91.136 151.995 92.7727 150.906 93.4059C149.818 94.0428 148.637 93.4059 148.323 92.0469C147.953 90.6843 148.549 89.0031 149.637 88.4143Z",
    fill: "#4F5B77"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M148.731 86.9199L148.775 87.1421L148.864 87.5087H148.823L148.642 87.2828L148.501 87.1014L148.731 86.9199Z",
    fill: "#F8F8F8"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M147.876 92.8574L147.916 92.9981L147.372 93.5832L147.232 93.7683L147.102 93.3573L147.232 93.2685L147.876 92.8574Z",
    fill: "#F8F8F8"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M146.876 92.6837L147.054 92.6355L147.328 92.543L147.372 92.6355L147.102 92.8577L146.958 92.9984L146.876 92.6837Z",
    fill: "#F8F8F8"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M147.732 88.0039L147.828 88.1891L148.006 88.4631L147.957 88.5519L147.732 88.4149L147.554 88.3261L147.732 88.0039Z",
    fill: "#F8F8F8"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M147.372 88.6895L147.505 88.7783L148.005 89.2745L147.957 89.4152L147.372 89.1412L147.191 89.0523L147.372 88.6895Z",
    fill: "#F8F8F8"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M146.736 91.0508L146.917 91.1396H147.191V91.2767L146.917 91.3655L146.736 91.4137V91.0508Z",
    fill: "#F8F8F8"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M147.054 89.4551L147.19 89.5958L147.457 89.7291L147.372 89.8661L147.102 89.8217L146.957 89.7772L147.054 89.4551Z",
    fill: "#F8F8F8"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M146.827 90.2266H147.005L147.642 90.5043V90.5931L146.957 90.6857H146.779L146.827 90.2266Z",
    fill: "#F8F8F8"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M164.743 39.2297C165.332 38.8705 165.969 39.2297 166.146 40.0036L184.786 112.696C185.012 113.47 184.657 114.369 184.061 114.692L153.358 132.432C152.817 132.791 152.136 132.432 151.951 131.658L133.311 58.9774C133.133 58.2035 133.455 57.2926 134.037 56.9334L164.747 39.2371L164.743 39.2297ZM151.448 95.4031C153.354 94.2663 154.442 91.3224 153.813 88.8637C153.173 86.3679 151.093 85.2793 149.138 86.4161C147.191 87.501 146.103 90.4486 146.732 92.9443C147.373 95.3994 149.453 96.4843 151.448 95.3994V95.4031ZM160.479 85.831L160.072 84.4239C159.983 84.0647 159.709 83.8796 159.436 84.0647L154.901 86.6049C154.631 86.7827 154.446 87.2344 154.539 87.6047L154.942 89.0525C155.038 89.4154 155.353 89.6006 155.627 89.4154L160.12 86.7827C160.435 86.6457 160.572 86.1939 160.483 85.831H160.479Z",
    fill: "#4F5B77"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M151.448 86.3301L151.77 86.4189L151.677 86.6448L151.359 87.4187H151.274L151.407 86.5078L151.448 86.3301Z",
    fill: "#F8F8F8"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M149.638 86.3708L149.912 86.3301V86.5078V86.9188L149.823 86.9633L149.727 86.6004L149.638 86.3708Z",
    fill: "#F8F8F8"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M148.231 87.3711L148.324 87.5525L148.642 88.2783L148.553 88.3672L148.098 87.8303L147.957 87.6895L148.231 87.3711Z",
    fill: "#F8F8F8"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M146.736 91.8616L146.917 91.8209L147.554 91.7246L147.602 91.8616L146.958 92.2245L146.828 92.2726L146.736 91.8616Z",
    fill: "#F8F8F8"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M166.147 31.1591C167.779 30.2482 169.593 31.1591 170.137 33.2438L190.724 113.731C191.272 115.815 190.369 118.27 188.729 119.222L151.944 140.458C150.319 141.414 148.546 140.506 148.002 138.418L127.411 57.9275C126.867 55.8428 127.774 53.3915 129.41 52.3954L166.143 31.1628L166.147 31.1591ZM185.468 112.279L166.828 39.5944C166.513 38.4131 165.514 37.8651 164.518 38.4131L133.852 56.1094C132.856 56.65 132.353 58.1053 132.675 59.3717L151.267 132.06C151.626 133.238 152.625 133.786 153.584 133.238L184.283 115.545C185.235 114.956 185.731 113.549 185.464 112.279H185.468Z",
    fill: "#4F5B77"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M153.171 92.6859L152.631 92.4082L152.542 92.4971L153.086 93.0007L153.171 93.134L153.353 92.7267L153.171 92.6859Z",
    fill: "#F8F8F8"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M153.628 90.413V89.9539L152.995 90.0501L152.947 89.9539L153.587 89.5947C153.539 89.4503 153.539 89.3206 153.491 89.1355L153.217 89.2244L153.172 89.1355L153.443 88.9504C153.402 88.7726 153.354 88.6837 153.313 88.4986L152.721 88.9096L152.632 88.7726L153.172 88.2246C153.087 88.0913 153.039 87.958 152.995 87.8617L152.721 88.0468L152.673 87.958L152.858 87.684C152.817 87.5951 152.721 87.4581 152.632 87.3618L152.132 87.995L152.043 87.9543L152.403 87.1322C152.358 87.0433 152.221 86.9545 152.132 86.9063L151.947 87.2211L151.907 87.1322L151.995 86.7693C151.907 86.7212 151.77 86.6805 151.677 86.6323L151.362 87.4062H151.274L151.411 86.499C151.274 86.499 151.177 86.4546 151.096 86.4546L150.952 86.7693H150.907V86.4102H150.544L150.448 87.3174H150.319L150.271 86.4102C150.134 86.4546 149.997 86.499 149.908 86.499V86.9101L149.819 86.9582L149.723 86.5953C149.593 86.5953 149.449 86.6842 149.36 86.7286L149.449 87.5951L149.36 87.6358L149.093 86.8619C149.001 86.9582 148.912 87.0471 148.775 87.1359L148.864 87.4988H148.823L148.638 87.2729C148.501 87.3618 148.412 87.4544 148.324 87.5433L148.638 88.269L148.549 88.3579L148.098 87.8173C148.002 87.9543 147.913 88.0431 147.824 88.1802L148.002 88.4542L147.953 88.543L147.728 88.406C147.639 88.4949 147.55 88.6319 147.502 88.7689L148.002 89.2651L147.953 89.4021L147.372 89.1281C147.28 89.2651 147.232 89.4021 147.191 89.5873L147.457 89.7206L147.372 89.8576L147.102 89.8131C147.102 89.9464 147.054 90.1279 147.006 90.2168L147.643 90.4908V90.5797L146.958 90.6722C146.913 90.7611 146.913 90.9388 146.913 91.124H147.191V91.261L146.913 91.3499V91.809L147.55 91.7127L147.598 91.8498L146.958 92.2126C147.006 92.3052 147.006 92.483 147.054 92.6237L147.328 92.5348L147.372 92.6237L147.102 92.8495C147.143 92.9865 147.191 93.1236 147.232 93.2606L147.872 92.8495L147.913 92.9866L147.372 93.5753C147.457 93.6716 147.506 93.8049 147.55 93.9382L147.824 93.7123L147.872 93.8049L147.687 94.1196C147.728 94.2085 147.824 94.3048 147.913 94.3937L148.453 93.7568L148.501 93.8456L148.142 94.664C148.231 94.7084 148.324 94.801 148.412 94.8417L148.638 94.5714L148.683 94.6195L148.546 94.9824C148.683 95.0269 148.771 95.1194 148.908 95.1194L149.179 94.3455L149.316 94.3937L149.179 95.2564C149.267 95.3009 149.356 95.3009 149.493 95.3009L149.63 94.9824H149.678V95.3453C149.815 95.3897 149.904 95.3897 149.993 95.3897L150.13 94.4825H150.267L150.315 95.3009C150.444 95.3009 150.541 95.3009 150.63 95.2564L150.678 94.8936L150.722 94.8454L150.818 95.2083C150.948 95.1194 151.092 95.1194 151.174 95.0306L151.092 94.2085L151.174 94.1196L151.448 94.8417C151.544 94.801 151.673 94.7528 151.77 94.664L151.721 94.3011L151.77 94.2529L151.947 94.4788C152.043 94.39 152.173 94.3011 152.269 94.2011L151.907 93.479L151.995 93.3902L152.447 93.9308C152.543 93.8419 152.632 93.7049 152.721 93.5679L152.543 93.3013L152.632 93.205L152.817 93.3902C152.906 93.2532 152.995 93.1161 153.087 92.9791L152.543 92.4792L152.632 92.3904L153.172 92.6644C153.265 92.4792 153.313 92.3422 153.354 92.2052L153.128 92.0275L153.172 91.9312H153.443C153.443 91.8016 153.539 91.6646 153.539 91.4795L152.906 91.3017L152.947 91.1647L153.631 91.1166V90.6648L153.357 90.6167V90.4797L153.631 90.3908L153.628 90.413ZM150.996 93.5864C149.819 94.3159 148.549 93.6346 148.142 92.1386C147.731 90.6389 148.412 88.8689 149.597 88.1913C150.726 87.5062 151.995 88.1431 152.406 89.6872C152.817 91.1351 152.177 92.9495 151 93.5864H150.996Z",
    fill: "#4F5B77"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M152.994 87.8726L153.131 87.7319L152.994 87.5098L152.857 87.6912L152.672 87.9652L152.72 88.0541L152.994 87.8726Z",
    fill: "#F8F8F8"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M152.632 87.3722L152.769 87.2352L152.543 86.9648L152.406 87.1426L152.043 87.9646L152.132 88.0054L152.632 87.3722Z",
    fill: "#F8F8F8"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M166.83 39.5958C166.516 38.4146 165.516 37.8665 164.521 38.4146L133.854 56.1108C132.859 56.6515 132.355 58.1067 132.677 59.3731L151.27 132.062C151.629 133.239 152.628 133.787 153.587 133.239L184.286 115.546C185.237 114.958 185.733 113.551 185.467 112.28L166.827 39.5958H166.83ZM184.06 114.687L153.357 132.428C152.817 132.787 152.136 132.428 151.951 131.654L133.31 58.9732C133.133 58.1993 133.455 57.2884 134.036 56.9292L164.746 39.2329C165.335 38.8737 165.972 39.2329 166.149 40.0068L184.79 112.699C185.015 113.473 184.66 114.373 184.064 114.695L184.06 114.687Z",
    fill: "#F8F8F8"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M151.906 93.4971L152.269 94.2229L152.358 94.408L152.591 94.134L152.447 93.9488L151.995 93.4082L151.906 93.4971Z",
    fill: "#F8F8F8"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M151.447 95.404C153.353 94.2672 154.442 91.3234 153.812 88.8647C153.172 86.3689 151.092 85.2802 149.137 86.417C147.191 87.502 146.102 90.4495 146.732 92.9453C147.372 95.4003 149.452 96.4853 151.447 95.4003V95.404ZM146.917 91.3641L146.735 91.4086V91.0457L146.917 91.1345C146.917 90.9494 146.917 90.7717 146.961 90.6828H146.783L146.831 90.2236H147.009C147.057 90.1347 147.105 89.9533 147.105 89.82L146.961 89.7756L147.057 89.4534L147.194 89.5978C147.235 89.4127 147.283 89.2757 147.376 89.1387L147.194 89.0498L147.376 88.6906L147.509 88.7795C147.553 88.6425 147.646 88.5055 147.735 88.4166L147.557 88.3277L147.735 88.0093L147.831 88.1944C147.92 88.0574 148.009 87.9685 148.105 87.8315L147.96 87.6945L148.234 87.3724L148.327 87.5538C148.416 87.4649 148.505 87.3724 148.641 87.2835L148.505 87.1058L148.73 86.9206L148.778 87.1465C148.915 87.0576 149.004 86.9688 149.097 86.8725L149.004 86.6947L149.363 86.5133V86.7392C149.452 86.6947 149.596 86.6059 149.726 86.6059L149.637 86.3763L149.911 86.3355V86.5133C150 86.5133 150.137 86.4689 150.274 86.4244L150.226 86.2393L150.548 86.1985V86.4244H150.91V86.1985L151.136 86.2393L151.096 86.4726C151.177 86.4726 151.273 86.517 151.41 86.517L151.451 86.3393L151.773 86.4281L151.677 86.654C151.773 86.7021 151.906 86.7429 151.995 86.791L152.043 86.6133L152.269 86.7466L152.132 86.9317C152.221 86.9799 152.358 87.0687 152.402 87.1576L152.539 86.9799L152.765 87.2465L152.628 87.3835C152.717 87.4761 152.813 87.6168 152.854 87.7056L152.991 87.5205L153.124 87.7464L152.991 87.8834C153.035 87.9797 153.083 88.113 153.168 88.2463L153.309 88.0685L153.439 88.4314L153.309 88.5203C153.35 88.7054 153.398 88.7943 153.439 88.972L153.624 88.7943L153.664 89.1535H153.487C153.535 89.3386 153.535 89.4682 153.583 89.6126L153.761 89.5164L153.809 89.9681H153.624V90.4273L153.809 90.3791V90.6976H153.624V91.1493H153.761L153.712 91.6011L153.535 91.5122C153.535 91.6974 153.439 91.8344 153.439 91.964L153.624 92.0121L153.535 92.3306L153.35 92.238C153.309 92.375 153.261 92.5083 153.168 92.6972H153.35V92.7379L153.168 93.1489L153.083 93.0119C152.991 93.1489 152.902 93.2822 152.813 93.4229L152.991 93.5118L152.813 93.7858L152.717 93.6007C152.628 93.7377 152.539 93.8747 152.443 93.9636L152.583 94.1487L152.354 94.4227L152.265 94.2376C152.169 94.3339 152.039 94.4227 151.943 94.5153L152.039 94.6968L151.814 94.8745L151.769 94.6968C151.673 94.7856 151.543 94.8338 151.447 94.8745L151.543 95.1004L151.225 95.2855L151.177 95.0596C151.096 95.1485 150.951 95.1485 150.822 95.2374L150.91 95.4225L150.64 95.5114V95.2855C150.551 95.33 150.455 95.33 150.326 95.33L150.366 95.5966H150.004V95.4188C149.915 95.4188 149.826 95.4188 149.689 95.3744V95.6003H149.456L149.504 95.3337C149.367 95.3337 149.278 95.3337 149.189 95.2892L149.1 95.5151L148.83 95.4262L148.919 95.1522C148.782 95.1522 148.693 95.0633 148.556 95.0152V95.2411L148.282 95.0633L148.419 94.8782C148.331 94.8375 148.238 94.7412 148.149 94.7005L148.06 94.8782L147.835 94.6079L147.923 94.4301C147.835 94.3413 147.738 94.245 147.698 94.1561L147.561 94.3413L147.424 94.0673L147.561 93.971C147.516 93.8377 147.464 93.7044 147.383 93.6081L147.242 93.7932L147.113 93.3822L147.242 93.2933C147.202 93.1563 147.154 93.023 147.113 92.8823L146.968 93.0193L146.883 92.7046L147.061 92.6564C147.013 92.5194 147.013 92.3417 146.965 92.2454L146.835 92.2936L146.739 91.8825L146.92 91.8418V91.3826L146.917 91.3641Z",
    fill: "#F8F8F8"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M153.813 90.6874V90.3652L153.628 90.4134L153.354 90.5059V90.6392L153.628 90.6874H153.813Z",
    fill: "#F8F8F8"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M153.313 88.0527L153.446 88.4156L153.313 88.5045L152.721 88.9155L152.632 88.7785L153.172 88.2342L153.313 88.0527Z",
    fill: "#F8F8F8"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M265.368 60.4727L259.883 59.3359C259.883 59.3359 253.19 62.913 252.543 62.9315C251.895 62.9426 254.197 61.2615 253.953 61.0652C253.683 60.8504 252.968 60.6838 252.35 60.8134C251.747 60.9578 244.907 64.4386 243.922 64.794C245.536 65.7642 247.39 67.7045 246.898 71.4149C249.752 70.4373 259.087 67.8082 260.286 66.9528C261.474 66.1123 265.86 63.3166 266.323 62.5353C266.782 61.7428 265.368 60.4653 265.368 60.4653V60.4727Z",
    fill: "#E8B188"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M212.19 211.534C215.514 216.529 225.464 222.273 226.171 223.002C226.548 223.417 226.918 223.798 227.177 224.12C227.466 224.435 227.647 224.705 227.647 224.817C227.647 225.083 225.741 228.671 225.086 228.712C224.412 228.768 216.032 227.616 214.596 227.312C213.164 227.023 208.263 223.539 208.263 223.539C208.263 223.539 202.911 222.521 200.638 221.836C198.34 221.143 195.812 218.118 195.812 218.118C195.812 218.118 196.104 215.611 196.293 213.549C195.912 213.145 195.689 212.697 195.63 212.204C195.597 211.845 195.541 211.131 195.497 210.164C194.131 210.29 192.799 210.445 191.477 210.657L190.559 225.416C190.356 225.942 190.123 226.424 189.819 226.849L192.987 240.087L193.102 240.58C193.102 240.58 193.491 245.19 193.247 245.371C192.999 245.549 188.679 247.519 187.75 247.453C186.821 247.408 178.737 244.609 177.63 243.801C176.76 243.176 176.938 233.163 177.064 228.842C176.113 228.312 175.483 227.657 175.361 226.857C175.195 225.705 175.062 221.473 174.947 215.992C174.273 216.341 173.625 216.7 173.011 217.092C158.59 226.039 159.075 239.847 174.088 247.941C189.075 256.028 212.92 255.332 227.325 246.375C241.735 237.414 241.239 223.62 226.252 215.511C222.136 213.315 217.35 211.771 212.283 210.875V211.368C212.25 211.438 212.227 211.482 212.194 211.527L212.19 211.534Z",
    fill: "#B3B3B3"
  }))), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M187.572 228.825C186.529 229.396 185.329 229.755 184.089 229.921C183.094 230.07 182.061 230.07 181.076 229.992C181.236 233.106 181.65 239.579 182.061 240.808C182.546 242.297 185.266 244.615 187.546 245.055C189.834 245.503 191.736 243.352 192.036 243.285C192.262 243.252 192.717 241.278 192.988 240.093L189.819 226.855C189.227 227.692 188.464 228.333 187.569 228.825H187.572Z",
    fill: "#333333"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M217.079 223.035C218.442 223.66 222.765 224.805 223.705 225.119C224.408 225.353 226.311 224.527 227.177 224.123C226.918 223.797 226.548 223.416 226.17 223.005C225.467 222.276 215.514 216.532 212.19 211.537C211.339 213.152 209.936 214.225 208.292 214.918C207.215 215.37 206.02 215.636 204.835 215.747C206.268 216.062 207.726 216.251 208.385 216.466C210.006 217.003 215.717 222.398 217.083 223.038L217.079 223.035Z",
    fill: "#333333"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M187.55 245.052C185.27 244.611 182.55 242.293 182.065 240.804C181.65 239.575 181.239 233.102 181.08 229.988C179.537 229.844 178.115 229.44 177.064 228.848C176.942 233.169 176.761 243.182 177.631 243.807C178.741 244.615 186.821 247.414 187.75 247.459C188.679 247.525 193.003 245.552 193.247 245.377C193.491 245.196 193.102 240.586 193.102 240.586L192.988 240.093C192.718 241.278 192.262 243.252 192.036 243.285C191.737 243.352 189.834 245.503 187.547 245.055L187.55 245.052Z",
    fill: "#1A1A1A"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M200.639 221.834C202.908 222.519 208.264 223.537 208.264 223.537C208.264 223.537 213.165 227.022 214.597 227.311C216.033 227.614 224.413 228.77 225.087 228.71C225.746 228.666 227.648 225.081 227.648 224.815C227.648 224.704 227.467 224.433 227.178 224.119C226.316 224.522 224.413 225.352 223.706 225.115C222.766 224.8 218.443 223.656 217.081 223.03C215.715 222.393 210.004 216.994 208.383 216.457C207.724 216.243 206.265 216.054 204.833 215.739C201.339 216.087 197.737 215.135 196.29 213.547C196.098 215.606 195.809 218.116 195.809 218.116C195.809 218.116 198.337 221.142 200.635 221.834H200.639Z",
    fill: "#1A1A1A"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M175.358 226.863C175.48 227.66 176.109 228.319 177.06 228.848C178.112 229.444 179.533 229.844 181.076 229.989C182.061 230.067 183.094 230.067 184.089 229.918C182.287 229.685 180.81 228.193 180.162 226.193C180.036 225.845 179.948 225.497 179.892 225.127C179.278 221.365 178.704 191.486 180.954 182.158C183.208 172.83 182.827 171.16 182.668 166.28C182.579 163.21 181.684 153.12 181.036 146.088C179.803 146.48 177.253 147.228 175.158 147.632C175.754 157.019 176.379 166.972 176.535 169.246C176.824 173.767 176.287 175.056 175.38 181.484C174.754 185.898 174.721 203.939 174.943 215.999C175.054 221.476 175.188 225.708 175.358 226.863Z",
    fill: "#171D2D"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M194.131 133.391C185.455 134.957 179.917 133.199 176.905 131.554C177.027 133.169 177.027 134.309 176.816 134.713C177.959 133.658 178.152 132.628 178.152 132.628L182.608 136.994C182.608 136.994 182.427 138.494 182.179 139.753C188.627 142.326 195.049 140.671 195.049 140.671C196.459 148.318 194.634 164.322 194.179 168.062C194.29 172.531 195.049 201.614 195.5 210.168C195.545 211.134 195.6 211.849 195.634 212.208C195.689 212.7 195.911 213.148 196.296 213.552C197.74 215.141 201.341 216.096 204.839 215.744C206.027 215.633 207.219 215.366 208.296 214.915C204.869 213.211 202.218 213.211 200.853 211.212C200.383 210.527 200.057 209.631 199.901 208.39C199.242 203.336 199.957 175.723 201.682 165.71C203.407 155.731 205.22 137.335 206.371 136.124C207.345 135.069 212.205 132.191 214.981 128.507C215.229 124.474 215.384 121.875 215.384 121.875C215.384 121.875 215.273 121.986 215.103 122.212C213.704 123.845 206.808 131.125 194.135 133.387L194.131 133.391Z",
    fill: "#171D2D"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M198.163 46.192C199.665 42.6853 200.069 39.3749 200.069 39.3749C200.728 39.4712 201.298 39.4823 201.816 39.4712C205.754 39.3268 205.847 36.6385 206.117 35.5831C206.161 35.398 206.272 34.7944 206.372 33.902C206.964 29.44 208.086 17.5906 206.617 12.4473C201.997 15.8466 191.071 16.2428 191.071 16.2428C191.126 18.346 189.235 19.4199 189.268 21.0047C189.324 22.6081 189.831 27.1886 189.483 27.6959C189.105 28.2217 188.128 27.6589 187.913 27.4885C187.691 27.333 187.399 23.1709 185.911 22.46C184.423 21.7453 184.423 24.878 184.911 27.607C185.426 30.3509 185 31.2803 185 31.2803C185.333 33.2355 185.315 35.1277 185.2 36.5459C185.085 37.9234 184.908 38.8306 184.908 38.8306C184.863 42.952 198.163 46.1957 198.163 46.1957V46.192Z",
    fill: "#E8B188"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M184.907 27.6046C184.414 24.8792 184.414 21.7429 185.906 22.4575C187.394 23.1685 187.687 27.3306 187.909 27.4861C188.123 27.6527 189.097 28.2193 189.478 27.6935C189.826 27.1862 189.323 22.6056 189.263 21.0023C189.23 19.4174 191.125 18.3436 191.066 16.2403C191.066 16.2403 201.992 15.8441 206.612 12.4448C207.6 11.7302 208.303 10.86 208.551 9.83426C205.698 10.4304 206.164 3.31341 196.011 1.11017C185.825 -1.09677 180.328 5.77956 180.891 8.20497C180.891 8.20497 178.352 10.2897 178.414 15.3442C178.463 20.395 181.346 26.5567 184.996 31.2742C184.996 31.2742 185.418 30.3448 184.907 27.6009V27.6046Z",
    fill: "#311B0B"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M209.055 125.637L209.066 124.645L208.977 124.7L209.055 125.637Z",
    fill: "#171D2D"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M207.587 76.0279L207.498 75.9316C207.161 75.9465 206.839 75.9576 206.517 75.9687L206.839 76.3093L207.587 76.0242V76.0279Z",
    fill: "#292E3F"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M159.923 60.6074C160.441 59.7187 160.908 59.0596 161.13 58.6152C160.56 59.4003 160.145 60.0705 159.923 60.6074Z",
    fill: "#171D2D"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M181.772 145.861C181.772 145.861 181.413 142.077 181.816 141.069C181.949 140.766 182.06 140.262 182.175 139.747C182.423 138.492 182.604 136.989 182.604 136.989L178.148 132.623C178.148 132.623 177.959 133.652 176.812 134.708C176.712 134.797 176.601 134.886 176.49 135L176.456 135.011C175.842 135.493 175.013 135.948 173.913 136.311C173.869 136.311 173.847 136.322 173.802 136.333C173.532 136.415 173.232 136.5 172.918 136.567C172.885 136.567 172.836 136.567 172.792 136.593C172.481 136.656 172.141 136.704 171.774 136.748H171.737C171.382 136.793 171 136.837 170.597 136.848C170.527 136.859 170.464 136.859 170.371 136.87C169.99 136.87 169.564 136.881 169.139 136.87H168.891C168.443 136.848 167.962 136.837 167.458 136.781C167.458 136.781 167.48 136.859 167.525 136.992C167.962 138.429 170.749 147.05 172.115 147.768C172.585 148.012 173.769 147.901 175.15 147.631C177.245 147.227 179.795 146.479 181.028 146.087C181.487 145.954 181.764 145.861 181.764 145.861H181.772Z",
    fill: "#E8B188"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M207.497 75.9327L207.586 76.029L208.17 76.7066C208.17 76.7066 208.215 76.366 208.292 75.7624C208.574 73.2407 208.011 63.3391 207.03 57.7069C206.612 55.6851 206.146 53.7115 205.664 51.8156C205.664 51.786 205.642 51.7785 205.642 51.7637C205.483 51.1416 205.317 50.5418 205.161 49.9382C205.161 49.8826 205.128 49.8197 205.128 49.7642C204.78 48.5496 204.454 47.3795 204.121 46.276C204.102 46.2205 204.088 46.1575 204.077 46.1094C203.74 45.0281 203.429 44.0468 203.136 43.1285C203.103 43.0656 203.07 42.9693 203.048 42.9175C202.755 42.0436 202.489 41.2659 202.255 40.592C202.222 40.5142 202.189 40.4365 202.152 40.3476C202.041 40.044 201.93 39.7329 201.819 39.47C201.301 39.4811 200.731 39.47 200.072 39.3738C200.072 39.3738 199.668 42.6842 198.165 46.1908C198.165 46.1908 184.866 42.9508 184.911 38.8257C184.911 38.8257 185.088 37.9185 185.203 36.541C181.409 37.0779 178.052 42.9693 178.052 42.9693L189.771 55.1852L207.504 75.9327H207.497Z",
    fill: "#F3FEFF"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M206.368 136.123C205.216 137.334 203.403 155.73 201.678 165.709C199.953 175.722 199.235 203.335 199.897 208.389C200.053 209.633 200.379 210.526 200.849 211.211C202.215 213.214 204.865 213.214 208.292 214.914C209.939 214.221 211.339 213.147 212.19 211.533C212.219 211.488 212.245 211.444 212.279 211.374V210.881C212.293 206.875 212.382 179.747 212.516 173.826C212.638 168.957 214.24 141.374 214.977 128.506C212.201 132.19 207.345 135.067 206.368 136.123Z",
    fill: "#292E3F"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M182.177 139.754C182.062 140.269 181.955 140.772 181.818 141.076C181.414 142.083 181.773 145.867 181.773 145.867C181.773 145.867 181.496 145.956 181.037 146.093C181.684 153.125 182.58 163.216 182.669 166.285C182.828 171.166 183.209 172.836 180.955 182.163C178.709 191.491 179.279 221.37 179.893 225.132C179.949 225.503 180.037 225.851 180.163 226.199C180.811 228.202 182.288 229.691 184.09 229.924C185.33 229.757 186.53 229.398 187.573 228.828C188.469 228.335 189.232 227.695 189.824 226.858C190.127 226.432 190.361 225.951 190.564 225.425L191.482 210.665L194.162 167.463C194.162 167.463 194.162 167.685 194.184 168.066C194.639 164.327 196.464 148.322 195.054 140.676C195.054 140.676 188.632 142.331 182.184 139.758L182.177 139.754Z",
    fill: "#292E3F"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M178.751 112.852C181.393 106.113 181.937 100.758 182.06 98.47C181.434 97.7776 177.955 90.5421 174.079 82.292C173.543 81.1144 172.969 79.9258 172.41 78.7408C172.399 78.6964 172.362 78.6409 172.34 78.6038C171.803 77.4189 171.244 76.2229 170.707 75.0527C170.371 76.2747 170.06 77.53 169.745 78.8297C168.883 82.6585 168.224 86.7355 167.709 90.431C167.058 96.7926 166.61 101.877 166.566 102.18C166.477 102.999 173.606 88.8165 173.606 88.8165L178.406 96.8556L175.923 110.497L172.854 119.521L175.138 130.652L176.704 129.712C176.411 127.183 175.912 124.009 175.342 120.673C176.415 118.188 177.622 115.378 178.747 112.845L178.751 112.852Z",
    fill: "#171D2D"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M176.712 129.717L176.849 129.617C176.646 122.652 187.302 106.448 186.628 98.0239C185.992 89.5813 173.599 64.8087 171.786 64.3792C170.646 64.0866 168.876 79.2353 167.722 90.4218C166.893 96.4798 166.511 101.545 166.478 102.997C166.356 106.244 176.072 135.294 176.072 135.294C176.205 135.205 176.331 135.105 176.453 135.016L176.487 135.005C176.598 134.89 176.709 134.801 176.809 134.713C177.02 134.309 177.02 133.168 176.897 131.554C176.846 130.991 176.775 130.365 176.705 129.717H176.712ZM168.092 87.8557C168.118 87.6965 168.136 87.5076 168.162 87.3188C168.14 87.5076 168.118 87.7002 168.092 87.8557ZM173.455 110.577C172.404 105.282 171.541 101.223 171.541 101.223L172.404 96.5428C173.444 99.4311 174.118 101.627 174.229 102.59C174.384 104.182 174.007 107.226 173.455 110.573V110.577ZM176.601 128.773C176.59 128.751 176.59 128.706 176.59 128.673C176.59 128.706 176.59 128.755 176.601 128.773ZM175.987 124.633C175.987 124.474 175.954 124.318 175.92 124.163C175.954 124.318 175.987 124.478 175.987 124.633Z",
    fill: "#171D2D"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M209.133 46.4636C208.619 42.6829 218.875 71.3435 219.738 73.0321C220.597 74.7021 221.718 73.98 224.705 73.4727C227.526 72.9839 244.208 68.5774 246.636 68.0516C246.073 66.4409 244.956 65.4263 243.927 64.8005C242.827 64.145 241.865 63.9303 241.865 63.9303L227.607 67.2333C227.607 67.2333 212.317 36.8841 209.474 34.9549C209.474 34.9549 209.385 33.8662 206.372 33.9033C206.272 34.7957 206.161 35.3993 206.117 35.5844C205.846 36.6397 205.758 39.3281 201.816 39.4725C201.927 39.7354 202.038 40.0501 202.149 40.3501C202.186 40.4389 202.219 40.5204 202.252 40.5945C202.486 41.2684 202.752 42.0423 203.044 42.9199C203.067 42.9717 203.1 43.068 203.133 43.131C203.426 44.0493 203.737 45.0306 204.073 46.1118C204.085 46.1636 204.096 46.2266 204.118 46.2784C204.455 47.3819 204.78 48.552 205.125 49.7666C205.125 49.8221 205.158 49.8851 205.158 49.9406C205.317 50.5442 205.484 51.1441 205.639 51.7662C205.639 51.781 205.661 51.7884 205.661 51.818C206.146 53.7102 206.613 55.6876 207.027 57.7094C208.012 63.3415 208.571 73.2468 208.289 75.7648C208.212 76.3684 208.167 76.7091 208.167 76.7091L207.582 76.0314L206.835 76.3166L206.513 75.9759C206.835 75.9648 207.16 75.9537 207.494 75.9389L189.76 55.1914L178.041 42.9754C173.752 45.0343 166.434 52.018 162.459 56.8725C161.977 57.4872 161.504 58.0834 161.126 58.6092C160.9 59.0683 160.434 59.7238 159.919 60.6125C159.135 61.9677 158.239 63.8933 157.858 66.6075C155.989 79.9269 155.618 103.848 155.778 105.418C156.022 107.525 166.101 136.126 166.612 136.752C166.704 136.863 167.037 136.945 167.529 136.996C167.485 136.863 167.463 136.785 167.463 136.785C167.966 136.841 168.451 136.852 168.895 136.874H169.143C169.569 136.885 169.995 136.874 170.376 136.874C170.465 136.863 170.531 136.863 170.602 136.852C171.005 136.841 171.386 136.793 171.742 136.752H171.779C172.145 136.708 172.482 136.663 172.797 136.596C172.841 136.571 172.885 136.571 172.922 136.571C173.237 136.504 173.537 136.415 173.807 136.337C173.851 136.326 173.874 136.315 173.918 136.315C174.814 136.034 175.521 135.674 176.076 135.293C176.076 135.293 166.36 106.24 166.482 102.996C166.515 101.541 166.897 96.479 167.715 90.4284C168.877 79.2308 170.646 64.0821 171.79 64.3746C173.603 64.8042 185.996 89.5767 186.632 98.0194C187.306 106.44 176.65 122.648 176.853 129.613L176.716 129.713C176.783 130.383 176.853 131.012 176.909 131.549C179.922 133.193 185.463 134.952 194.135 133.386C200.853 132.186 205.924 129.587 209.437 127.158C213.212 115.96 211.332 82.2746 211.891 79.4085C212.468 76.5647 209.626 50.2554 209.133 46.4636Z",
    fill: "#292E3F"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M215.099 122.213L215.38 121.876C215.38 121.876 216.565 120.488 217.238 119.425C217.386 116.951 216.85 96.9851 215.832 86.4466C216.927 85.9652 218.293 88.2832 219.703 87.5686C229.823 82.2586 246.639 72.8272 246.639 72.8272C246.75 72.3273 246.85 71.8719 246.905 71.4201C247.086 70.0834 246.949 68.9688 246.639 68.0505C244.21 68.5763 227.528 72.9864 224.708 73.4715C221.721 73.9825 220.599 74.7009 219.74 73.0309C218.878 71.3424 208.625 42.6817 209.136 46.4624C209.628 50.2542 212.471 76.5635 211.893 79.4073C211.331 82.2734 213.215 115.963 209.439 127.157C212.541 124.987 214.444 122.969 215.103 122.209L215.099 122.213Z",
    fill: "#171D2D"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M178.149 46.8281C179.637 49.8645 196.127 74.5445 196.438 74.8444C196.749 75.1296 201.801 73.3522 201.923 73.5855C202.06 73.8187 199.347 76.5256 199.347 76.9662C199.369 77.4365 208.134 83.2612 208.134 83.2612L196.031 77.9068C196.031 77.9068 177.624 50.0275 178.142 46.8281H178.149Z",
    fill: "#171D2D"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29 70.3544C210.798 71.1283 209.691 71.2986 209.625 71.7689C209.558 72.2577 212.153 72.0614 212.378 73.0945C212.604 74.1202 213.803 69.5879 212.29 70.3507V70.3544Z",
    fill: "#171D2D"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M198.99 48.0389C198.99 48.0389 195.278 52.0528 195.363 52.9045C195.448 53.7451 198.587 53.1193 198.472 53.8487C198.383 54.5856 201.104 68.4531 201.104 68.4531L208.514 77.5289C208.514 77.5289 208.414 66.3794 208.137 64.7502C207.822 63.1135 203.099 52.6675 202.525 52.6934C201.922 52.7045 203.621 50.4458 202.995 49.8422C202.37 49.2275 198.987 48.0352 198.987 48.0352L198.99 48.0389Z",
    fill: "#F15A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityleft);
export default __webpack_public_path__ + "static/media/equityleft.1ac389e39d969dcd7a31d40e97e1523c.svg";
export { ForwardRef as ReactComponent };